(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './curity-ssi-libs-sd-jwt.js', './curity-ssi-libs-core-json.js', './kotlinx-serialization-kotlinx-serialization-json.js', './Kotlin-DateTime-library-kotlinx-datetime.js', './curity-ssi-libs-jose.js', './curity-ssi-libs-core.js', './curity-ssi-libs-verifiable-credentials.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./curity-ssi-libs-sd-jwt.js'), require('./curity-ssi-libs-core-json.js'), require('./kotlinx-serialization-kotlinx-serialization-json.js'), require('./Kotlin-DateTime-library-kotlinx-datetime.js'), require('./curity-ssi-libs-jose.js'), require('./curity-ssi-libs-core.js'), require('./curity-ssi-libs-verifiable-credentials.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials-vc-ks-data'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'curity-ssi-libs-verifiable-credentials-vc-ks-data'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials-vc-ks-data'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-verifiable-credentials-vc-ks-data'.");
    }
    if (typeof this['curity-ssi-libs-sd-jwt'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials-vc-ks-data'. Its dependency 'curity-ssi-libs-sd-jwt' was not found. Please, check whether 'curity-ssi-libs-sd-jwt' is loaded prior to 'curity-ssi-libs-verifiable-credentials-vc-ks-data'.");
    }
    if (typeof this['curity-ssi-libs-core-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials-vc-ks-data'. Its dependency 'curity-ssi-libs-core-json' was not found. Please, check whether 'curity-ssi-libs-core-json' is loaded prior to 'curity-ssi-libs-verifiable-credentials-vc-ks-data'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials-vc-ks-data'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json' is loaded prior to 'curity-ssi-libs-verifiable-credentials-vc-ks-data'.");
    }
    if (typeof this['Kotlin-DateTime-library-kotlinx-datetime'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials-vc-ks-data'. Its dependency 'Kotlin-DateTime-library-kotlinx-datetime' was not found. Please, check whether 'Kotlin-DateTime-library-kotlinx-datetime' is loaded prior to 'curity-ssi-libs-verifiable-credentials-vc-ks-data'.");
    }
    if (typeof this['curity-ssi-libs-jose'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials-vc-ks-data'. Its dependency 'curity-ssi-libs-jose' was not found. Please, check whether 'curity-ssi-libs-jose' is loaded prior to 'curity-ssi-libs-verifiable-credentials-vc-ks-data'.");
    }
    if (typeof this['curity-ssi-libs-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials-vc-ks-data'. Its dependency 'curity-ssi-libs-core' was not found. Please, check whether 'curity-ssi-libs-core' is loaded prior to 'curity-ssi-libs-verifiable-credentials-vc-ks-data'.");
    }
    if (typeof this['curity-ssi-libs-verifiable-credentials'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-verifiable-credentials-vc-ks-data'. Its dependency 'curity-ssi-libs-verifiable-credentials' was not found. Please, check whether 'curity-ssi-libs-verifiable-credentials' is loaded prior to 'curity-ssi-libs-verifiable-credentials-vc-ks-data'.");
    }
    root['curity-ssi-libs-verifiable-credentials-vc-ks-data'] = factory(typeof this['curity-ssi-libs-verifiable-credentials-vc-ks-data'] === 'undefined' ? {} : this['curity-ssi-libs-verifiable-credentials-vc-ks-data'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['curity-ssi-libs-sd-jwt'], this['curity-ssi-libs-core-json'], this['kotlinx-serialization-kotlinx-serialization-json'], this['Kotlin-DateTime-library-kotlinx-datetime'], this['curity-ssi-libs-jose'], this['curity-ssi-libs-core'], this['curity-ssi-libs-verifiable-credentials']);
  }
}(globalThis, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_curity_ssi_sd_jwt, kotlin_io_curity_ssi_core_json, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_org_jetbrains_kotlinx_kotlinx_datetime, kotlin_io_curity_ssi_jose, kotlin_io_curity_ssi_core, kotlin_io_curity_ssi_verifiable_credentials) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.p;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q1;
  var LinkedHashMapSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var protoOf = kotlin_kotlin.$_$.kb;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var $serializer_getInstance = kotlin_io_curity_ssi_sd_jwt.$_$.d;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t1;
  var initMetadataForObject = kotlin_kotlin.$_$.oa;
  var VOID = kotlin_kotlin.$_$.f;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var objectCreate = kotlin_kotlin.$_$.jb;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var toString = kotlin_kotlin.$_$.ob;
  var toString_0 = kotlin_kotlin.$_$.vf;
  var hashCode = kotlin_kotlin.$_$.ha;
  var getStringHashCode = kotlin_kotlin.$_$.ga;
  var equals = kotlin_kotlin.$_$.ba;
  var IntSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.n;
  var Long = kotlin_kotlin.$_$.ne;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var getKClass = kotlin_kotlin.$_$.e;
  var PolymorphicSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.a;
  var SealedClassSerializer_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var initMetadataForInterface = kotlin_kotlin.$_$.ma;
  var LinkedHashSetSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.w1;
  var ToJsonDictionarySerializer_getInstance = kotlin_io_curity_ssi_core_json.$_$.i;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var ToJson = kotlin_io_curity_ssi_core_json.$_$.u;
  var InstantIso8601Serializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_datetime.$_$.a;
  var Default_getInstance_0 = kotlin_kotlin.$_$.x4;
  var encodeBase64url = kotlin_io_curity_ssi_jose.$_$.o;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.m2;
  var arrayOf = kotlin_kotlin.$_$.hf;
  var createKType = kotlin_kotlin.$_$.b;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.t2;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var isInterface = kotlin_kotlin.$_$.xa;
  var IllegalArgumentException = kotlin_kotlin.$_$.le;
  var Companion_instance = kotlin_io_curity_ssi_core_json.$_$.e;
  var asSequence = kotlin_kotlin.$_$.y5;
  var map = kotlin_kotlin.$_$.ec;
  var toList = kotlin_kotlin.$_$.fc;
  var JsonArray = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.f;
  var KtMap = kotlin_kotlin.$_$.r5;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.y4;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.a;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.t1;
  var get_jsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.s;
  var MapDictionary = kotlin_io_curity_ssi_core.$_$.g;
  var DictionaryCredential = kotlin_io_curity_ssi_verifiable_credentials.$_$.b;
  var DefaultJsonMultiValue_init_$Create$ = kotlin_io_curity_ssi_core_json.$_$.b;
  var JsonObject = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.i;
  var get_jsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.t;
  var StringCredential = kotlin_io_curity_ssi_verifiable_credentials.$_$.c;
  var JsonPrimitive = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.m;
  var DefaultJsonMultiValue_init_$Create$_0 = kotlin_io_curity_ssi_core_json.$_$.a;
  var BooleanSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.m;
  var getBooleanHashCode = kotlin_kotlin.$_$.ea;
  var FromJsonHelper_instance = kotlin_io_curity_ssi_core_json.$_$.g;
  var toMutableMap = kotlin_kotlin.$_$.p8;
  var unwrapString = kotlin_io_curity_ssi_core_json.$_$.p1;
  var unwrapOptionalString = kotlin_io_curity_ssi_core_json.$_$.m1;
  var toMap = kotlin_kotlin.$_$.m8;
  var JsonDictionary = kotlin_io_curity_ssi_core_json.$_$.o;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
  var toJson = kotlin_io_curity_ssi_core_json.$_$.c1;
  var emptyMap = kotlin_kotlin.$_$.s6;
  var lazy = kotlin_kotlin.$_$.qf;
  var get_keys = kotlin_io_curity_ssi_core_json.$_$.r;
  var get = kotlin_io_curity_ssi_core_json.$_$.q;
  var toJson_0 = kotlin_io_curity_ssi_core_json.$_$.s;
  var toMap_0 = kotlin_io_curity_ssi_core.$_$.d;
  var ToJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.t;
  var Dictionary = kotlin_io_curity_ssi_core.$_$.e;
  var unwrapOptionalStringList = kotlin_io_curity_ssi_core_json.$_$.l1;
  var toJson_1 = kotlin_io_curity_ssi_core_json.$_$.y;
  var toJsons = kotlin_io_curity_ssi_core_json.$_$.x;
  var KProperty1 = kotlin_kotlin.$_$.ac;
  var getPropertyCallableRef = kotlin_kotlin.$_$.fa;
  var CompositeFromJson = kotlin_io_curity_ssi_core_json.$_$.k;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var first = kotlin_kotlin.$_$.y6;
  var JsonPrimitive_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.j;
  var to = kotlin_kotlin.$_$.wf;
  var mapOf = kotlin_kotlin.$_$.r7;
  var mapOf_0 = kotlin_kotlin.$_$.q7;
  var TypedDictionaryFromJson = kotlin_io_curity_ssi_core_json.$_$.v;
  var DelegateSerializer = kotlin_io_curity_ssi_core_json.$_$.m;
  var JsonSerializer = kotlin_io_curity_ssi_core_json.$_$.p;
  var JsonContentPolymorphicSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.g;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.w4;
  var serializer_0 = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u;
  var DerivedSerializer = kotlin_io_curity_ssi_core_json.$_$.n;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.a6;
  var mapCapacity = kotlin_kotlin.$_$.p7;
  var coerceAtLeast = kotlin_kotlin.$_$.rb;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.v;
  var unwrapOptionalBoolean = kotlin_io_curity_ssi_core_json.$_$.g1;
  var toJson_2 = kotlin_io_curity_ssi_core_json.$_$.d1;
  var unwrapStringSet = kotlin_io_curity_ssi_core_json.$_$.o1;
  var unwrapOptionalJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.h1;
  var toJson_3 = kotlin_io_curity_ssi_core_json.$_$.z;
  var Companion_instance_0 = kotlin_io_curity_ssi_core_json.$_$.h;
  var getStringOrDefault = kotlin_io_curity_ssi_core_json.$_$.w;
  var unwrapStringList = kotlin_io_curity_ssi_core_json.$_$.n1;
  var unwrapMultiValueJsonDictionary = kotlin_io_curity_ssi_core_json.$_$.f1;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
  var toJson_4 = kotlin_io_curity_ssi_core_json.$_$.b1;
  var IssuerObject = kotlin_io_curity_ssi_verifiable_credentials.$_$.d;
  var IssuerURI = kotlin_io_curity_ssi_verifiable_credentials.$_$.e;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.rf;
  var ensureNotNull = kotlin_kotlin.$_$.kf;
  var defineProp = kotlin_kotlin.$_$.aa;
  var copyToArray = kotlin_kotlin.$_$.o6;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.n;
  var isBlank = kotlin_kotlin.$_$.uc;
  var toSet = kotlin_kotlin.$_$.r8;
  var toList_0 = kotlin_kotlin.$_$.k8;
  var JsonToJsConverter_instance = kotlin_io_curity_ssi_core_json.$_$.d;
  var contains = kotlin_kotlin.$_$.b6;
  var firstOrNull = kotlin_kotlin.$_$.v6;
  var Primitive = kotlin_io_curity_ssi_sd_jwt.$_$.i;
  var Locale = kotlin_io_curity_ssi_core.$_$.f;
  var Array_0 = kotlin_io_curity_ssi_sd_jwt.$_$.g;
  var Object_0 = kotlin_io_curity_ssi_sd_jwt.$_$.h;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForInterface(ValidatedCredentialResponse, 'ValidatedCredentialResponse', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_5});
  initMetadataForInterface(ValidatedVcSdJwtCredentialResponse, 'ValidatedVcSdJwtCredentialResponse', VOID, VOID, [ValidatedCredentialResponse]);
  initMetadataForClass(DefaultValidatedVcSdJwtCredentialResponse, 'DefaultValidatedVcSdJwtCredentialResponse', VOID, VOID, [ValidatedVcSdJwtCredentialResponse], VOID, VOID, {0: $serializer_getInstance_0});
  initMetadataForCompanion(Companion_0);
  initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForInterface(ValidatedJwtVcJsonCredentialResponse, 'ValidatedJwtVcJsonCredentialResponse', VOID, VOID, [ValidatedCredentialResponse], VOID, VOID, {0: Companion_getInstance_6});
  initMetadataForClass(DidValidatedJwtVcJsonCredentialResponse, 'DidValidatedJwtVcJsonCredentialResponse', VOID, VOID, [ValidatedJwtVcJsonCredentialResponse], VOID, VOID, {0: $serializer_getInstance_1});
  initMetadataForCompanion(Companion_1);
  initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForCompanion(Companion_2);
  initMetadataForObject($serializer_2, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonTxCode, 'JsonTxCode', JsonTxCode, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_3});
  initMetadataForObject($serializer_3, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonAuthorizationCode, 'JsonAuthorizationCode', JsonAuthorizationCode, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
  initMetadataForClass(JsonPreAuthorizedCode, 'JsonPreAuthorizedCode', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
  initMetadataForCompanion(Companion_3);
  initMetadataForObject($serializer_4, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonGrants, 'JsonGrants', JsonGrants, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_5});
  initMetadataForCompanion(Companion_4);
  initMetadataForObject($serializer_5, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonOffer, 'JsonOffer', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_6});
  initMetadataForCompanion(Companion_5, VOID, [SerializerFactory]);
  initMetadataForInterface(ValidatedLdpVcCredentialResponse, 'ValidatedLdpVcCredentialResponse', VOID, VOID, [ValidatedCredentialResponse]);
  initMetadataForInterface(ValidatedJwtVcJsonLdCredentialResponse, 'ValidatedJwtVcJsonLdCredentialResponse', VOID, VOID, [ValidatedCredentialResponse]);
  initMetadataForCompanion(Companion_6, VOID, [SerializerFactory]);
  initMetadataForCompanion(Companion_7);
  initMetadataForObject($serializer_6, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonCredentialDefinition, 'JsonCredentialDefinition', VOID, VOID, [ToJson], VOID, VOID, {0: $serializer_getInstance_7});
  initMetadataForCompanion(Companion_8);
  initMetadataForObject($serializer_7, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonCredentialIssuer, 'JsonCredentialIssuer', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
  initMetadataForCompanion(Companion_9);
  initMetadataForObject($serializer_8, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(UserVerifiableCredential, 'UserVerifiableCredential', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
  initMetadataForCompanion(Companion_10);
  initMetadataForObject($serializer_9, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonCredentialIssuerMetadata, 'JsonCredentialIssuerMetadata', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
  initMetadataForInterface(JsonCredentialConfigurationsSupported, 'JsonCredentialConfigurationsSupported', VOID, VOID, VOID, VOID, VOID, {0: JsonSupportedCredentialSerializer_getInstance});
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(JsonIssuerDisplay, 'JsonIssuerDisplay', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JsonIssuerDisplaySerializer_getInstance});
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(JsonDisplayable, 'JsonDisplayable', JsonDisplayable, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JsonDisplayableSerializer_getInstance});
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(JsonLogo, 'JsonLogo', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JsonLogoSerializer_getInstance});
  initMetadataForCompanion(Companion_14);
  initMetadataForClass(JsonCredentialDisplay, 'JsonCredentialDisplay', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JsonCredentialDisplaySerializer_getInstance});
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(DefaultJsonCredentialConfigurationsSupported, 'DefaultJsonCredentialConfigurationsSupported', VOID, VOID, [JsonCredentialConfigurationsSupported, ToJsonDictionary], VOID, VOID, {0: DefaultJsonSupportedCredentialSerializer_getInstance});
  initMetadataForCompanion(Companion_16);
  initMetadataForObject($serializer_10, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(DefaultCredentialResponseEncryption, 'DefaultCredentialResponseEncryption', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(JsonImage, 'JsonImage', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JsonImageSerializer_getInstance});
  initMetadataForCompanion(Companion_18);
  initMetadataForObject($serializer_11, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonProofTypesSupported, 'JsonProofTypesSupported', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
  initMetadataForCompanion(Companion_19);
  initMetadataForObject($serializer_12, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonOAuthMetadata, 'JsonOAuthMetadata', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
  initMetadataForCompanion(Companion_20, CompositeFromJson);
  initMetadataForClass(JwtProofOfPossession, 'JwtProofOfPossession', VOID, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: JwtProofOfPossessionSerializer_getInstance});
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(JsonProofOfPossession, 'JsonProofOfPossession', VOID, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: JsonProofOfPossessionSerializer_getInstance});
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(JsonProof, 'JsonProof', VOID, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: JsonProofSerializer_getInstance});
  initMetadataForCompanion(Companion_23);
  initMetadataForObject($serializer_13, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonDeferredCredentialResponse, 'JsonDeferredCredentialResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
  initMetadataForObject(ToJsonProofOfPossessionSerializer, 'ToJsonProofOfPossessionSerializer', VOID, DelegateSerializer);
  initMetadataForObject(BasicCredentialSubjectSerializer, 'BasicCredentialSubjectSerializer', VOID, JsonSerializer);
  initMetadataForObject(JwtProofOfPossessionSerializer, 'JwtProofOfPossessionSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonProofOfPossessionSerializer, 'JsonProofOfPossessionSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonProofSerializer, 'JsonProofSerializer', VOID, JsonSerializer);
  initMetadataForObject(SerializableW3CVerifiableCredentialSerializer, 'SerializableW3CVerifiableCredentialSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonCredentialStatusSerializer, 'JsonCredentialStatusSerializer', VOID, JsonSerializer);
  initMetadataForClass(JsonIssuerSerializer$_objectSerializer$1, VOID, VOID, JsonSerializer);
  initMetadataForObject(JsonIssuerSerializer, 'JsonIssuerSerializer', VOID, JsonContentPolymorphicSerializer);
  initMetadataForObject(JsonIssuerDisplaySerializer, 'JsonIssuerDisplaySerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonDisplayableSerializer, 'JsonDisplayableSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonLogoSerializer, 'JsonLogoSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonCredentialDisplaySerializer, 'JsonCredentialDisplaySerializer', VOID, JsonSerializer);
  initMetadataForObject(DefaultJsonSupportedCredentialSerializer, 'DefaultJsonSupportedCredentialSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonImageSerializer, 'JsonImageSerializer', VOID, JsonSerializer);
  initMetadataForClass(VerifiableCredentialResponseSerializer, 'VerifiableCredentialResponseSerializer', VOID, JsonContentPolymorphicSerializer);
  initMetadataForCompanion(Companion_24);
  initMetadataForCompanion(Companion_25);
  initMetadataForClass(JsonClaims, 'JsonClaims', VOID, VOID, [ToJsonDictionary], VOID, VOID, {0: VcSdJwtAuthorizationDetailClaimsSerializer_getInstance});
  initMetadataForClass(JsonClaimsItem, 'JsonClaimsItem', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: VcSdJwtAuthorizationDetailClaimsItemSerializer_getInstance});
  initMetadataForCompanion(Companion_26);
  initMetadataForObject($serializer_14, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(VcSdJwtAuthorizationDetail, 'VcSdJwtAuthorizationDetail', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
  initMetadataForCompanion(Companion_27);
  initMetadataForObject($serializer_15, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(VcSdJwtCredentialConfigurationsSupported, 'VcSdJwtCredentialConfigurationsSupported', VOID, VOID, [JsonCredentialConfigurationsSupported], VOID, VOID, {0: $serializer_getInstance_16});
  initMetadataForCompanion(Companion_28);
  initMetadataForClass(VcSdJwtClaimsMetadata, 'VcSdJwtClaimsMetadata', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: VcSdJwtClaimsMetadataSerializer_getInstance});
  initMetadataForCompanion(Companion_29);
  initMetadataForClass(VcSdJwtClaimsEntryMetadata, 'VcSdJwtClaimsEntryMetadata', VcSdJwtClaimsEntryMetadata, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: VcSdJwtClaimsMetadataEntrySerializer_getInstance});
  initMetadataForCompanion(Companion_30);
  initMetadataForObject($serializer_16, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(VcSdJwtVerifiableCredentialRequest, 'VcSdJwtVerifiableCredentialRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
  initMetadataForCompanion(Companion_31);
  initMetadataForObject($serializer_17, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForInterface(VcSdJwtCredentialResponse, 'VcSdJwtCredentialResponse', VOID, VOID, VOID, VOID, VOID, {0: VcSdJwtCredentialResponseSerializer_getInstance});
  initMetadataForClass(VcSdJwtVerifiableCredentialResponse, 'VcSdJwtVerifiableCredentialResponse', VOID, VOID, [VcSdJwtCredentialResponse], VOID, VOID, {0: $serializer_getInstance_18});
  initMetadataForObject(VcSdJwtClaimsMetadataSerializer, 'VcSdJwtClaimsMetadataSerializer', VOID, JsonSerializer);
  initMetadataForObject(VcSdJwtClaimsMetadataEntrySerializer, 'VcSdJwtClaimsMetadataEntrySerializer', VOID, JsonSerializer);
  initMetadataForObject(VcSdJwtAuthorizationDetailClaimsSerializer, 'VcSdJwtAuthorizationDetailClaimsSerializer', VOID, JsonSerializer);
  initMetadataForObject(VcSdJwtAuthorizationDetailClaimsItemSerializer, 'VcSdJwtAuthorizationDetailClaimsItemSerializer', VOID, JsonSerializer);
  initMetadataForCompanion(Companion_32);
  initMetadataForObject($serializer_18, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JwtVcJsonAuthorizationDetail, 'JwtVcJsonAuthorizationDetail', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
  initMetadataForCompanion(Companion_33);
  initMetadataForCompanion(Companion_34);
  initMetadataForClass(JsonCredentialSubject, 'JsonCredentialSubject', VOID, VOID, [ToJsonDictionary], VOID, VOID, {0: JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance});
  initMetadataForClass(JsonCredentialSubjectItem, 'JsonCredentialSubjectItem', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_getInstance});
  initMetadataForCompanion(Companion_35);
  initMetadataForObject($serializer_19, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JwtVcJsonAuthorizationDetailsCredentialDefinition, 'JwtVcJsonAuthorizationDetailsCredentialDefinition', JwtVcJsonAuthorizationDetailsCredentialDefinition, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_20});
  initMetadataForCompanion(Companion_36);
  initMetadataForObject($serializer_20, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JwtVcJsonCredentialConfigurationsSupported, 'JwtVcJsonCredentialConfigurationsSupported', VOID, VOID, [JsonCredentialConfigurationsSupported], VOID, VOID, {0: $serializer_getInstance_21});
  initMetadataForCompanion(Companion_37);
  initMetadataForObject($serializer_21, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JwtVcJsonMetadataCredentialDefinition, 'JwtVcJsonMetadataCredentialDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_22});
  initMetadataForCompanion(Companion_38);
  initMetadataForClass(JwtVcJsonCredentialSubjectMetadata, 'JwtVcJsonCredentialSubjectMetadata', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JwtVcJsonCredentialSubjectMetadataSerializer_getInstance});
  initMetadataForCompanion(Companion_39);
  initMetadataForClass(JwtVcJsonCredentialSubjectEntryMetadata, 'JwtVcJsonCredentialSubjectEntryMetadata', JwtVcJsonCredentialSubjectEntryMetadata, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JwtVcJsonCredentialSubjectEntryMetadataSerializer_getInstance});
  initMetadataForCompanion(Companion_40);
  initMetadataForClass(CredentialDefinition, 'CredentialDefinition', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance});
  initMetadataForCompanion(Companion_41);
  initMetadataForObject($serializer_22, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JwtVcJsonVerifiableCredentialRequest, 'JwtVcJsonVerifiableCredentialRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_23});
  initMetadataForCompanion(Companion_42);
  initMetadataForObject($serializer_23, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JwtVcJsonLdVerifiableCredentialRequest, 'JwtVcJsonLdVerifiableCredentialRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_24});
  initMetadataForCompanion(Companion_43);
  initMetadataForObject($serializer_24, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(LdpVerifiableCredentialRequest, 'LdpVerifiableCredentialRequest', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_25});
  initMetadataForCompanion(Companion_44, CompositeFromJson);
  initMetadataForClass(BasicCredentialSubject, 'BasicCredentialSubject', VOID, VOID, [ToJsonDictionary], VOID, VOID, {0: BasicCredentialSubjectSerializer_getInstance});
  initMetadataForCompanion(Companion_45);
  initMetadataForObject($serializer_25, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForInterface(JwtVcJsonCredentialResponse, 'JwtVcJsonCredentialResponse', VOID, VOID, VOID, VOID, VOID, {0: JwtVcJsonCredentialResponseSerializer_getInstance});
  initMetadataForClass(JwtVcJsonVerifiableCredentialResponse, 'JwtVcJsonVerifiableCredentialResponse', VOID, VOID, [JwtVcJsonCredentialResponse], VOID, VOID, {0: $serializer_getInstance_26});
  initMetadataForCompanion(Companion_46);
  initMetadataForObject($serializer_26, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForInterface(LdpVcCredentialResponse, 'LdpVcCredentialResponse', VOID, VOID, VOID, VOID, VOID, {0: LdpVcCredentialResponseSerializer_getInstance});
  initMetadataForClass(LdpVcVerifiableCredentialResponse, 'LdpVcVerifiableCredentialResponse', VOID, VOID, [LdpVcCredentialResponse], VOID, VOID, {0: $serializer_getInstance_27});
  initMetadataForCompanion(Companion_47);
  initMetadataForObject($serializer_27, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForInterface(JwtVcJsonLdCredentialResponse, 'JwtVcJsonLdCredentialResponse', VOID, VOID, VOID, VOID, VOID, {0: JwtVcJsonLdCredentialResponseSerializer_getInstance});
  initMetadataForClass(JwtVcJsonLdVerifiableCredentialResponse, 'JwtVcJsonLdVerifiableCredentialResponse', VOID, VOID, [JwtVcJsonLdCredentialResponse], VOID, VOID, {0: $serializer_getInstance_28});
  initMetadataForCompanion(Companion_48);
  initMetadataForClass(Deferred, 'Deferred', VOID, VOID, [JwtVcJsonCredentialResponse], VOID, VOID, {0: DeferredJwtVcJsonCredentialResponseSerializer_getInstance});
  initMetadataForCompanion(Companion_49);
  initMetadataForClass(Deferred_0, 'Deferred', VOID, VOID, [LdpVcCredentialResponse], VOID, VOID, {0: DeferredLdpVcCredentialResponseSerializer_getInstance});
  initMetadataForCompanion(Companion_50);
  initMetadataForClass(Deferred_1, 'Deferred', VOID, VOID, [JwtVcJsonLdCredentialResponse], VOID, VOID, {0: DeferredJwtVcJsonLdCredentialResponseSerializer_getInstance});
  initMetadataForCompanion(Companion_51);
  initMetadataForClass(Deferred_2, 'Deferred', VOID, VOID, [VcSdJwtCredentialResponse], VOID, VOID, {0: DeferredVcSdJwtCredentialResponseSerializer_getInstance});
  initMetadataForObject(JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer, 'JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer', VOID, JsonSerializer);
  initMetadataForObject(DeferredJwtVcJsonCredentialResponseSerializer, 'DeferredJwtVcJsonCredentialResponseSerializer', VOID, DerivedSerializer);
  initMetadataForObject(JwtVcJsonCredentialResponseSerializer, 'JwtVcJsonCredentialResponseSerializer', VOID, VerifiableCredentialResponseSerializer);
  initMetadataForObject(DeferredLdpVcCredentialResponseSerializer, 'DeferredLdpVcCredentialResponseSerializer', VOID, DerivedSerializer);
  initMetadataForObject(LdpVcCredentialResponseSerializer, 'LdpVcCredentialResponseSerializer', VOID, VerifiableCredentialResponseSerializer);
  initMetadataForObject(DeferredJwtVcJsonLdCredentialResponseSerializer, 'DeferredJwtVcJsonLdCredentialResponseSerializer', VOID, DerivedSerializer);
  initMetadataForObject(JwtVcJsonLdCredentialResponseSerializer, 'JwtVcJsonLdCredentialResponseSerializer', VOID, VerifiableCredentialResponseSerializer);
  initMetadataForObject(JsonSupportedCredentialSerializer, 'JsonSupportedCredentialSerializer', VOID, JsonContentPolymorphicSerializer);
  initMetadataForObject(JwtVcJsonCredentialSubjectMetadataSerializer, 'JwtVcJsonCredentialSubjectMetadataSerializer', VOID, JsonSerializer);
  initMetadataForObject(JwtVcJsonCredentialSubjectEntryMetadataSerializer, 'JwtVcJsonCredentialSubjectEntryMetadataSerializer', VOID, JsonSerializer);
  initMetadataForObject(VcSdJwtCredentialResponseSerializer, 'VcSdJwtCredentialResponseSerializer', VOID, VerifiableCredentialResponseSerializer);
  initMetadataForObject(DeferredVcSdJwtCredentialResponseSerializer, 'DeferredVcSdJwtCredentialResponseSerializer', VOID, DerivedSerializer);
  initMetadataForObject(JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer, 'JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer', VOID, JsonSerializer);
  initMetadataForObject(JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer, 'JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer', VOID, JsonSerializer);
  initMetadataForCompanion(Companion_52);
  initMetadataForClass(SerializableW3CVerifiableCredential, 'SerializableW3CVerifiableCredential', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: SerializableW3CVerifiableCredentialSerializer_getInstance});
  initMetadataForCompanion(Companion_53);
  initMetadataForClass(JsonCredentialStatus, 'JsonCredentialStatus', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: JsonCredentialStatusSerializer_getInstance});
  initMetadataForCompanion(Companion_54);
  initMetadataForClass(JsonIssuer$IssuerObject$toIssuer$1, VOID, VOID, MapDictionary, [MapDictionary, IssuerObject]);
  function toIssuer() {
    return this.q3c().f3c();
  }
  initMetadataForInterface(ToJsonIssuer, 'ToJsonIssuer', VOID, VOID, [ToJson]);
  function toJsonIssuer() {
    return this;
  }
  initMetadataForInterface(JsonIssuer, 'JsonIssuer', VOID, VOID, [ToJsonIssuer], VOID, VOID, {0: JsonIssuerSerializer_getInstance});
  initMetadataForClass(IssuerURI_0, 'IssuerURI', VOID, VOID, [JsonIssuer]);
  initMetadataForClass(IssuerObject_0, 'IssuerObject', VOID, VOID, [JsonIssuer]);
  initMetadataForCompanion(Companion_55);
  initMetadataForObject($serializer_28, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonPresentationSubmission, 'JsonPresentationSubmission', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_29});
  initMetadataForCompanion(Companion_56);
  initMetadataForObject($serializer_29, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonDescriptorMapObject, 'JsonDescriptorMapObject', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_30});
  initMetadataForCompanion(Companion_57);
  initMetadataForObject($serializer_30, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonPresentationDefinition, 'JsonPresentationDefinition', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_31});
  initMetadataForObject($serializer_31, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonInputDescriptor, 'JsonInputDescriptor', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_32});
  initMetadataForCompanion(Companion_58);
  initMetadataForObject($serializer_32, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonConstraints, 'JsonConstraints', JsonConstraints, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_33});
  initMetadataForCompanion(Companion_59);
  initMetadataForObject($serializer_33, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonField, 'JsonField', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_34});
  initMetadataForCompanion(Companion_60);
  initMetadataForClass(AbstractJsonFilter, 'AbstractJsonFilter', VOID, VOID, VOID, VOID, VOID, {0: JsonFilterSerializer_getInstance});
  initMetadataForCompanion(Companion_61);
  initMetadataForObject($serializer_34, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonArrayContainsFilter, 'JsonArrayContainsFilter', VOID, AbstractJsonFilter, VOID, VOID, VOID, {0: $serializer_getInstance_35});
  initMetadataForObject($serializer_35, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonContains, 'JsonContains', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_36});
  initMetadataForCompanion(Companion_62);
  initMetadataForObject($serializer_36, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonStringFilter, 'JsonStringFilter', VOID, AbstractJsonFilter, VOID, VOID, VOID, {0: $serializer_getInstance_37});
  initMetadataForCompanion(Companion_63);
  initMetadataForObject($serializer_37, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonFormat, 'JsonFormat', JsonFormat, VOID, [Dictionary, ToJsonDictionary], VOID, VOID, {0: $serializer_getInstance_38});
  initMetadataForCompanion(Companion_64);
  initMetadataForObject($serializer_38, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonAlgFormat, 'JsonAlgFormat', VOID, VOID, [ToJson], VOID, VOID, {0: $serializer_getInstance_39});
  initMetadataForCompanion(Companion_65);
  initMetadataForObject($serializer_39, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonPathNested, 'JsonPathNested', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_40});
  initMetadataForCompanion(Companion_66);
  initMetadataForObject($serializer_40, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonProofTypeFormat, 'JsonProofTypeFormat', VOID, VOID, [ToJson], VOID, VOID, {0: $serializer_getInstance_41});
  initMetadataForCompanion(Companion_67);
  initMetadataForObject($serializer_41, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonVcSdJwtAlgsFormat, 'JsonVcSdJwtAlgsFormat', VOID, VOID, [ToJson], VOID, VOID, {0: $serializer_getInstance_42});
  initMetadataForCompanion(Companion_68, VOID, [SerializerFactory]);
  initMetadataForInterface(JsonVerifiablePresentation, 'JsonVerifiablePresentation', VOID, VOID, [ToJson], VOID, VOID, {0: JsonVerifiablePresentationSerializer_getInstance});
  initMetadataForClass(JsonStringVerifiablePresentation, 'JsonStringVerifiablePresentation', VOID, VOID, [JsonVerifiablePresentation]);
  initMetadataForClass(JsonDictionaryVerifiablePresentation, 'JsonDictionaryVerifiablePresentation', VOID, VOID, [JsonVerifiablePresentation, ToJsonDictionary]);
  initMetadataForCompanion(Companion_69);
  initMetadataForObject($serializer_42, '$serializer', VOID, VOID, [GeneratedSerializer]);
  initMetadataForClass(JsonVerifierDirectPostAuthorizationResponse, 'JsonVerifierDirectPostAuthorizationResponse', JsonVerifierDirectPostAuthorizationResponse, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_43});
  initMetadataForObject(JsonFilterSerializer, 'JsonFilterSerializer', VOID, JsonContentPolymorphicSerializer);
  initMetadataForObject(SerializableW3CVerifiablePresentationSerializer, 'SerializableW3CVerifiablePresentationSerializer', VOID, JsonSerializer);
  initMetadataForObject(JsonVerifiablePresentationSerializer, 'JsonVerifiablePresentationSerializer', VOID, JsonSerializer);
  initMetadataForCompanion(Companion_70);
  initMetadataForClass(SerializableW3CVerifiablePresentation, 'SerializableW3CVerifiablePresentation', VOID, VOID, [ToJsonDictionary, Dictionary], VOID, VOID, {0: SerializableW3CVerifiablePresentationSerializer_getInstance});
  initMetadataForCompanion(Companion_71);
  initMetadataForClass(Either, 'Either');
  initMetadataForInterface(ToJsonString, 'ToJsonString');
  initMetadataForClass(JSObject, 'JSObject');
  initMetadataForClass(JSIssuerObject, 'JSIssuerObject', VOID, JSObject);
  initMetadataForClass(JSProofObject, 'JSProofObject', VOID, JSObject);
  initMetadataForClass(JSCredentialStatusObject, 'JSCredentialStatusObject', VOID, JSObject);
  initMetadataForClass(JsPair, 'JsPair');
  initMetadataForClass(JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition, 'JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition');
  initMetadataForClass(JSJwtVcJsonVerifiableCredentialRequest, 'JSJwtVcJsonVerifiableCredentialRequest', VOID, VOID, [ToJsonString]);
  initMetadataForClass(JSJwtVcJsonLdVerifiableCredentialRequest, 'JSJwtVcJsonLdVerifiableCredentialRequest', VOID, VOID, [ToJsonString]);
  initMetadataForClass(JSLdpVerifiableCredentialRequest, 'JSLdpVerifiableCredentialRequest', VOID, VOID, [ToJsonString]);
  initMetadataForClass(JSDeferredJsonCredentialResponse, 'JSDeferredJsonCredentialResponse', VOID, VOID, [ToJsonString]);
  initMetadataForClass(JSJwtVcJsonVerifiableCredentialResponse, 'JSJwtVcJsonVerifiableCredentialResponse', VOID, VOID, [ToJsonString]);
  initMetadataForClass(JSLdpVerifiableCredentialResponse, 'JSLdpVerifiableCredentialResponse', VOID, VOID, [ToJsonString]);
  initMetadataForClass(JSJwtVcJsonLdVerifiableCredentialResponse, 'JSJwtVcJsonLdVerifiableCredentialResponse', VOID, VOID, [ToJsonString]);
  initMetadataForInterface(JsDisplayable, 'JsDisplayable');
  initMetadataForInterface(JsIssuerDisplay, 'JsIssuerDisplay', VOID, VOID, [JsDisplayable]);
  initMetadataForInterface(JsDisplayableSet, 'JsDisplayableSet');
  initMetadataForClass(JsServerMetadata, 'JsServerMetadata');
  initMetadataForClass(JsDisplayableAdapter, 'JsDisplayableAdapter', VOID, VOID, [JsDisplayable]);
  initMetadataForClass(JsIssuerDisplayAdapter, 'JsIssuerDisplayAdapter', VOID, VOID, [JsIssuerDisplay]);
  initMetadataForClass(JsCredentialDisplayAdapter, 'JsCredentialDisplayAdapter');
  initMetadataForClass(JsLogo, 'JsLogo');
  initMetadataForClass(JsCredentialDisplay, 'JsCredentialDisplay', VOID, VOID, [JsDisplayable]);
  initMetadataForClass(JsCredentialIssuerSupportedCredential, 'JsCredentialIssuerSupportedCredential');
  initMetadataForClass(JsCredentialStatus, 'JsCredentialStatus');
  function getNestedDisclosures() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = [];
    this.buildNestedDisclosure(array);
    return array;
  }
  initMetadataForInterface(JsSdValue, 'JsSdValue');
  initMetadataForClass(JsSdObject, 'JsSdObject', VOID, VOID, [JsSdValue]);
  initMetadataForClass(JsSdArray, 'JsSdArray', VOID, VOID, [JsSdValue]);
  initMetadataForClass(JsSdPrimitive, 'JsSdPrimitive', VOID, VOID, [JsSdValue]);
  initMetadataForClass(JsSdProperty, 'JsSdProperty');
  initMetadataForClass(JsSdArrayValue, 'JsSdArrayValue');
  initMetadataForClass(JsCredentialIssuer, 'JsCredentialIssuer');
  initMetadataForClass(JsUserVerifiableCredential, 'JsUserVerifiableCredential');
  initMetadataForClass(JsLdpVcJsonLdCredential, 'JsLdpVcJsonLdCredential');
  initMetadataForClass(JSCredentialResponse, 'JSCredentialResponse');
  initMetadataForClass(JsJwtVcJsonLdCredential, 'JsJwtVcJsonLdCredential');
  initMetadataForClass(JsJwtVcJsonCredential, 'JsJwtVcJsonCredential');
  initMetadataForClass(JsDidJwtVcJsonCredential, 'JsDidJwtVcJsonCredential');
  initMetadataForClass(JsSelectivelyDiscloseableClaim, 'JsSelectivelyDiscloseableClaim');
  initMetadataForClass(JsVcSdJwtCredential, 'JsVcSdJwtCredential');
  initMetadataForClass(JsDisplayableSetAdapter, 'JsDisplayableSetAdapter', VOID, VOID, [JsDisplayableSet]);
  initMetadataForCompanion(Companion_72);
  initMetadataForClass(JSW3CVerifiableCredential, 'JSW3CVerifiableCredential', VOID, VOID, [ToJsonString]);
  //endregion
  function Companion() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q30_1 = [null, new LinkedHashMapSerializer(StringSerializer_getInstance(), new ArrayListSerializer(JsonDisplayableSerializer_getInstance())), new ArrayListSerializer(JsonCredentialDisplaySerializer_getInstance()), null, null, null, null, null];
  }
  var Companion_instance_1;
  function Companion_getInstance() {
    if (Companion_instance_1 == null)
      new Companion();
    return Companion_instance_1;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.DefaultValidatedVcSdJwtCredentialResponse', this, 8);
    tmp0_serialDesc.wy('response', false);
    tmp0_serialDesc.wy('claimDisplayables', false);
    tmp0_serialDesc.wy('credentialDisplay', false);
    tmp0_serialDesc.wy('credential', false);
    tmp0_serialDesc.wy('issuer', false);
    tmp0_serialDesc.wy('vct', false);
    tmp0_serialDesc.wy('customClaims', false);
    tmp0_serialDesc.wy('kid', false);
    this.r30_1 = tmp0_serialDesc;
  }
  protoOf($serializer).s30 = function (encoder, value) {
    var tmp0_desc = this.r30_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance().q30_1;
    tmp1_output.bt(tmp0_desc, 0, VcSdJwtCredentialResponseSerializer_getInstance(), value.t30_1);
    tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.u30_1);
    tmp1_output.dt(tmp0_desc, 2, tmp2_cached[2], value.v30_1);
    tmp1_output.zs(tmp0_desc, 3, value.w30_1);
    tmp1_output.zs(tmp0_desc, 4, value.x30_1);
    tmp1_output.zs(tmp0_desc, 5, value.y30_1);
    tmp1_output.bt(tmp0_desc, 6, $serializer_getInstance(), value.z30_1);
    tmp1_output.zs(tmp0_desc, 7, value.a31_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer).zn = function (encoder, value) {
    return this.s30(encoder, value instanceof DefaultValidatedVcSdJwtCredentialResponse ? value : THROW_CCE());
  };
  protoOf($serializer).ao = function (decoder) {
    var tmp0_desc = this.r30_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.lr(tmp0_desc);
    var tmp13_cached = Companion_getInstance().q30_1;
    if (tmp12_input.as()) {
      tmp4_local0 = tmp12_input.xr(tmp0_desc, 0, VcSdJwtCredentialResponseSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.xr(tmp0_desc, 1, tmp13_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.vr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.vr(tmp0_desc, 4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.vr(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.xr(tmp0_desc, 6, $serializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.vr(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.xr(tmp0_desc, 0, VcSdJwtCredentialResponseSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.xr(tmp0_desc, 1, tmp13_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.vr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.vr(tmp0_desc, 4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.vr(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.xr(tmp0_desc, 6, $serializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.vr(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.mr(tmp0_desc);
    return DefaultValidatedVcSdJwtCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer).yn = function () {
    return this.r30_1;
  };
  protoOf($serializer).lz = function () {
    var tmp0_cached = Companion_getInstance().q30_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [VcSdJwtCredentialResponseSerializer_getInstance(), tmp0_cached[1], get_nullable(tmp0_cached[2]), StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance_0() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function DefaultValidatedVcSdJwtCredentialResponse_init_$Init$(seen0, response, claimDisplayables, credentialDisplay, credential, issuer, vct, customClaims, kid, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen0))) {
      throwMissingFieldException(seen0, 255, $serializer_getInstance_0().r30_1);
    }
    $this.t30_1 = response;
    $this.u30_1 = claimDisplayables;
    $this.v30_1 = credentialDisplay;
    $this.w30_1 = credential;
    $this.x30_1 = issuer;
    $this.y30_1 = vct;
    $this.z30_1 = customClaims;
    $this.a31_1 = kid;
    return $this;
  }
  function DefaultValidatedVcSdJwtCredentialResponse_init_$Create$(seen0, response, claimDisplayables, credentialDisplay, credential, issuer, vct, customClaims, kid, serializationConstructorMarker) {
    return DefaultValidatedVcSdJwtCredentialResponse_init_$Init$(seen0, response, claimDisplayables, credentialDisplay, credential, issuer, vct, customClaims, kid, serializationConstructorMarker, objectCreate(protoOf(DefaultValidatedVcSdJwtCredentialResponse)));
  }
  function DefaultValidatedVcSdJwtCredentialResponse(response, claimDisplayables, credentialDisplay, credential, issuer, vct, customClaims, kid) {
    Companion_getInstance();
    this.t30_1 = response;
    this.u30_1 = claimDisplayables;
    this.v30_1 = credentialDisplay;
    this.w30_1 = credential;
    this.x30_1 = issuer;
    this.y30_1 = vct;
    this.z30_1 = customClaims;
    this.a31_1 = kid;
  }
  function Companion_0() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b31_1 = [null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), new ArrayListSerializer(JsonDisplayableSerializer_getInstance())), new ArrayListSerializer(JsonCredentialDisplaySerializer_getInstance())];
  }
  var Companion_instance_2;
  function Companion_getInstance_0() {
    if (Companion_instance_2 == null)
      new Companion_0();
    return Companion_instance_2;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.DidValidatedJwtVcJsonCredentialResponse', this, 5);
    tmp0_serialDesc.wy('response', false);
    tmp0_serialDesc.wy('credentialJwt', false);
    tmp0_serialDesc.wy('w3cCredential', false);
    tmp0_serialDesc.wy('claimDisplayables', false);
    tmp0_serialDesc.wy('credentialDisplay', false);
    this.c31_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).d31 = function (encoder, value) {
    var tmp0_desc = this.c31_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_0().b31_1;
    tmp1_output.bt(tmp0_desc, 0, JwtVcJsonCredentialResponseSerializer_getInstance(), value.e31_1);
    tmp1_output.zs(tmp0_desc, 1, value.f31_1);
    tmp1_output.bt(tmp0_desc, 2, SerializableW3CVerifiableCredentialSerializer_getInstance(), value.g31_1);
    tmp1_output.bt(tmp0_desc, 3, tmp2_cached[3], value.h31_1);
    tmp1_output.dt(tmp0_desc, 4, tmp2_cached[4], value.i31_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_0).zn = function (encoder, value) {
    return this.d31(encoder, value instanceof DidValidatedJwtVcJsonCredentialResponse ? value : THROW_CCE());
  };
  protoOf($serializer_0).ao = function (decoder) {
    var tmp0_desc = this.c31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.lr(tmp0_desc);
    var tmp10_cached = Companion_getInstance_0().b31_1;
    if (tmp9_input.as()) {
      tmp4_local0 = tmp9_input.xr(tmp0_desc, 0, JwtVcJsonCredentialResponseSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, SerializableW3CVerifiableCredentialSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.xr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.xr(tmp0_desc, 0, JwtVcJsonCredentialResponseSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, SerializableW3CVerifiableCredentialSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.xr(tmp0_desc, 3, tmp10_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.mr(tmp0_desc);
    return DidValidatedJwtVcJsonCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_0).yn = function () {
    return this.c31_1;
  };
  protoOf($serializer_0).lz = function () {
    var tmp0_cached = Companion_getInstance_0().b31_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [JwtVcJsonCredentialResponseSerializer_getInstance(), StringSerializer_getInstance(), SerializableW3CVerifiableCredentialSerializer_getInstance(), tmp0_cached[3], get_nullable(tmp0_cached[4])];
  };
  var $serializer_instance_0;
  function $serializer_getInstance_1() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function DidValidatedJwtVcJsonCredentialResponse_init_$Init$(seen0, response, credentialJwt, w3cCredential, claimDisplayables, credentialDisplay, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_1().c31_1);
    }
    $this.e31_1 = response;
    $this.f31_1 = credentialJwt;
    $this.g31_1 = w3cCredential;
    $this.h31_1 = claimDisplayables;
    $this.i31_1 = credentialDisplay;
    return $this;
  }
  function DidValidatedJwtVcJsonCredentialResponse_init_$Create$(seen0, response, credentialJwt, w3cCredential, claimDisplayables, credentialDisplay, serializationConstructorMarker) {
    return DidValidatedJwtVcJsonCredentialResponse_init_$Init$(seen0, response, credentialJwt, w3cCredential, claimDisplayables, credentialDisplay, serializationConstructorMarker, objectCreate(protoOf(DidValidatedJwtVcJsonCredentialResponse)));
  }
  function DidValidatedJwtVcJsonCredentialResponse(response, credentialJwt, w3cCredential, claimDisplayables, credentialDisplay) {
    Companion_getInstance_0();
    this.e31_1 = response;
    this.f31_1 = credentialJwt;
    this.g31_1 = w3cCredential;
    this.h31_1 = claimDisplayables;
    this.i31_1 = credentialDisplay;
  }
  protoOf(DidValidatedJwtVcJsonCredentialResponse).j31 = function () {
    return this.e31_1;
  };
  protoOf(DidValidatedJwtVcJsonCredentialResponse).k31 = function () {
    return this.f31_1;
  };
  protoOf(DidValidatedJwtVcJsonCredentialResponse).toString = function () {
    return 'DidValidatedJwtVcJsonCredentialResponse(response=' + toString(this.e31_1) + ', credentialJwt=' + this.f31_1 + ', w3cCredential=' + this.g31_1.toString() + ', claimDisplayables=' + toString(this.h31_1) + ', credentialDisplay=' + toString_0(this.i31_1) + ')';
  };
  protoOf(DidValidatedJwtVcJsonCredentialResponse).hashCode = function () {
    var result = hashCode(this.e31_1);
    result = imul(result, 31) + getStringHashCode(this.f31_1) | 0;
    result = imul(result, 31) + this.g31_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.h31_1) | 0;
    result = imul(result, 31) + (this.i31_1 == null ? 0 : hashCode(this.i31_1)) | 0;
    return result;
  };
  protoOf(DidValidatedJwtVcJsonCredentialResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DidValidatedJwtVcJsonCredentialResponse))
      return false;
    var tmp0_other_with_cast = other instanceof DidValidatedJwtVcJsonCredentialResponse ? other : THROW_CCE();
    if (!equals(this.e31_1, tmp0_other_with_cast.e31_1))
      return false;
    if (!(this.f31_1 === tmp0_other_with_cast.f31_1))
      return false;
    if (!this.g31_1.equals(tmp0_other_with_cast.g31_1))
      return false;
    if (!equals(this.h31_1, tmp0_other_with_cast.h31_1))
      return false;
    if (!equals(this.i31_1, tmp0_other_with_cast.i31_1))
      return false;
    return true;
  };
  function Companion_1() {
  }
  var Companion_instance_3;
  function Companion_getInstance_1() {
    return Companion_instance_3;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonOffer.JsonGrants.JsonAuthorizationCode', this, 2);
    tmp0_serialDesc.wy('issuer_state', true);
    tmp0_serialDesc.wy('authorization_server', true);
    this.l31_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).m31 = function (encoder, value) {
    var tmp0_desc = this.l31_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.n31_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.n31_1);
    }
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.o31_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.o31_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_1).zn = function (encoder, value) {
    return this.m31(encoder, value instanceof JsonAuthorizationCode ? value : THROW_CCE());
  };
  protoOf($serializer_1).ao = function (decoder) {
    var tmp0_desc = this.l31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonAuthorizationCode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_1).yn = function () {
    return this.l31_1;
  };
  protoOf($serializer_1).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_1;
  function $serializer_getInstance_2() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function JsonAuthorizationCode_init_$Init$(seen0, issuerState, authorizationServer, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_2().l31_1);
    }
    if (0 === (seen0 & 1))
      $this.n31_1 = null;
    else
      $this.n31_1 = issuerState;
    if (0 === (seen0 & 2))
      $this.o31_1 = null;
    else
      $this.o31_1 = authorizationServer;
    return $this;
  }
  function JsonAuthorizationCode_init_$Create$(seen0, issuerState, authorizationServer, serializationConstructorMarker) {
    return JsonAuthorizationCode_init_$Init$(seen0, issuerState, authorizationServer, serializationConstructorMarker, objectCreate(protoOf(JsonAuthorizationCode)));
  }
  function Companion_2() {
  }
  var Companion_instance_4;
  function Companion_getInstance_2() {
    return Companion_instance_4;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonOffer.JsonGrants.JsonPreAuthorizedCode.JsonTxCode', this, 3);
    tmp0_serialDesc.wy('input_mode', true);
    tmp0_serialDesc.wy('length', true);
    tmp0_serialDesc.wy('description', true);
    this.p31_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).q31 = function (encoder, value) {
    var tmp0_desc = this.p31_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.r31_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.r31_1);
    }
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.s31_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, IntSerializer_getInstance(), value.s31_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.t31_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.t31_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_2).zn = function (encoder, value) {
    return this.q31(encoder, value instanceof JsonTxCode ? value : THROW_CCE());
  };
  protoOf($serializer_2).ao = function (decoder) {
    var tmp0_desc = this.p31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, IntSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JsonTxCode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_2).yn = function () {
    return this.p31_1;
  };
  protoOf($serializer_2).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(IntSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_2;
  function $serializer_getInstance_3() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function JsonTxCode_init_$Init$(seen0, inputMode, length, description, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_3().p31_1);
    }
    if (0 === (seen0 & 1))
      $this.r31_1 = null;
    else
      $this.r31_1 = inputMode;
    if (0 === (seen0 & 2))
      $this.s31_1 = null;
    else
      $this.s31_1 = length;
    if (0 === (seen0 & 4))
      $this.t31_1 = null;
    else
      $this.t31_1 = description;
    return $this;
  }
  function JsonTxCode_init_$Create$(seen0, inputMode, length, description, serializationConstructorMarker) {
    return JsonTxCode_init_$Init$(seen0, inputMode, length, description, serializationConstructorMarker, objectCreate(protoOf(JsonTxCode)));
  }
  function JsonTxCode(inputMode, length, description) {
    inputMode = inputMode === VOID ? null : inputMode;
    length = length === VOID ? null : length;
    description = description === VOID ? null : description;
    this.r31_1 = inputMode;
    this.s31_1 = length;
    this.t31_1 = description;
  }
  protoOf(JsonTxCode).toString = function () {
    return 'JsonTxCode(inputMode=' + this.r31_1 + ', length=' + this.s31_1 + ', description=' + this.t31_1 + ')';
  };
  protoOf(JsonTxCode).hashCode = function () {
    var result = this.r31_1 == null ? 0 : getStringHashCode(this.r31_1);
    result = imul(result, 31) + (this.s31_1 == null ? 0 : this.s31_1) | 0;
    result = imul(result, 31) + (this.t31_1 == null ? 0 : getStringHashCode(this.t31_1)) | 0;
    return result;
  };
  protoOf(JsonTxCode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonTxCode))
      return false;
    var tmp0_other_with_cast = other instanceof JsonTxCode ? other : THROW_CCE();
    if (!(this.r31_1 == tmp0_other_with_cast.r31_1))
      return false;
    if (!(this.s31_1 == tmp0_other_with_cast.s31_1))
      return false;
    if (!(this.t31_1 == tmp0_other_with_cast.t31_1))
      return false;
    return true;
  };
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonOffer.JsonGrants.JsonPreAuthorizedCode', this, 4);
    tmp0_serialDesc.wy('pre-authorized_code', false);
    tmp0_serialDesc.wy('tx_code', true);
    tmp0_serialDesc.wy('interval', true);
    tmp0_serialDesc.wy('authorization_server', true);
    this.u31_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).v31 = function (encoder, value) {
    var tmp0_desc = this.u31_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.w31_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.x31_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, $serializer_getInstance_3(), value.x31_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !value.y31_1.equals(new Long(5, 0))) {
      tmp1_output.vs(tmp0_desc, 2, value.y31_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.z31_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.z31_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_3).zn = function (encoder, value) {
    return this.v31(encoder, value instanceof JsonPreAuthorizedCode ? value : THROW_CCE());
  };
  protoOf($serializer_3).ao = function (decoder) {
    var tmp0_desc = this.u31_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = new Long(0, 0);
    var tmp7_local3 = null;
    var tmp8_input = decoder.lr(tmp0_desc);
    if (tmp8_input.as()) {
      tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zr(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.rr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zr(tmp0_desc, 1, $serializer_getInstance_3(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.rr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.mr(tmp0_desc);
    return JsonPreAuthorizedCode_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_3).yn = function () {
    return this.u31_1;
  };
  protoOf($serializer_3).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable($serializer_getInstance_3()), LongSerializer_getInstance(), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_3;
  function $serializer_getInstance_4() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function JsonPreAuthorizedCode_init_$Init$(seen0, preAuthorizedCode, txCode, interval, authorizationServer, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_4().u31_1);
    }
    $this.w31_1 = preAuthorizedCode;
    if (0 === (seen0 & 2))
      $this.x31_1 = null;
    else
      $this.x31_1 = txCode;
    if (0 === (seen0 & 4))
      $this.y31_1 = new Long(5, 0);
    else
      $this.y31_1 = interval;
    if (0 === (seen0 & 8))
      $this.z31_1 = null;
    else
      $this.z31_1 = authorizationServer;
    return $this;
  }
  function JsonPreAuthorizedCode_init_$Create$(seen0, preAuthorizedCode, txCode, interval, authorizationServer, serializationConstructorMarker) {
    return JsonPreAuthorizedCode_init_$Init$(seen0, preAuthorizedCode, txCode, interval, authorizationServer, serializationConstructorMarker, objectCreate(protoOf(JsonPreAuthorizedCode)));
  }
  function JsonAuthorizationCode(issuerState, authorizationServer) {
    issuerState = issuerState === VOID ? null : issuerState;
    authorizationServer = authorizationServer === VOID ? null : authorizationServer;
    this.n31_1 = issuerState;
    this.o31_1 = authorizationServer;
  }
  protoOf(JsonAuthorizationCode).toString = function () {
    return 'JsonAuthorizationCode(issuerState=' + this.n31_1 + ', authorizationServer=' + this.o31_1 + ')';
  };
  protoOf(JsonAuthorizationCode).hashCode = function () {
    var result = this.n31_1 == null ? 0 : getStringHashCode(this.n31_1);
    result = imul(result, 31) + (this.o31_1 == null ? 0 : getStringHashCode(this.o31_1)) | 0;
    return result;
  };
  protoOf(JsonAuthorizationCode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonAuthorizationCode))
      return false;
    var tmp0_other_with_cast = other instanceof JsonAuthorizationCode ? other : THROW_CCE();
    if (!(this.n31_1 == tmp0_other_with_cast.n31_1))
      return false;
    if (!(this.o31_1 == tmp0_other_with_cast.o31_1))
      return false;
    return true;
  };
  function JsonPreAuthorizedCode() {
  }
  protoOf(JsonPreAuthorizedCode).toString = function () {
    return 'JsonPreAuthorizedCode(preAuthorizedCode=' + this.w31_1 + ', txCode=' + toString_0(this.x31_1) + ', interval=' + this.y31_1.toString() + ', authorizationServer=' + this.z31_1 + ')';
  };
  protoOf(JsonPreAuthorizedCode).hashCode = function () {
    var result = getStringHashCode(this.w31_1);
    result = imul(result, 31) + (this.x31_1 == null ? 0 : this.x31_1.hashCode()) | 0;
    result = imul(result, 31) + this.y31_1.hashCode() | 0;
    result = imul(result, 31) + (this.z31_1 == null ? 0 : getStringHashCode(this.z31_1)) | 0;
    return result;
  };
  protoOf(JsonPreAuthorizedCode).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonPreAuthorizedCode))
      return false;
    var tmp0_other_with_cast = other instanceof JsonPreAuthorizedCode ? other : THROW_CCE();
    if (!(this.w31_1 === tmp0_other_with_cast.w31_1))
      return false;
    if (!equals(this.x31_1, tmp0_other_with_cast.x31_1))
      return false;
    if (!this.y31_1.equals(tmp0_other_with_cast.y31_1))
      return false;
    if (!(this.z31_1 == tmp0_other_with_cast.z31_1))
      return false;
    return true;
  };
  function Companion_3() {
  }
  var Companion_instance_5;
  function Companion_getInstance_3() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonOffer.JsonGrants', this, 2);
    tmp0_serialDesc.wy('authorization_code', true);
    tmp0_serialDesc.wy('urn:ietf:params:oauth:grant-type:pre-authorized_code', true);
    this.a32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).b32 = function (encoder, value) {
    var tmp0_desc = this.a32_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.c32_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, $serializer_getInstance_2(), value.c32_1);
    }
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.d32_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, $serializer_getInstance_4(), value.d32_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_4).zn = function (encoder, value) {
    return this.b32(encoder, value instanceof JsonGrants ? value : THROW_CCE());
  };
  protoOf($serializer_4).ao = function (decoder) {
    var tmp0_desc = this.a32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, $serializer_getInstance_2(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, $serializer_getInstance_4(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonGrants_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_4).yn = function () {
    return this.a32_1;
  };
  protoOf($serializer_4).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_4())];
  };
  var $serializer_instance_4;
  function $serializer_getInstance_5() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function JsonGrants_init_$Init$(seen0, authorizationCode, preAuthorizedCode, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_5().a32_1);
    }
    if (0 === (seen0 & 1))
      $this.c32_1 = null;
    else
      $this.c32_1 = authorizationCode;
    if (0 === (seen0 & 2))
      $this.d32_1 = null;
    else
      $this.d32_1 = preAuthorizedCode;
    return $this;
  }
  function JsonGrants_init_$Create$(seen0, authorizationCode, preAuthorizedCode, serializationConstructorMarker) {
    return JsonGrants_init_$Init$(seen0, authorizationCode, preAuthorizedCode, serializationConstructorMarker, objectCreate(protoOf(JsonGrants)));
  }
  function JsonGrants(authorizationCode, preAuthorizedCode) {
    authorizationCode = authorizationCode === VOID ? null : authorizationCode;
    preAuthorizedCode = preAuthorizedCode === VOID ? null : preAuthorizedCode;
    this.c32_1 = authorizationCode;
    this.d32_1 = preAuthorizedCode;
  }
  protoOf(JsonGrants).toString = function () {
    return 'JsonGrants(authorizationCode=' + toString_0(this.c32_1) + ', preAuthorizedCode=' + toString_0(this.d32_1) + ')';
  };
  protoOf(JsonGrants).hashCode = function () {
    var result = this.c32_1 == null ? 0 : this.c32_1.hashCode();
    result = imul(result, 31) + (this.d32_1 == null ? 0 : this.d32_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonGrants).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonGrants))
      return false;
    var tmp0_other_with_cast = other instanceof JsonGrants ? other : THROW_CCE();
    if (!equals(this.c32_1, tmp0_other_with_cast.c32_1))
      return false;
    if (!equals(this.d32_1, tmp0_other_with_cast.d32_1))
      return false;
    return true;
  };
  function Companion_4() {
    Companion_instance_6 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e32_1 = [null, new ArrayListSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_6;
  function Companion_getInstance_4() {
    if (Companion_instance_6 == null)
      new Companion_4();
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonOffer', this, 3);
    tmp0_serialDesc.wy('credential_issuer', false);
    tmp0_serialDesc.wy('credential_configuration_ids', false);
    tmp0_serialDesc.wy('grants', true);
    this.f32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).g32 = function (encoder, value) {
    var tmp0_desc = this.f32_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_4().e32_1;
    tmp1_output.zs(tmp0_desc, 0, value.h32_1);
    tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.i32_1);
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.j32_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, $serializer_getInstance_5(), value.j32_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_5).zn = function (encoder, value) {
    return this.g32(encoder, value instanceof JsonOffer ? value : THROW_CCE());
  };
  protoOf($serializer_5).ao = function (decoder) {
    var tmp0_desc = this.f32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    var tmp8_cached = Companion_getInstance_4().e32_1;
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, $serializer_getInstance_5(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, $serializer_getInstance_5(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JsonOffer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_5).yn = function () {
    return this.f32_1;
  };
  protoOf($serializer_5).lz = function () {
    var tmp0_cached = Companion_getInstance_4().e32_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], get_nullable($serializer_getInstance_5())];
  };
  var $serializer_instance_5;
  function $serializer_getInstance_6() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function JsonOffer_init_$Init$(seen0, credentialIssuer, credentialConfigurationIds, grants, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_6().f32_1);
    }
    $this.h32_1 = credentialIssuer;
    $this.i32_1 = credentialConfigurationIds;
    if (0 === (seen0 & 4))
      $this.j32_1 = null;
    else
      $this.j32_1 = grants;
    return $this;
  }
  function JsonOffer_init_$Create$(seen0, credentialIssuer, credentialConfigurationIds, grants, serializationConstructorMarker) {
    return JsonOffer_init_$Init$(seen0, credentialIssuer, credentialConfigurationIds, grants, serializationConstructorMarker, objectCreate(protoOf(JsonOffer)));
  }
  function JsonOffer(credentialIssuer, credentialConfigurationIds, grants) {
    Companion_getInstance_4();
    grants = grants === VOID ? null : grants;
    this.h32_1 = credentialIssuer;
    this.i32_1 = credentialConfigurationIds;
    this.j32_1 = grants;
  }
  protoOf(JsonOffer).toString = function () {
    return 'JsonOffer(credentialIssuer=' + this.h32_1 + ', credentialConfigurationIds=' + toString(this.i32_1) + ', grants=' + toString_0(this.j32_1) + ')';
  };
  protoOf(JsonOffer).hashCode = function () {
    var result = getStringHashCode(this.h32_1);
    result = imul(result, 31) + hashCode(this.i32_1) | 0;
    result = imul(result, 31) + (this.j32_1 == null ? 0 : this.j32_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonOffer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonOffer))
      return false;
    var tmp0_other_with_cast = other instanceof JsonOffer ? other : THROW_CCE();
    if (!(this.h32_1 === tmp0_other_with_cast.h32_1))
      return false;
    if (!equals(this.i32_1, tmp0_other_with_cast.i32_1))
      return false;
    if (!equals(this.j32_1, tmp0_other_with_cast.j32_1))
      return false;
    return true;
  };
  function Companion_5() {
  }
  protoOf(Companion_5).b1b = function () {
    var tmp = getKClass(ValidatedCredentialResponse);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(DidValidatedJwtVcJsonCredentialResponse), getKClass(ValidatedJwtVcJsonLdCredentialResponse), getKClass(ValidatedLdpVcCredentialResponse), getKClass(DefaultValidatedVcSdJwtCredentialResponse)];
    // Inline function 'kotlin.arrayOf' call
    var tmp_1 = $serializer_getInstance_1();
    var tmp_2 = getKClass(ValidatedJwtVcJsonLdCredentialResponse);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [];
    var tmp_3 = PolymorphicSerializer_init_$Create$(tmp_2, tmp$ret$5);
    var tmp_4 = getKClass(ValidatedLdpVcCredentialResponse);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_5 = [tmp_1, tmp_3, PolymorphicSerializer_init_$Create$(tmp_4, tmp$ret$8), $serializer_getInstance_0()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$14 = [];
    return SealedClassSerializer_init_$Create$('io.curity.vc.serialization.ValidatedCredentialResponse', tmp, tmp_0, tmp_5, tmp$ret$14);
  };
  protoOf(Companion_5).wz = function (typeParamsSerializers) {
    return this.b1b();
  };
  var Companion_instance_7;
  function Companion_getInstance_5() {
    return Companion_instance_7;
  }
  function ValidatedCredentialResponse() {
  }
  function ValidatedLdpVcCredentialResponse() {
  }
  function ValidatedJwtVcJsonLdCredentialResponse() {
  }
  function Companion_6() {
  }
  protoOf(Companion_6).b1b = function () {
    var tmp = getKClass(ValidatedJwtVcJsonCredentialResponse);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_0 = [getKClass(DidValidatedJwtVcJsonCredentialResponse)];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [$serializer_getInstance_1()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    return SealedClassSerializer_init_$Create$('io.curity.vc.serialization.ValidatedJwtVcJsonCredentialResponse', tmp, tmp_0, tmp_1, tmp$ret$8);
  };
  protoOf(Companion_6).wz = function (typeParamsSerializers) {
    return this.b1b();
  };
  var Companion_instance_8;
  function Companion_getInstance_6() {
    return Companion_instance_8;
  }
  function ValidatedJwtVcJsonCredentialResponse() {
  }
  function ValidatedVcSdJwtCredentialResponse() {
  }
  function Companion_7() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l32_1 = [new ArrayListSerializer(StringSerializer_getInstance()), new LinkedHashSetSerializer(StringSerializer_getInstance()), null];
  }
  protoOf(Companion_7).b1b = function () {
    return $serializer_getInstance_7();
  };
  var Companion_instance_9;
  function Companion_getInstance_7() {
    if (Companion_instance_9 == null)
      new Companion_7();
    return Companion_instance_9;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonCredentialDefinition', this, 3);
    tmp0_serialDesc.wy('@context', false);
    tmp0_serialDesc.wy('types', false);
    tmp0_serialDesc.wy('credentialSubject', false);
    this.m32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).n32 = function (encoder, value) {
    var tmp0_desc = this.m32_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_7().l32_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.o32_1);
    tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.p32_1);
    tmp1_output.bt(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), value.q32_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_6).zn = function (encoder, value) {
    return this.n32(encoder, value instanceof JsonCredentialDefinition ? value : THROW_CCE());
  };
  protoOf($serializer_6).ao = function (decoder) {
    var tmp0_desc = this.m32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    var tmp8_cached = Companion_getInstance_7().l32_1;
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JsonCredentialDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_6).yn = function () {
    return this.m32_1;
  };
  protoOf($serializer_6).lz = function () {
    var tmp0_cached = Companion_getInstance_7().l32_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], ToJsonDictionarySerializer_getInstance()];
  };
  var $serializer_instance_6;
  function $serializer_getInstance_7() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function JsonCredentialDefinition_init_$Init$(seen0, context, types, credentialSubject, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_7().m32_1);
    }
    $this.o32_1 = context;
    $this.p32_1 = types;
    $this.q32_1 = credentialSubject;
    return $this;
  }
  function JsonCredentialDefinition_init_$Create$(seen0, context, types, credentialSubject, serializationConstructorMarker) {
    return JsonCredentialDefinition_init_$Init$(seen0, context, types, credentialSubject, serializationConstructorMarker, objectCreate(protoOf(JsonCredentialDefinition)));
  }
  function JsonCredentialDefinition(context, types, credentialSubject) {
    Companion_getInstance_7();
    this.o32_1 = context;
    this.p32_1 = types;
    this.q32_1 = credentialSubject;
  }
  protoOf(JsonCredentialDefinition).a27 = function () {
    return Default_getInstance().a19(Companion_getInstance_7().b1b(), this);
  };
  protoOf(JsonCredentialDefinition).toString = function () {
    return 'JsonCredentialDefinition(context=' + toString(this.o32_1) + ', types=' + toString(this.p32_1) + ', credentialSubject=' + toString(this.q32_1) + ')';
  };
  protoOf(JsonCredentialDefinition).hashCode = function () {
    var result = hashCode(this.o32_1);
    result = imul(result, 31) + hashCode(this.p32_1) | 0;
    result = imul(result, 31) + hashCode(this.q32_1) | 0;
    return result;
  };
  protoOf(JsonCredentialDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonCredentialDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof JsonCredentialDefinition ? other : THROW_CCE();
    if (!equals(this.o32_1, tmp0_other_with_cast.o32_1))
      return false;
    if (!equals(this.p32_1, tmp0_other_with_cast.p32_1))
      return false;
    if (!equals(this.q32_1, tmp0_other_with_cast.q32_1))
      return false;
    return true;
  };
  function Companion_8() {
  }
  var Companion_instance_10;
  function Companion_getInstance_8() {
    return Companion_instance_10;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonCredentialIssuer', this, 3);
    tmp0_serialDesc.wy('issuerMetadata', false);
    tmp0_serialDesc.wy('authorizationServerMetadata', false);
    tmp0_serialDesc.wy('lastUpdate', false);
    this.r32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).s32 = function (encoder, value) {
    var tmp0_desc = this.r32_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.bt(tmp0_desc, 0, $serializer_getInstance_10(), value.t32_1);
    tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_13(), value.u32_1);
    tmp1_output.bt(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), value.v32_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_7).zn = function (encoder, value) {
    return this.s32(encoder, value instanceof JsonCredentialIssuer ? value : THROW_CCE());
  };
  protoOf($serializer_7).ao = function (decoder) {
    var tmp0_desc = this.r32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, $serializer_getInstance_10(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_13(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JsonCredentialIssuer_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_7).yn = function () {
    return this.r32_1;
  };
  protoOf($serializer_7).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_10(), $serializer_getInstance_13(), InstantIso8601Serializer_getInstance()];
  };
  var $serializer_instance_7;
  function $serializer_getInstance_8() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function JsonCredentialIssuer_init_$Init$(seen0, issuerMetadata, authorizationServerMetadata, lastUpdate, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_8().r32_1);
    }
    $this.t32_1 = issuerMetadata;
    $this.u32_1 = authorizationServerMetadata;
    $this.v32_1 = lastUpdate;
    return $this;
  }
  function JsonCredentialIssuer_init_$Create$(seen0, issuerMetadata, authorizationServerMetadata, lastUpdate, serializationConstructorMarker) {
    return JsonCredentialIssuer_init_$Init$(seen0, issuerMetadata, authorizationServerMetadata, lastUpdate, serializationConstructorMarker, objectCreate(protoOf(JsonCredentialIssuer)));
  }
  function JsonCredentialIssuer(issuerMetadata, authorizationServerMetadata, lastUpdate) {
    this.t32_1 = issuerMetadata;
    this.u32_1 = authorizationServerMetadata;
    this.v32_1 = lastUpdate;
  }
  protoOf(JsonCredentialIssuer).toString = function () {
    return 'JsonCredentialIssuer(issuerMetadata=' + this.t32_1.toString() + ', authorizationServerMetadata=' + this.u32_1.toString() + ', lastUpdate=' + this.v32_1.toString() + ')';
  };
  protoOf(JsonCredentialIssuer).hashCode = function () {
    var result = this.t32_1.hashCode();
    result = imul(result, 31) + this.u32_1.hashCode() | 0;
    result = imul(result, 31) + this.v32_1.hashCode() | 0;
    return result;
  };
  protoOf(JsonCredentialIssuer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonCredentialIssuer))
      return false;
    var tmp0_other_with_cast = other instanceof JsonCredentialIssuer ? other : THROW_CCE();
    if (!this.t32_1.equals(tmp0_other_with_cast.t32_1))
      return false;
    if (!this.u32_1.equals(tmp0_other_with_cast.u32_1))
      return false;
    if (!this.v32_1.equals(tmp0_other_with_cast.v32_1))
      return false;
    return true;
  };
  function Companion_9() {
    Companion_instance_11 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    var tmp_0 = getKClass(ValidatedCredentialResponse);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = [getKClass(DidValidatedJwtVcJsonCredentialResponse), getKClass(ValidatedJwtVcJsonLdCredentialResponse), getKClass(ValidatedLdpVcCredentialResponse), getKClass(DefaultValidatedVcSdJwtCredentialResponse)];
    // Inline function 'kotlin.arrayOf' call
    var tmp_2 = $serializer_getInstance_1();
    var tmp_3 = getKClass(ValidatedJwtVcJsonLdCredentialResponse);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = [];
    var tmp_4 = PolymorphicSerializer_init_$Create$(tmp_3, tmp$ret$5);
    var tmp_5 = getKClass(ValidatedLdpVcCredentialResponse);
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$8 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_6 = [tmp_2, tmp_4, PolymorphicSerializer_init_$Create$(tmp_5, tmp$ret$8), $serializer_getInstance_0()];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$14 = [];
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.w32_1 = [null, null, null, null, SealedClassSerializer_init_$Create$('io.curity.vc.serialization.ValidatedCredentialResponse', tmp_0, tmp_1, tmp_6, tmp$ret$14)];
  }
  protoOf(Companion_9).x32 = function () {
    return encodeBase64url(Default_getInstance_0().fh(16));
  };
  var Companion_instance_11;
  function Companion_getInstance_9() {
    if (Companion_instance_11 == null)
      new Companion_9();
    return Companion_instance_11;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.UserVerifiableCredential', this, 5);
    tmp0_serialDesc.wy('localId', false);
    tmp0_serialDesc.wy('issuerId', false);
    tmp0_serialDesc.wy('issuedAt', false);
    tmp0_serialDesc.wy('userDefinedName', false);
    tmp0_serialDesc.wy('credentialResponse', false);
    this.y32_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).z32 = function (encoder, value) {
    var tmp0_desc = this.y32_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().w32_1;
    tmp1_output.zs(tmp0_desc, 0, value.a33_1);
    tmp1_output.zs(tmp0_desc, 1, value.b33_1);
    tmp1_output.bt(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), value.c33_1);
    tmp1_output.zs(tmp0_desc, 3, value.d33_1);
    tmp1_output.bt(tmp0_desc, 4, tmp2_cached[4], value.e33_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_8).zn = function (encoder, value) {
    return this.z32(encoder, value instanceof UserVerifiableCredential ? value : THROW_CCE());
  };
  protoOf($serializer_8).ao = function (decoder) {
    var tmp0_desc = this.y32_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.lr(tmp0_desc);
    var tmp10_cached = Companion_getInstance_9().w32_1;
    if (tmp9_input.as()) {
      tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.vr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.xr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.xr(tmp0_desc, 2, InstantIso8601Serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.vr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.xr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.mr(tmp0_desc);
    return UserVerifiableCredential_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_8).yn = function () {
    return this.y32_1;
  };
  protoOf($serializer_8).lz = function () {
    var tmp0_cached = Companion_getInstance_9().w32_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), InstantIso8601Serializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[4]];
  };
  var $serializer_instance_8;
  function $serializer_getInstance_9() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function UserVerifiableCredential_init_$Init$(seen0, localId, issuerId, issuedAt, userDefinedName, credentialResponse, serializationConstructorMarker, $this) {
    if (!(31 === (31 & seen0))) {
      throwMissingFieldException(seen0, 31, $serializer_getInstance_9().y32_1);
    }
    $this.a33_1 = localId;
    $this.b33_1 = issuerId;
    $this.c33_1 = issuedAt;
    $this.d33_1 = userDefinedName;
    $this.e33_1 = credentialResponse;
    var tmp;
    var tmp_0 = $this.e33_1;
    if (!(tmp_0 instanceof DidValidatedJwtVcJsonCredentialResponse)) {
      var tmp_1 = $this.e33_1;
      tmp = !(tmp_1 instanceof DefaultValidatedVcSdJwtCredentialResponse);
    } else {
      tmp = false;
    }
    if (tmp) {
      throw UnsupportedOperationException_init_$Create$('ValidatedCredentialResponse of this type ' + ('is not supported yet: ' + toString($this.e33_1)));
    }
    return $this;
  }
  function UserVerifiableCredential_init_$Create$(seen0, localId, issuerId, issuedAt, userDefinedName, credentialResponse, serializationConstructorMarker) {
    return UserVerifiableCredential_init_$Init$(seen0, localId, issuerId, issuedAt, userDefinedName, credentialResponse, serializationConstructorMarker, objectCreate(protoOf(UserVerifiableCredential)));
  }
  function UserVerifiableCredential(localId, issuerId, issuedAt, userDefinedName, credentialResponse) {
    Companion_getInstance_9();
    this.a33_1 = localId;
    this.b33_1 = issuerId;
    this.c33_1 = issuedAt;
    this.d33_1 = userDefinedName;
    this.e33_1 = credentialResponse;
    var tmp;
    var tmp_0 = this.e33_1;
    if (!(tmp_0 instanceof DidValidatedJwtVcJsonCredentialResponse)) {
      var tmp_1 = this.e33_1;
      tmp = !(tmp_1 instanceof DefaultValidatedVcSdJwtCredentialResponse);
    } else {
      tmp = false;
    }
    if (tmp) {
      throw UnsupportedOperationException_init_$Create$('ValidatedCredentialResponse of this type ' + ('is not supported yet: ' + toString(this.e33_1)));
    }
  }
  protoOf(UserVerifiableCredential).f33 = function (localId, issuerId, issuedAt, userDefinedName, credentialResponse) {
    return new UserVerifiableCredential(localId, issuerId, issuedAt, userDefinedName, credentialResponse);
  };
  protoOf(UserVerifiableCredential).g33 = function (localId, issuerId, issuedAt, userDefinedName, credentialResponse, $super) {
    localId = localId === VOID ? this.a33_1 : localId;
    issuerId = issuerId === VOID ? this.b33_1 : issuerId;
    issuedAt = issuedAt === VOID ? this.c33_1 : issuedAt;
    userDefinedName = userDefinedName === VOID ? this.d33_1 : userDefinedName;
    credentialResponse = credentialResponse === VOID ? this.e33_1 : credentialResponse;
    return $super === VOID ? this.f33(localId, issuerId, issuedAt, userDefinedName, credentialResponse) : $super.f33.call(this, localId, issuerId, issuedAt, userDefinedName, credentialResponse);
  };
  protoOf(UserVerifiableCredential).toString = function () {
    return 'UserVerifiableCredential(localId=' + this.a33_1 + ', issuerId=' + this.b33_1 + ', issuedAt=' + this.c33_1.toString() + ', userDefinedName=' + this.d33_1 + ', credentialResponse=' + toString(this.e33_1) + ')';
  };
  protoOf(UserVerifiableCredential).hashCode = function () {
    var result = getStringHashCode(this.a33_1);
    result = imul(result, 31) + getStringHashCode(this.b33_1) | 0;
    result = imul(result, 31) + this.c33_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.d33_1) | 0;
    result = imul(result, 31) + hashCode(this.e33_1) | 0;
    return result;
  };
  protoOf(UserVerifiableCredential).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof UserVerifiableCredential))
      return false;
    var tmp0_other_with_cast = other instanceof UserVerifiableCredential ? other : THROW_CCE();
    if (!(this.a33_1 === tmp0_other_with_cast.a33_1))
      return false;
    if (!(this.b33_1 === tmp0_other_with_cast.b33_1))
      return false;
    if (!this.c33_1.equals(tmp0_other_with_cast.c33_1))
      return false;
    if (!(this.d33_1 === tmp0_other_with_cast.d33_1))
      return false;
    if (!equals(this.e33_1, tmp0_other_with_cast.e33_1))
      return false;
    return true;
  };
  function unwrapIssuer(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwDeserializationError('Missing mandatory key "' + key + '"');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    try {
      // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
      var this_0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.dp();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(JsonIssuer), arrayOf([]), false));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp_0 = this_0.b19(tmp$ret$1, value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapOptionalProofs(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var item = tmp;
    var tmp_0;
    try {
      tmp_0 = Companion_instance.e27(item, Companion_getInstance_22().b1b());
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapOptionalCredentialStatus(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    try {
      tmp_0 = Companion_instance_55.d27(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapOptionalLogo(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    try {
      tmp_0 = Companion_instance_15.d27(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapOptionalImage(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    try {
      tmp_0 = Companion_instance_19.d27(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapCredentialDisplays(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwDeserializationError('Missing mandatory key "' + key + '"');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    if (value instanceof JsonArray) {
      var tmp_1 = asSequence(value);
      tmp_0 = toList(map(tmp_1, unwrapCredentialDisplays$lambda));
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  }
  function unwrapSupportedProofType(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    try {
      // Inline function 'kotlinx.serialization.json.decodeFromJsonElement' call
      var this_0 = Default_getInstance();
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = this_0.dp();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer(this_1, createKType(getKClass(KtMap), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gb(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(JsonProofTypesSupported), arrayOf([]), false))]), true));
      var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
      tmp_0 = this_0.b19(tmp$ret$1, value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapOptionalDisplays(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    if (value instanceof JsonArray) {
      var tmp_1 = asSequence(value);
      tmp_0 = toList(map(tmp_1, unwrapOptionalDisplays$lambda));
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  }
  function unwrapDisplays(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwDeserializationError('Missing mandatory key "' + key + '"');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    if (value instanceof JsonArray) {
      var tmp_1 = asSequence(value);
      tmp_0 = toList(map(tmp_1, unwrapDisplays$lambda));
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  }
  function throwDeserializationError(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function unwrapOptionalAlgFormat(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    try {
      tmp_0 = Companion_getInstance_64().d27(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapOptionalVcSdJwtAlgsFormat(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    try {
      tmp_0 = Companion_getInstance_67().d27(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapOptionalProofTypeFormat(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    try {
      tmp_0 = Companion_getInstance_66().d27(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        throwDeserializationError('Key "' + key + '" has an invalid value: ' + e.message);
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    return tmp_0;
  }
  function unwrapOptionalVerifiableCredentials(_this__u8e3s4, key) {
    var tmp0_elvis_lhs = _this__u8e3s4.n2(key);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp_0;
    if (value instanceof JsonArray) {
      var tmp_1 = asSequence(value);
      tmp_0 = DefaultJsonMultiValue_init_$Create$_0(toList(map(tmp_1, unwrapOptionalVerifiableCredentials$lambda(key))));
    } else {
      if (value instanceof JsonPrimitive) {
        tmp_0 = DefaultJsonMultiValue_init_$Create$(new StringCredential(get_jsonPrimitive(value).e1b()));
      } else {
        if (value instanceof JsonObject) {
          tmp_0 = DefaultJsonMultiValue_init_$Create$(new DictionaryCredential(new MapDictionary(get_jsonObject(value))));
        } else {
          throwDeserializationError('Key "' + key + '" has an invalid value.');
        }
      }
    }
    return tmp_0;
  }
  function unwrapCredentialDisplays$lambda(it) {
    return Companion_instance_16.d27(it);
  }
  function unwrapOptionalDisplays$lambda(it) {
    return Companion_instance_14.d27(it);
  }
  function unwrapDisplays$lambda(it) {
    return Companion_instance_14.d27(it);
  }
  function unwrapOptionalVerifiableCredentials$lambda($key) {
    return function (it) {
      var tmp;
      if (it instanceof JsonPrimitive) {
        tmp = new StringCredential(get_jsonPrimitive(it).e1b());
      } else {
        if (it instanceof JsonObject) {
          tmp = new DictionaryCredential(new MapDictionary(get_jsonObject(it)));
        } else {
          throwDeserializationError('Key "' + $key + '" has an invalid value.');
        }
      }
      return tmp;
    };
  }
  function Companion_10() {
    Companion_instance_12 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.l33_1 = [new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null, new LinkedHashMapSerializer(StringSerializer_getInstance(), JsonSupportedCredentialSerializer_getInstance()), null, new ArrayListSerializer(JsonIssuerDisplaySerializer_getInstance()), null, null, null];
  }
  var Companion_instance_12;
  function Companion_getInstance_10() {
    if (Companion_instance_12 == null)
      new Companion_10();
    return Companion_instance_12;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonCredentialIssuerMetadata', this, 11);
    tmp0_serialDesc.wy('authorization_servers', true);
    tmp0_serialDesc.wy('credential_endpoint', false);
    tmp0_serialDesc.wy('batch_credential_endpoint', true);
    tmp0_serialDesc.wy('deferred_credential_endpoint', true);
    tmp0_serialDesc.wy('notification_endpoint', true);
    tmp0_serialDesc.wy('credential_configurations_supported', false);
    tmp0_serialDesc.wy('credential_issuer', false);
    tmp0_serialDesc.wy('display', true);
    tmp0_serialDesc.wy('credential_response_encryption', true);
    tmp0_serialDesc.wy('credential_identifiers_supported', true);
    tmp0_serialDesc.wy('signed_metadata', true);
    this.m33_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).n33 = function (encoder, value) {
    var tmp0_desc = this.m33_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().l33_1;
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.o33_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, tmp2_cached[0], value.o33_1);
    }
    tmp1_output.zs(tmp0_desc, 1, value.p33_1);
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.q33_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.q33_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.r33_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.r33_1);
    }
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.s33_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.s33_1);
    }
    tmp1_output.bt(tmp0_desc, 5, tmp2_cached[5], value.t33_1);
    tmp1_output.zs(tmp0_desc, 6, value.u33_1);
    if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.v33_1 == null)) {
      tmp1_output.dt(tmp0_desc, 7, tmp2_cached[7], value.v33_1);
    }
    if (tmp1_output.ht(tmp0_desc, 8) ? true : !(value.w33_1 == null)) {
      tmp1_output.dt(tmp0_desc, 8, $serializer_getInstance_11(), value.w33_1);
    }
    if (tmp1_output.ht(tmp0_desc, 9) ? true : !(value.x33_1 == null)) {
      tmp1_output.dt(tmp0_desc, 9, BooleanSerializer_getInstance(), value.x33_1);
    }
    if (tmp1_output.ht(tmp0_desc, 10) ? true : !(value.y33_1 == null)) {
      tmp1_output.dt(tmp0_desc, 10, StringSerializer_getInstance(), value.y33_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_9).zn = function (encoder, value) {
    return this.n33(encoder, value instanceof JsonCredentialIssuerMetadata ? value : THROW_CCE());
  };
  protoOf($serializer_9).ao = function (decoder) {
    var tmp0_desc = this.m33_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_local10 = null;
    var tmp15_input = decoder.lr(tmp0_desc);
    var tmp16_cached = Companion_getInstance_10().l33_1;
    if (tmp15_input.as()) {
      tmp4_local0 = tmp15_input.zr(tmp0_desc, 0, tmp16_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp15_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp15_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp15_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp15_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp15_input.xr(tmp0_desc, 5, tmp16_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp15_input.vr(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp15_input.zr(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp15_input.zr(tmp0_desc, 8, $serializer_getInstance_11(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp15_input.zr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
      tmp14_local10 = tmp15_input.zr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
      tmp3_bitMask0 = tmp3_bitMask0 | 1024;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp15_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp15_input.zr(tmp0_desc, 0, tmp16_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp15_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp15_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp15_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp15_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp15_input.xr(tmp0_desc, 5, tmp16_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp15_input.vr(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp15_input.zr(tmp0_desc, 7, tmp16_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp15_input.zr(tmp0_desc, 8, $serializer_getInstance_11(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp15_input.zr(tmp0_desc, 9, BooleanSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          case 10:
            tmp14_local10 = tmp15_input.zr(tmp0_desc, 10, StringSerializer_getInstance(), tmp14_local10);
            tmp3_bitMask0 = tmp3_bitMask0 | 1024;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp15_input.mr(tmp0_desc);
    return JsonCredentialIssuerMetadata_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, tmp14_local10, null);
  };
  protoOf($serializer_9).yn = function () {
    return this.m33_1;
  };
  protoOf($serializer_9).lz = function () {
    var tmp0_cached = Companion_getInstance_10().l33_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[5], StringSerializer_getInstance(), get_nullable(tmp0_cached[7]), get_nullable($serializer_getInstance_11()), get_nullable(BooleanSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_9;
  function $serializer_getInstance_10() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function JsonCredentialIssuerMetadata_init_$Init$(seen0, authorizationServers, credentialEndpoint, batchCredentialEndpoint, deferredCredentialEndpoint, notificationEndpoint, credentialConfigurationsSupported, credentialIssuer, display, credentialResponseEncryption, credentialIdentifiersSupported, signedMetadata, serializationConstructorMarker, $this) {
    if (!(98 === (98 & seen0))) {
      throwMissingFieldException(seen0, 98, $serializer_getInstance_10().m33_1);
    }
    if (0 === (seen0 & 1))
      $this.o33_1 = null;
    else
      $this.o33_1 = authorizationServers;
    $this.p33_1 = credentialEndpoint;
    if (0 === (seen0 & 4))
      $this.q33_1 = null;
    else
      $this.q33_1 = batchCredentialEndpoint;
    if (0 === (seen0 & 8))
      $this.r33_1 = null;
    else
      $this.r33_1 = deferredCredentialEndpoint;
    if (0 === (seen0 & 16))
      $this.s33_1 = null;
    else
      $this.s33_1 = notificationEndpoint;
    $this.t33_1 = credentialConfigurationsSupported;
    $this.u33_1 = credentialIssuer;
    if (0 === (seen0 & 128))
      $this.v33_1 = null;
    else
      $this.v33_1 = display;
    if (0 === (seen0 & 256))
      $this.w33_1 = null;
    else
      $this.w33_1 = credentialResponseEncryption;
    if (0 === (seen0 & 512))
      $this.x33_1 = null;
    else
      $this.x33_1 = credentialIdentifiersSupported;
    if (0 === (seen0 & 1024))
      $this.y33_1 = null;
    else
      $this.y33_1 = signedMetadata;
    return $this;
  }
  function JsonCredentialIssuerMetadata_init_$Create$(seen0, authorizationServers, credentialEndpoint, batchCredentialEndpoint, deferredCredentialEndpoint, notificationEndpoint, credentialConfigurationsSupported, credentialIssuer, display, credentialResponseEncryption, credentialIdentifiersSupported, signedMetadata, serializationConstructorMarker) {
    return JsonCredentialIssuerMetadata_init_$Init$(seen0, authorizationServers, credentialEndpoint, batchCredentialEndpoint, deferredCredentialEndpoint, notificationEndpoint, credentialConfigurationsSupported, credentialIssuer, display, credentialResponseEncryption, credentialIdentifiersSupported, signedMetadata, serializationConstructorMarker, objectCreate(protoOf(JsonCredentialIssuerMetadata)));
  }
  function JsonCredentialIssuerMetadata(authorizationServers, credentialEndpoint, batchCredentialEndpoint, deferredCredentialEndpoint, notificationEndpoint, credentialConfigurationsSupported, credentialIssuer, display, credentialResponseEncryption, credentialIdentifiersSupported, signedMetadata) {
    Companion_getInstance_10();
    authorizationServers = authorizationServers === VOID ? null : authorizationServers;
    batchCredentialEndpoint = batchCredentialEndpoint === VOID ? null : batchCredentialEndpoint;
    deferredCredentialEndpoint = deferredCredentialEndpoint === VOID ? null : deferredCredentialEndpoint;
    notificationEndpoint = notificationEndpoint === VOID ? null : notificationEndpoint;
    display = display === VOID ? null : display;
    credentialResponseEncryption = credentialResponseEncryption === VOID ? null : credentialResponseEncryption;
    credentialIdentifiersSupported = credentialIdentifiersSupported === VOID ? null : credentialIdentifiersSupported;
    signedMetadata = signedMetadata === VOID ? null : signedMetadata;
    this.o33_1 = authorizationServers;
    this.p33_1 = credentialEndpoint;
    this.q33_1 = batchCredentialEndpoint;
    this.r33_1 = deferredCredentialEndpoint;
    this.s33_1 = notificationEndpoint;
    this.t33_1 = credentialConfigurationsSupported;
    this.u33_1 = credentialIssuer;
    this.v33_1 = display;
    this.w33_1 = credentialResponseEncryption;
    this.x33_1 = credentialIdentifiersSupported;
    this.y33_1 = signedMetadata;
  }
  protoOf(JsonCredentialIssuerMetadata).toString = function () {
    return 'JsonCredentialIssuerMetadata(authorizationServers=' + toString_0(this.o33_1) + ', credentialEndpoint=' + this.p33_1 + ', batchCredentialEndpoint=' + this.q33_1 + ', deferredCredentialEndpoint=' + this.r33_1 + ', notificationEndpoint=' + this.s33_1 + ', credentialConfigurationsSupported=' + toString(this.t33_1) + ', credentialIssuer=' + this.u33_1 + ', display=' + toString_0(this.v33_1) + ', credentialResponseEncryption=' + toString_0(this.w33_1) + ', credentialIdentifiersSupported=' + this.x33_1 + ', signedMetadata=' + this.y33_1 + ')';
  };
  protoOf(JsonCredentialIssuerMetadata).hashCode = function () {
    var result = this.o33_1 == null ? 0 : hashCode(this.o33_1);
    result = imul(result, 31) + getStringHashCode(this.p33_1) | 0;
    result = imul(result, 31) + (this.q33_1 == null ? 0 : getStringHashCode(this.q33_1)) | 0;
    result = imul(result, 31) + (this.r33_1 == null ? 0 : getStringHashCode(this.r33_1)) | 0;
    result = imul(result, 31) + (this.s33_1 == null ? 0 : getStringHashCode(this.s33_1)) | 0;
    result = imul(result, 31) + hashCode(this.t33_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.u33_1) | 0;
    result = imul(result, 31) + (this.v33_1 == null ? 0 : hashCode(this.v33_1)) | 0;
    result = imul(result, 31) + (this.w33_1 == null ? 0 : this.w33_1.hashCode()) | 0;
    result = imul(result, 31) + (this.x33_1 == null ? 0 : getBooleanHashCode(this.x33_1)) | 0;
    result = imul(result, 31) + (this.y33_1 == null ? 0 : getStringHashCode(this.y33_1)) | 0;
    return result;
  };
  protoOf(JsonCredentialIssuerMetadata).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonCredentialIssuerMetadata))
      return false;
    var tmp0_other_with_cast = other instanceof JsonCredentialIssuerMetadata ? other : THROW_CCE();
    if (!equals(this.o33_1, tmp0_other_with_cast.o33_1))
      return false;
    if (!(this.p33_1 === tmp0_other_with_cast.p33_1))
      return false;
    if (!(this.q33_1 == tmp0_other_with_cast.q33_1))
      return false;
    if (!(this.r33_1 == tmp0_other_with_cast.r33_1))
      return false;
    if (!(this.s33_1 == tmp0_other_with_cast.s33_1))
      return false;
    if (!equals(this.t33_1, tmp0_other_with_cast.t33_1))
      return false;
    if (!(this.u33_1 === tmp0_other_with_cast.u33_1))
      return false;
    if (!equals(this.v33_1, tmp0_other_with_cast.v33_1))
      return false;
    if (!equals(this.w33_1, tmp0_other_with_cast.w33_1))
      return false;
    if (!(this.x33_1 == tmp0_other_with_cast.x33_1))
      return false;
    if (!(this.y33_1 == tmp0_other_with_cast.y33_1))
      return false;
    return true;
  };
  function JsonCredentialConfigurationsSupported() {
  }
  function Companion_11() {
  }
  protoOf(Companion_11).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonIssuerDisplay'));
    return new JsonIssuerDisplay(unwrapString(map, 'name'), unwrapOptionalString(map, 'locale'), unwrapOptionalLogo(map, 'logo'), new JsonDictionary(toMap(map)));
  };
  var Companion_instance_13;
  function Companion_getInstance_11() {
    return Companion_instance_13;
  }
  function _get__serializable__azf9o3($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.e34_1;
    _serializable$factory();
    return this_0.b1();
  }
  function JsonIssuerDisplay$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.JsonIssuerDisplay._serializable$delegate.<anonymous>.<anonymous>' call
      this_0.o2(this$0.d34_1.a27());
      if (!(this$0.a34_1 == null)) {
        this_0.m2('name', toJson(this$0.a34_1));
      }
      if (!(this$0.b34_1 == null)) {
        this_0.m2('locale', toJson(this$0.b34_1));
      }
      if (!(this$0.c34_1 == null)) {
        this_0.m2('logo', this$0.c34_1.a27());
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JsonIssuerDisplay(name, locale, logo, customClaims) {
    customClaims = customClaims === VOID ? new JsonDictionary(emptyMap()) : customClaims;
    this.a34_1 = name;
    this.b34_1 = locale;
    this.c34_1 = logo;
    this.d34_1 = customClaims;
    var tmp = this;
    tmp.e34_1 = lazy(JsonIssuerDisplay$_serializable$delegate$lambda(this));
  }
  protoOf(JsonIssuerDisplay).y26 = function () {
    return _get__serializable__azf9o3(this);
  };
  protoOf(JsonIssuerDisplay).toString = function () {
    return 'JsonIssuerDisplay(name=' + this.a34_1 + ', locale=' + this.b34_1 + ', logo=' + toString_0(this.c34_1) + ', customClaims=' + toString(this.d34_1) + ')';
  };
  protoOf(JsonIssuerDisplay).hashCode = function () {
    var result = this.a34_1 == null ? 0 : getStringHashCode(this.a34_1);
    result = imul(result, 31) + (this.b34_1 == null ? 0 : getStringHashCode(this.b34_1)) | 0;
    result = imul(result, 31) + (this.c34_1 == null ? 0 : this.c34_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.d34_1) | 0;
    return result;
  };
  protoOf(JsonIssuerDisplay).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonIssuerDisplay))
      return false;
    var tmp0_other_with_cast = other instanceof JsonIssuerDisplay ? other : THROW_CCE();
    if (!(this.a34_1 == tmp0_other_with_cast.a34_1))
      return false;
    if (!(this.b34_1 == tmp0_other_with_cast.b34_1))
      return false;
    if (!equals(this.c34_1, tmp0_other_with_cast.c34_1))
      return false;
    if (!equals(this.d34_1, tmp0_other_with_cast.d34_1))
      return false;
    return true;
  };
  function Companion_12() {
  }
  protoOf(Companion_12).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonDisplayable'));
    return new JsonDisplayable(unwrapString(map, 'name'), unwrapOptionalString(map, 'locale'), new JsonDictionary(toMap(map)));
  };
  var Companion_instance_14;
  function Companion_getInstance_12() {
    return Companion_instance_14;
  }
  function _get__serializable__azf9o3_0($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.i34_1;
    _serializable$factory_0();
    return this_0.b1();
  }
  function JsonDisplayable$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.JsonDisplayable._serializable$delegate.<anonymous>.<anonymous>' call
      this_0.o2(this$0.h34_1.a27());
      if (!(this$0.f34_1 == null)) {
        this_0.m2('name', toJson(this$0.f34_1));
      }
      if (!(this$0.g34_1 == null)) {
        this_0.m2('locale', toJson(this$0.g34_1));
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JsonDisplayable(name, locale, customClaims) {
    name = name === VOID ? null : name;
    locale = locale === VOID ? null : locale;
    customClaims = customClaims === VOID ? new JsonDictionary(emptyMap()) : customClaims;
    this.f34_1 = name;
    this.g34_1 = locale;
    this.h34_1 = customClaims;
    var tmp = this;
    tmp.i34_1 = lazy(JsonDisplayable$_serializable$delegate$lambda(this));
  }
  protoOf(JsonDisplayable).y26 = function () {
    return _get__serializable__azf9o3_0(this);
  };
  protoOf(JsonDisplayable).toString = function () {
    return 'JsonDisplayable(name=' + this.f34_1 + ', locale=' + this.g34_1 + ', customClaims=' + toString(this.h34_1) + ')';
  };
  protoOf(JsonDisplayable).hashCode = function () {
    var result = this.f34_1 == null ? 0 : getStringHashCode(this.f34_1);
    result = imul(result, 31) + (this.g34_1 == null ? 0 : getStringHashCode(this.g34_1)) | 0;
    result = imul(result, 31) + hashCode(this.h34_1) | 0;
    return result;
  };
  protoOf(JsonDisplayable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonDisplayable))
      return false;
    var tmp0_other_with_cast = other instanceof JsonDisplayable ? other : THROW_CCE();
    if (!(this.f34_1 == tmp0_other_with_cast.f34_1))
      return false;
    if (!(this.g34_1 == tmp0_other_with_cast.g34_1))
      return false;
    if (!equals(this.h34_1, tmp0_other_with_cast.h34_1))
      return false;
    return true;
  };
  function Companion_13() {
  }
  protoOf(Companion_13).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonLogo'));
    return new JsonLogo(unwrapString(map, 'uri'), unwrapOptionalString(map, 'alt_text'), map.s() ? null : new JsonDictionary(toMap(map)));
  };
  var Companion_instance_15;
  function Companion_getInstance_13() {
    return Companion_instance_15;
  }
  function _get__serializable__azf9o3_1($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.m34_1;
    _serializable$factory_1();
    return this_0.b1();
  }
  function JsonLogo$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.JsonLogo._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.l34_1 == null)) {
        this_0.o2(this$0.l34_1.a27());
      }
      this_0.m2('uri', toJson(this$0.j34_1));
      if (!(this$0.k34_1 == null)) {
        this_0.m2('alt_text', toJson(this$0.k34_1));
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JsonLogo(uri, altText, customClaims) {
    altText = altText === VOID ? null : altText;
    customClaims = customClaims === VOID ? null : customClaims;
    this.j34_1 = uri;
    this.k34_1 = altText;
    this.l34_1 = customClaims;
    var tmp = this;
    tmp.m34_1 = lazy(JsonLogo$_serializable$delegate$lambda(this));
  }
  protoOf(JsonLogo).y26 = function () {
    return _get__serializable__azf9o3_1(this);
  };
  protoOf(JsonLogo).toString = function () {
    return 'JsonLogo(uri=' + this.j34_1 + ', altText=' + this.k34_1 + ', customClaims=' + toString_0(this.l34_1) + ')';
  };
  protoOf(JsonLogo).hashCode = function () {
    var result = getStringHashCode(this.j34_1);
    result = imul(result, 31) + (this.k34_1 == null ? 0 : getStringHashCode(this.k34_1)) | 0;
    result = imul(result, 31) + (this.l34_1 == null ? 0 : hashCode(this.l34_1)) | 0;
    return result;
  };
  protoOf(JsonLogo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonLogo))
      return false;
    var tmp0_other_with_cast = other instanceof JsonLogo ? other : THROW_CCE();
    if (!(this.j34_1 === tmp0_other_with_cast.j34_1))
      return false;
    if (!(this.k34_1 == tmp0_other_with_cast.k34_1))
      return false;
    if (!equals(this.l34_1, tmp0_other_with_cast.l34_1))
      return false;
    return true;
  };
  function Companion_14() {
  }
  protoOf(Companion_14).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonLogo'));
    return new JsonCredentialDisplay(unwrapString(map, 'name'), unwrapString(map, 'locale'), unwrapOptionalLogo(map, 'logo'), unwrapOptionalString(map, 'description'), unwrapOptionalString(map, 'background_color'), unwrapOptionalImage(map, 'background_image'), unwrapOptionalString(map, 'text_color'), new JsonDictionary(toMap(map)));
  };
  var Companion_instance_16;
  function Companion_getInstance_14() {
    return Companion_instance_16;
  }
  function _get__serializable__azf9o3_2($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.v34_1;
    _serializable$factory_2();
    return this_0.b1();
  }
  function JsonCredentialDisplay$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.JsonCredentialDisplay._serializable$delegate.<anonymous>.<anonymous>' call
      this_0.o2(this$0.u34_1.a27());
      this_0.m2('name', toJson(this$0.n34_1));
      if (!(this$0.o34_1 == null)) {
        this_0.m2('locale', toJson(this$0.o34_1));
      }
      if (!(this$0.p34_1 == null)) {
        this_0.m2('logo', this$0.p34_1.a27());
      }
      if (!(this$0.q34_1 == null)) {
        this_0.m2('description', toJson(this$0.q34_1));
      }
      if (!(this$0.r34_1 == null)) {
        this_0.m2('background_color', toJson(this$0.r34_1));
      }
      if (!(this$0.t34_1 == null)) {
        this_0.m2('text_color', toJson(this$0.t34_1));
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JsonCredentialDisplay(name, locale, logo, description, backgroundColor, backgroundImage, textColor, customClaims) {
    locale = locale === VOID ? null : locale;
    logo = logo === VOID ? null : logo;
    description = description === VOID ? null : description;
    backgroundColor = backgroundColor === VOID ? null : backgroundColor;
    backgroundImage = backgroundImage === VOID ? null : backgroundImage;
    textColor = textColor === VOID ? null : textColor;
    customClaims = customClaims === VOID ? new JsonDictionary(emptyMap()) : customClaims;
    this.n34_1 = name;
    this.o34_1 = locale;
    this.p34_1 = logo;
    this.q34_1 = description;
    this.r34_1 = backgroundColor;
    this.s34_1 = backgroundImage;
    this.t34_1 = textColor;
    this.u34_1 = customClaims;
    var tmp = this;
    tmp.v34_1 = lazy(JsonCredentialDisplay$_serializable$delegate$lambda(this));
  }
  protoOf(JsonCredentialDisplay).y26 = function () {
    return _get__serializable__azf9o3_2(this);
  };
  protoOf(JsonCredentialDisplay).toString = function () {
    return 'JsonCredentialDisplay(name=' + this.n34_1 + ', locale=' + this.o34_1 + ', logo=' + toString_0(this.p34_1) + ', description=' + this.q34_1 + ', backgroundColor=' + this.r34_1 + ', backgroundImage=' + toString_0(this.s34_1) + ', textColor=' + this.t34_1 + ', customClaims=' + toString(this.u34_1) + ')';
  };
  protoOf(JsonCredentialDisplay).hashCode = function () {
    var result = getStringHashCode(this.n34_1);
    result = imul(result, 31) + (this.o34_1 == null ? 0 : getStringHashCode(this.o34_1)) | 0;
    result = imul(result, 31) + (this.p34_1 == null ? 0 : this.p34_1.hashCode()) | 0;
    result = imul(result, 31) + (this.q34_1 == null ? 0 : getStringHashCode(this.q34_1)) | 0;
    result = imul(result, 31) + (this.r34_1 == null ? 0 : getStringHashCode(this.r34_1)) | 0;
    result = imul(result, 31) + (this.s34_1 == null ? 0 : hashCode(this.s34_1)) | 0;
    result = imul(result, 31) + (this.t34_1 == null ? 0 : getStringHashCode(this.t34_1)) | 0;
    result = imul(result, 31) + hashCode(this.u34_1) | 0;
    return result;
  };
  protoOf(JsonCredentialDisplay).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonCredentialDisplay))
      return false;
    var tmp0_other_with_cast = other instanceof JsonCredentialDisplay ? other : THROW_CCE();
    if (!(this.n34_1 === tmp0_other_with_cast.n34_1))
      return false;
    if (!(this.o34_1 == tmp0_other_with_cast.o34_1))
      return false;
    if (!equals(this.p34_1, tmp0_other_with_cast.p34_1))
      return false;
    if (!(this.q34_1 == tmp0_other_with_cast.q34_1))
      return false;
    if (!(this.r34_1 == tmp0_other_with_cast.r34_1))
      return false;
    if (!equals(this.s34_1, tmp0_other_with_cast.s34_1))
      return false;
    if (!(this.t34_1 == tmp0_other_with_cast.t34_1))
      return false;
    if (!equals(this.u34_1, tmp0_other_with_cast.u34_1))
      return false;
    return true;
  };
  function Companion_15() {
  }
  protoOf(Companion_15).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonSupportedCredential'));
    var tmp1_format = unwrapString(map, 'format');
    var tmp2_cryptographicBindingMethodsSupported = unwrapOptionalStringList(map, 'cryptographic_binding_methods_supported');
    var tmp3_display = unwrapCredentialDisplays(map, 'display');
    var tmp4_customClaims = map.s() ? null : new JsonDictionary(toMap(map));
    var tmp5_scope = unwrapOptionalString(map, 'scope');
    var tmp6_proofTypesSupported = unwrapSupportedProofType(map, 'proof_types_supported');
    var tmp7_credentialSigningAlgValuesSupported = unwrapOptionalStringList(map, 'credential_signing_alg_values_supported');
    return new DefaultJsonCredentialConfigurationsSupported(tmp1_format, tmp2_cryptographicBindingMethodsSupported, tmp3_display, tmp4_customClaims, tmp5_scope, tmp7_credentialSigningAlgValuesSupported, tmp6_proofTypesSupported);
  };
  protoOf(Companion_15).b1b = function () {
    return DefaultJsonSupportedCredentialSerializer_getInstance();
  };
  var Companion_instance_17;
  function Companion_getInstance_15() {
    return Companion_instance_17;
  }
  function _get__serializable__azf9o3_3($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.d35_1;
    _serializable$factory_3();
    return this_0.b1();
  }
  function DefaultJsonCredentialConfigurationsSupported$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.DefaultJsonCredentialConfigurationsSupported._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.z34_1 == null)) {
        this_0.o2(this$0.z34_1.a27());
      }
      this_0.m2('format', toJson(this$0.w34_1));
      if (!(this$0.x34_1 == null)) {
        this_0.m2('cryptographic_binding_methods_supported', toJson_1(this$0.x34_1));
      }
      if (!(this$0.y34_1 == null)) {
        this_0.m2('display', toJsons(this$0.y34_1));
      }
      if (!(this$0.a35_1 == null)) {
        this_0.m2('scope', toJson(this$0.a35_1));
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function DefaultJsonCredentialConfigurationsSupported(format, cryptographicBindingMethodsSupported, display, customClaims, scope, credentialSigningAlgValuesSupported, proofTypesSupported) {
    display = display === VOID ? null : display;
    customClaims = customClaims === VOID ? null : customClaims;
    this.w34_1 = format;
    this.x34_1 = cryptographicBindingMethodsSupported;
    this.y34_1 = display;
    this.z34_1 = customClaims;
    this.a35_1 = scope;
    this.b35_1 = credentialSigningAlgValuesSupported;
    this.c35_1 = proofTypesSupported;
    var tmp = this;
    tmp.d35_1 = lazy(DefaultJsonCredentialConfigurationsSupported$_serializable$delegate$lambda(this));
  }
  protoOf(DefaultJsonCredentialConfigurationsSupported).z33 = function () {
    return this.w34_1;
  };
  protoOf(DefaultJsonCredentialConfigurationsSupported).y26 = function () {
    return _get__serializable__azf9o3_3(this);
  };
  protoOf(DefaultJsonCredentialConfigurationsSupported).toString = function () {
    return 'DefaultJsonCredentialConfigurationsSupported(format=' + this.w34_1 + ', cryptographicBindingMethodsSupported=' + toString_0(this.x34_1) + ', display=' + toString_0(this.y34_1) + ', customClaims=' + toString_0(this.z34_1) + ', scope=' + this.a35_1 + ', credentialSigningAlgValuesSupported=' + toString_0(this.b35_1) + ', proofTypesSupported=' + toString_0(this.c35_1) + ')';
  };
  protoOf(DefaultJsonCredentialConfigurationsSupported).hashCode = function () {
    var result = getStringHashCode(this.w34_1);
    result = imul(result, 31) + (this.x34_1 == null ? 0 : hashCode(this.x34_1)) | 0;
    result = imul(result, 31) + (this.y34_1 == null ? 0 : hashCode(this.y34_1)) | 0;
    result = imul(result, 31) + (this.z34_1 == null ? 0 : hashCode(this.z34_1)) | 0;
    result = imul(result, 31) + (this.a35_1 == null ? 0 : getStringHashCode(this.a35_1)) | 0;
    result = imul(result, 31) + (this.b35_1 == null ? 0 : hashCode(this.b35_1)) | 0;
    result = imul(result, 31) + (this.c35_1 == null ? 0 : hashCode(this.c35_1)) | 0;
    return result;
  };
  protoOf(DefaultJsonCredentialConfigurationsSupported).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DefaultJsonCredentialConfigurationsSupported))
      return false;
    var tmp0_other_with_cast = other instanceof DefaultJsonCredentialConfigurationsSupported ? other : THROW_CCE();
    if (!(this.w34_1 === tmp0_other_with_cast.w34_1))
      return false;
    if (!equals(this.x34_1, tmp0_other_with_cast.x34_1))
      return false;
    if (!equals(this.y34_1, tmp0_other_with_cast.y34_1))
      return false;
    if (!equals(this.z34_1, tmp0_other_with_cast.z34_1))
      return false;
    if (!(this.a35_1 == tmp0_other_with_cast.a35_1))
      return false;
    if (!equals(this.b35_1, tmp0_other_with_cast.b35_1))
      return false;
    if (!equals(this.c35_1, tmp0_other_with_cast.c35_1))
      return false;
    return true;
  };
  function Companion_16() {
    Companion_instance_18 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e35_1 = [new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_18;
  function Companion_getInstance_16() {
    if (Companion_instance_18 == null)
      new Companion_16();
    return Companion_instance_18;
  }
  function $serializer_10() {
    $serializer_instance_10 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.DefaultCredentialResponseEncryption', this, 3);
    tmp0_serialDesc.wy('alg_values_supported', false);
    tmp0_serialDesc.wy('enc_values_supported', false);
    tmp0_serialDesc.wy('encryption_required', false);
    this.f35_1 = tmp0_serialDesc;
  }
  protoOf($serializer_10).g35 = function (encoder, value) {
    var tmp0_desc = this.f35_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_16().e35_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.h35_1);
    tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.i35_1);
    tmp1_output.rs(tmp0_desc, 2, value.j35_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_10).zn = function (encoder, value) {
    return this.g35(encoder, value instanceof DefaultCredentialResponseEncryption ? value : THROW_CCE());
  };
  protoOf($serializer_10).ao = function (decoder) {
    var tmp0_desc = this.f35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = false;
    var tmp7_input = decoder.lr(tmp0_desc);
    var tmp8_cached = Companion_getInstance_16().e35_1;
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.nr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, tmp8_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, tmp8_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.nr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return DefaultCredentialResponseEncryption_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_10).yn = function () {
    return this.f35_1;
  };
  protoOf($serializer_10).lz = function () {
    var tmp0_cached = Companion_getInstance_16().e35_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1], BooleanSerializer_getInstance()];
  };
  var $serializer_instance_10;
  function $serializer_getInstance_11() {
    if ($serializer_instance_10 == null)
      new $serializer_10();
    return $serializer_instance_10;
  }
  function DefaultCredentialResponseEncryption_init_$Init$(seen0, algValuesSupported, encValuesSupported, encryptionRequired, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_11().f35_1);
    }
    $this.h35_1 = algValuesSupported;
    $this.i35_1 = encValuesSupported;
    $this.j35_1 = encryptionRequired;
    return $this;
  }
  function DefaultCredentialResponseEncryption_init_$Create$(seen0, algValuesSupported, encValuesSupported, encryptionRequired, serializationConstructorMarker) {
    return DefaultCredentialResponseEncryption_init_$Init$(seen0, algValuesSupported, encValuesSupported, encryptionRequired, serializationConstructorMarker, objectCreate(protoOf(DefaultCredentialResponseEncryption)));
  }
  function DefaultCredentialResponseEncryption() {
  }
  protoOf(DefaultCredentialResponseEncryption).toString = function () {
    return 'DefaultCredentialResponseEncryption(algValuesSupported=' + toString(this.h35_1) + ', encValuesSupported=' + toString(this.i35_1) + ', encryptionRequired=' + this.j35_1 + ')';
  };
  protoOf(DefaultCredentialResponseEncryption).hashCode = function () {
    var result = hashCode(this.h35_1);
    result = imul(result, 31) + hashCode(this.i35_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j35_1) | 0;
    return result;
  };
  protoOf(DefaultCredentialResponseEncryption).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DefaultCredentialResponseEncryption))
      return false;
    var tmp0_other_with_cast = other instanceof DefaultCredentialResponseEncryption ? other : THROW_CCE();
    if (!equals(this.h35_1, tmp0_other_with_cast.h35_1))
      return false;
    if (!equals(this.i35_1, tmp0_other_with_cast.i35_1))
      return false;
    if (!(this.j35_1 === tmp0_other_with_cast.j35_1))
      return false;
    return true;
  };
  function Companion_17() {
  }
  protoOf(Companion_17).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonImage'));
    return new JsonImage(unwrapString(map, 'uri'));
  };
  var Companion_instance_19;
  function Companion_getInstance_17() {
    return Companion_instance_19;
  }
  function _get__serializable__azf9o3_4($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.l35_1;
    _serializable$factory_4();
    return this_0.b1();
  }
  function JsonImage$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.JsonImage._serializable$delegate.<anonymous>.<anonymous>' call
      this_0.m2('uri', toJson(this$0.k35_1));
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JsonImage(uri) {
    this.k35_1 = uri;
    var tmp = this;
    tmp.l35_1 = lazy(JsonImage$_serializable$delegate$lambda(this));
  }
  protoOf(JsonImage).y26 = function () {
    return _get__serializable__azf9o3_4(this);
  };
  protoOf(JsonImage).toString = function () {
    return 'JsonImage(uri=' + this.k35_1 + ')';
  };
  protoOf(JsonImage).hashCode = function () {
    return getStringHashCode(this.k35_1);
  };
  protoOf(JsonImage).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonImage))
      return false;
    var tmp0_other_with_cast = other instanceof JsonImage ? other : THROW_CCE();
    if (!(this.k35_1 === tmp0_other_with_cast.k35_1))
      return false;
    return true;
  };
  function Companion_18() {
    Companion_instance_20 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.m35_1 = [new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_20;
  function Companion_getInstance_18() {
    if (Companion_instance_20 == null)
      new Companion_18();
    return Companion_instance_20;
  }
  function $serializer_11() {
    $serializer_instance_11 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonProofTypesSupported', this, 1);
    tmp0_serialDesc.wy('proof_signing_alg_values_supported', false);
    this.n35_1 = tmp0_serialDesc;
  }
  protoOf($serializer_11).o35 = function (encoder, value) {
    var tmp0_desc = this.n35_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_18().m35_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.p35_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_11).zn = function (encoder, value) {
    return this.o35(encoder, value instanceof JsonProofTypesSupported ? value : THROW_CCE());
  };
  protoOf($serializer_11).ao = function (decoder) {
    var tmp0_desc = this.n35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    var tmp6_cached = Companion_getInstance_18().m35_1;
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return JsonProofTypesSupported_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_11).yn = function () {
    return this.n35_1;
  };
  protoOf($serializer_11).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_18().m35_1[0]];
  };
  var $serializer_instance_11;
  function $serializer_getInstance_12() {
    if ($serializer_instance_11 == null)
      new $serializer_11();
    return $serializer_instance_11;
  }
  function JsonProofTypesSupported_init_$Init$(seen0, proofSigningAlgValuesSupported, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_12().n35_1);
    }
    $this.p35_1 = proofSigningAlgValuesSupported;
    return $this;
  }
  function JsonProofTypesSupported_init_$Create$(seen0, proofSigningAlgValuesSupported, serializationConstructorMarker) {
    return JsonProofTypesSupported_init_$Init$(seen0, proofSigningAlgValuesSupported, serializationConstructorMarker, objectCreate(protoOf(JsonProofTypesSupported)));
  }
  function JsonProofTypesSupported(proofSigningAlgValuesSupported) {
    Companion_getInstance_18();
    this.p35_1 = proofSigningAlgValuesSupported;
  }
  protoOf(JsonProofTypesSupported).toString = function () {
    return 'JsonProofTypesSupported(proofSigningAlgValuesSupported=' + toString(this.p35_1) + ')';
  };
  protoOf(JsonProofTypesSupported).hashCode = function () {
    return hashCode(this.p35_1);
  };
  protoOf(JsonProofTypesSupported).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonProofTypesSupported))
      return false;
    var tmp0_other_with_cast = other instanceof JsonProofTypesSupported ? other : THROW_CCE();
    if (!equals(this.p35_1, tmp0_other_with_cast.p35_1))
      return false;
    return true;
  };
  function _serializable$factory() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3(receiver);
    }, null);
  }
  function _serializable$factory_0() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_0(receiver);
    }, null);
  }
  function _serializable$factory_1() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_1(receiver);
    }, null);
  }
  function _serializable$factory_2() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_2(receiver);
    }, null);
  }
  function _serializable$factory_3() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_3(receiver);
    }, null);
  }
  function _serializable$factory_4() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_4(receiver);
    }, null);
  }
  function Companion_19() {
  }
  var Companion_instance_21;
  function Companion_getInstance_19() {
    return Companion_instance_21;
  }
  function $serializer_12() {
    $serializer_instance_12 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonOAuthMetadata', this, 2);
    tmp0_serialDesc.wy('authorization_endpoint', false);
    tmp0_serialDesc.wy('token_endpoint', false);
    this.q35_1 = tmp0_serialDesc;
  }
  protoOf($serializer_12).r35 = function (encoder, value) {
    var tmp0_desc = this.q35_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.s35_1);
    tmp1_output.zs(tmp0_desc, 1, value.t35_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_12).zn = function (encoder, value) {
    return this.r35(encoder, value instanceof JsonOAuthMetadata ? value : THROW_CCE());
  };
  protoOf($serializer_12).ao = function (decoder) {
    var tmp0_desc = this.q35_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonOAuthMetadata_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_12).yn = function () {
    return this.q35_1;
  };
  protoOf($serializer_12).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_12;
  function $serializer_getInstance_13() {
    if ($serializer_instance_12 == null)
      new $serializer_12();
    return $serializer_instance_12;
  }
  function JsonOAuthMetadata_init_$Init$(seen0, authorizationEndpoint, tokenEndpoint, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_13().q35_1);
    }
    $this.s35_1 = authorizationEndpoint;
    $this.t35_1 = tokenEndpoint;
    return $this;
  }
  function JsonOAuthMetadata_init_$Create$(seen0, authorizationEndpoint, tokenEndpoint, serializationConstructorMarker) {
    return JsonOAuthMetadata_init_$Init$(seen0, authorizationEndpoint, tokenEndpoint, serializationConstructorMarker, objectCreate(protoOf(JsonOAuthMetadata)));
  }
  function JsonOAuthMetadata(authorizationEndpoint, tokenEndpoint) {
    this.s35_1 = authorizationEndpoint;
    this.t35_1 = tokenEndpoint;
  }
  protoOf(JsonOAuthMetadata).toString = function () {
    return 'JsonOAuthMetadata(authorizationEndpoint=' + this.s35_1 + ', tokenEndpoint=' + this.t35_1 + ')';
  };
  protoOf(JsonOAuthMetadata).hashCode = function () {
    var result = getStringHashCode(this.s35_1);
    result = imul(result, 31) + getStringHashCode(this.t35_1) | 0;
    return result;
  };
  protoOf(JsonOAuthMetadata).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonOAuthMetadata))
      return false;
    var tmp0_other_with_cast = other instanceof JsonOAuthMetadata ? other : THROW_CCE();
    if (!(this.s35_1 === tmp0_other_with_cast.s35_1))
      return false;
    if (!(this.t35_1 === tmp0_other_with_cast.t35_1))
      return false;
    return true;
  };
  function Companion_20() {
    Companion_instance_22 = this;
    CompositeFromJson.call(this, Companion_getInstance_21());
    this.v35_1 = 'jwt';
  }
  protoOf(Companion_20).w35 = function (toJson) {
    var serialized = toJson.z35();
    var type = toJson.x35_1;
    var tmp;
    if (serialized.x35_1 === 'jwt') {
      var tmp0_elvis_lhs = serialized.y35_1;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        var message = 'Missing the "jwt" claim';
        throw IllegalStateException_init_$Create$(toString(message));
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var customClaims = tmp_0;
      var tmp_1;
      if (customClaims.f2().m() === 1 && first(customClaims.f2()) === 'jwt') {
        var jwt = customClaims.vl('jwt');
        var tmp_2;
        var tmp_3;
        if (jwt instanceof JsonPrimitive) {
          tmp_3 = jwt.d1b();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp_2 = new JwtProofOfPossession(jwt.e1b());
        } else {
          var message_0 = '"jwt" is not a String';
          throw IllegalStateException_init_$Create$(toString(message_0));
        }
        tmp_1 = tmp_2;
      } else {
        var message_1 = 'Expected a single "jwt" custom claim but got \'' + toString(serialized.y35_1.f2()) + "'";
        throw IllegalStateException_init_$Create$(toString(message_1));
      }
      tmp = tmp_1;
    } else {
      var message_2 = 'Unexpected "proof_type": \'' + type + "'";
      throw IllegalStateException_init_$Create$(toString(message_2));
    }
    return tmp;
  };
  protoOf(Companion_20).n27 = function (toJson) {
    return this.w35(toJson instanceof JsonProofOfPossession ? toJson : THROW_CCE());
  };
  var Companion_instance_22;
  function Companion_getInstance_20() {
    if (Companion_instance_22 == null)
      new Companion_20();
    return Companion_instance_22;
  }
  function _get__serialized__5dtwz6($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.c36_1;
    _serialized$factory();
    return this_0.b1();
  }
  function JwtProofOfPossession$_serialized$delegate$lambda(this$0) {
    return function () {
      return mapOf([to('proof_type', JsonPrimitive_0('jwt')), to('jwt', JsonPrimitive_0(this$0.a36_1))]);
    };
  }
  function JwtProofOfPossession(_jwt) {
    Companion_getInstance_20();
    this.a36_1 = _jwt;
    this.b36_1 = 'jwt';
    var tmp = this;
    tmp.c36_1 = lazy(JwtProofOfPossession$_serialized$delegate$lambda(this));
  }
  protoOf(JwtProofOfPossession).xl = function () {
    return _get__serialized__5dtwz6(this);
  };
  protoOf(JwtProofOfPossession).y26 = function () {
    return new JsonDictionary(this.xl());
  };
  protoOf(JwtProofOfPossession).z35 = function () {
    return new JsonProofOfPossession('jwt', new JsonDictionary(mapOf_0(to('jwt', JsonPrimitive_0(this.a36_1)))));
  };
  protoOf(JwtProofOfPossession).toString = function () {
    return 'JwtProofOfPossession(_jwt=' + this.a36_1 + ')';
  };
  protoOf(JwtProofOfPossession).hashCode = function () {
    return getStringHashCode(this.a36_1);
  };
  protoOf(JwtProofOfPossession).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtProofOfPossession))
      return false;
    var tmp0_other_with_cast = other instanceof JwtProofOfPossession ? other : THROW_CCE();
    if (!(this.a36_1 === tmp0_other_with_cast.a36_1))
      return false;
    return true;
  };
  function Companion_21() {
    Companion_instance_23 = this;
    this.d36_1 = new TypedDictionaryFromJson('proof_type');
  }
  protoOf(Companion_21).d27 = function (json) {
    var typedDictionary = this.d36_1.d27(json);
    return new JsonProofOfPossession(typedDictionary.r27_1, typedDictionary.s27_1);
  };
  var Companion_instance_23;
  function Companion_getInstance_21() {
    if (Companion_instance_23 == null)
      new Companion_21();
    return Companion_instance_23;
  }
  function JsonProofOfPossession(proofType, customClaims) {
    Companion_getInstance_21();
    customClaims = customClaims === VOID ? null : customClaims;
    this.x35_1 = proofType;
    this.y35_1 = customClaims;
  }
  protoOf(JsonProofOfPossession).y26 = function () {
    return Companion_getInstance_21().d36_1.p27(this.x35_1, this.y35_1);
  };
  protoOf(JsonProofOfPossession).z35 = function () {
    return this;
  };
  protoOf(JsonProofOfPossession).toString = function () {
    return 'JsonProofOfPossession(proofType=' + this.x35_1 + ', customClaims=' + toString_0(this.y35_1) + ')';
  };
  protoOf(JsonProofOfPossession).hashCode = function () {
    var result = getStringHashCode(this.x35_1);
    result = imul(result, 31) + (this.y35_1 == null ? 0 : this.y35_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonProofOfPossession).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonProofOfPossession))
      return false;
    var tmp0_other_with_cast = other instanceof JsonProofOfPossession ? other : THROW_CCE();
    if (!(this.x35_1 === tmp0_other_with_cast.x35_1))
      return false;
    if (!equals(this.y35_1, tmp0_other_with_cast.y35_1))
      return false;
    return true;
  };
  function Companion_22() {
    Companion_instance_24 = this;
    this.h33_1 = new TypedDictionaryFromJson('type');
  }
  protoOf(Companion_22).d27 = function (json) {
    var typedDictionary = this.h33_1.d27(json);
    return new JsonProof(typedDictionary.r27_1, typedDictionary.s27_1);
  };
  protoOf(Companion_22).b1b = function () {
    return JsonProofSerializer_getInstance();
  };
  var Companion_instance_24;
  function Companion_getInstance_22() {
    if (Companion_instance_24 == null)
      new Companion_22();
    return Companion_instance_24;
  }
  function JsonProof(type, customClaims) {
    Companion_getInstance_22();
    customClaims = customClaims === VOID ? null : customClaims;
    this.e36_1 = type;
    this.f36_1 = customClaims;
  }
  protoOf(JsonProof).g36 = function () {
    return this.e36_1;
  };
  protoOf(JsonProof).y26 = function () {
    return Companion_getInstance_22().h33_1.p27(this.e36_1, this.f36_1);
  };
  protoOf(JsonProof).toString = function () {
    return 'JsonProof(type=' + this.e36_1 + ', customClaims=' + toString_0(this.f36_1) + ')';
  };
  protoOf(JsonProof).hashCode = function () {
    var result = getStringHashCode(this.e36_1);
    result = imul(result, 31) + (this.f36_1 == null ? 0 : this.f36_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonProof).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonProof))
      return false;
    var tmp0_other_with_cast = other instanceof JsonProof ? other : THROW_CCE();
    if (!(this.e36_1 === tmp0_other_with_cast.e36_1))
      return false;
    if (!equals(this.f36_1, tmp0_other_with_cast.f36_1))
      return false;
    return true;
  };
  function _serialized$factory() {
    return getPropertyCallableRef('_serialized', 1, KProperty1, function (receiver) {
      return _get__serialized__5dtwz6(receiver);
    }, null);
  }
  function Companion_23() {
  }
  protoOf(Companion_23).b1b = function () {
    return $serializer_getInstance_14();
  };
  var Companion_instance_25;
  function Companion_getInstance_23() {
    return Companion_instance_25;
  }
  function $serializer_13() {
    $serializer_instance_13 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JsonDeferredCredentialResponse', this, 3);
    tmp0_serialDesc.wy('transaction_id', false);
    tmp0_serialDesc.wy('c_nonce', true);
    tmp0_serialDesc.wy('c_nonce_expires_in', true);
    this.h36_1 = tmp0_serialDesc;
  }
  protoOf($serializer_13).i36 = function (encoder, value) {
    var tmp0_desc = this.h36_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.j36_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.k36_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.k36_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.l36_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.l36_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_13).zn = function (encoder, value) {
    return this.i36(encoder, value instanceof JsonDeferredCredentialResponse ? value : THROW_CCE());
  };
  protoOf($serializer_13).ao = function (decoder) {
    var tmp0_desc = this.h36_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JsonDeferredCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_13).yn = function () {
    return this.h36_1;
  };
  protoOf($serializer_13).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_13;
  function $serializer_getInstance_14() {
    if ($serializer_instance_13 == null)
      new $serializer_13();
    return $serializer_instance_13;
  }
  function JsonDeferredCredentialResponse_init_$Init$(seen0, transactionId, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_14().h36_1);
    }
    $this.j36_1 = transactionId;
    if (0 === (seen0 & 2))
      $this.k36_1 = null;
    else
      $this.k36_1 = cNonce;
    if (0 === (seen0 & 4))
      $this.l36_1 = null;
    else
      $this.l36_1 = cNonceExpiresIn;
    return $this;
  }
  function JsonDeferredCredentialResponse_init_$Create$(seen0, transactionId, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
    return JsonDeferredCredentialResponse_init_$Init$(seen0, transactionId, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(JsonDeferredCredentialResponse)));
  }
  function JsonDeferredCredentialResponse() {
  }
  protoOf(JsonDeferredCredentialResponse).toString = function () {
    return 'JsonDeferredCredentialResponse(transactionId=' + this.j36_1 + ', cNonce=' + this.k36_1 + ', cNonceExpiresIn=' + toString_0(this.l36_1) + ')';
  };
  protoOf(JsonDeferredCredentialResponse).hashCode = function () {
    var result = getStringHashCode(this.j36_1);
    result = imul(result, 31) + (this.k36_1 == null ? 0 : getStringHashCode(this.k36_1)) | 0;
    result = imul(result, 31) + (this.l36_1 == null ? 0 : this.l36_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonDeferredCredentialResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonDeferredCredentialResponse))
      return false;
    var tmp0_other_with_cast = other instanceof JsonDeferredCredentialResponse ? other : THROW_CCE();
    if (!(this.j36_1 === tmp0_other_with_cast.j36_1))
      return false;
    if (!(this.k36_1 == tmp0_other_with_cast.k36_1))
      return false;
    if (!equals(this.l36_1, tmp0_other_with_cast.l36_1))
      return false;
    return true;
  };
  function ToJsonProofOfPossessionSerializer$_init_$lambda_79iudd(toJson) {
    return toJson.z35();
  }
  function ToJsonProofOfPossessionSerializer() {
    ToJsonProofOfPossessionSerializer_instance = this;
    var tmp = JsonProofOfPossessionSerializer_getInstance();
    DelegateSerializer.call(this, tmp, ToJsonProofOfPossessionSerializer$_init_$lambda_79iudd);
  }
  var ToJsonProofOfPossessionSerializer_instance;
  function ToJsonProofOfPossessionSerializer_getInstance() {
    if (ToJsonProofOfPossessionSerializer_instance == null)
      new ToJsonProofOfPossessionSerializer();
    return ToJsonProofOfPossessionSerializer_instance;
  }
  function BasicCredentialSubjectSerializer() {
    BasicCredentialSubjectSerializer_instance = this;
    JsonSerializer.call(this, Companion_getInstance_44());
  }
  var BasicCredentialSubjectSerializer_instance;
  function BasicCredentialSubjectSerializer_getInstance() {
    if (BasicCredentialSubjectSerializer_instance == null)
      new BasicCredentialSubjectSerializer();
    return BasicCredentialSubjectSerializer_instance;
  }
  function JwtProofOfPossessionSerializer() {
    JwtProofOfPossessionSerializer_instance = this;
    JsonSerializer.call(this, Companion_getInstance_20());
  }
  var JwtProofOfPossessionSerializer_instance;
  function JwtProofOfPossessionSerializer_getInstance() {
    if (JwtProofOfPossessionSerializer_instance == null)
      new JwtProofOfPossessionSerializer();
    return JwtProofOfPossessionSerializer_instance;
  }
  function JsonProofOfPossessionSerializer() {
    JsonProofOfPossessionSerializer_instance = this;
    JsonSerializer.call(this, Companion_getInstance_21());
  }
  var JsonProofOfPossessionSerializer_instance;
  function JsonProofOfPossessionSerializer_getInstance() {
    if (JsonProofOfPossessionSerializer_instance == null)
      new JsonProofOfPossessionSerializer();
    return JsonProofOfPossessionSerializer_instance;
  }
  function JsonProofSerializer() {
    JsonProofSerializer_instance = this;
    JsonSerializer.call(this, Companion_getInstance_22());
  }
  var JsonProofSerializer_instance;
  function JsonProofSerializer_getInstance() {
    if (JsonProofSerializer_instance == null)
      new JsonProofSerializer();
    return JsonProofSerializer_instance;
  }
  function SerializableW3CVerifiableCredentialSerializer() {
    SerializableW3CVerifiableCredentialSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_54);
  }
  var SerializableW3CVerifiableCredentialSerializer_instance;
  function SerializableW3CVerifiableCredentialSerializer_getInstance() {
    if (SerializableW3CVerifiableCredentialSerializer_instance == null)
      new SerializableW3CVerifiableCredentialSerializer();
    return SerializableW3CVerifiableCredentialSerializer_instance;
  }
  function JsonCredentialStatusSerializer() {
    JsonCredentialStatusSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_55);
  }
  var JsonCredentialStatusSerializer_instance;
  function JsonCredentialStatusSerializer_getInstance() {
    if (JsonCredentialStatusSerializer_instance == null)
      new JsonCredentialStatusSerializer();
    return JsonCredentialStatusSerializer_instance;
  }
  function JsonIssuerSerializer$_stringSerializer$lambda(it) {
    return it.m36_1;
  }
  function JsonIssuerSerializer$_stringSerializer$lambda_0(it) {
    return new IssuerURI_0(it);
  }
  function JsonIssuerSerializer$_objectSerializer$1() {
    JsonSerializer.call(this, Companion_instance_56);
  }
  function JsonIssuerSerializer() {
    JsonIssuerSerializer_instance = this;
    JsonContentPolymorphicSerializer.call(this, getKClass(JsonIssuer));
    var tmp = this;
    var tmp_0 = serializer_0(StringCompanionObject_instance);
    var tmp_1 = JsonIssuerSerializer$_stringSerializer$lambda;
    tmp.p36_1 = new DerivedSerializer(tmp_0, tmp_1, JsonIssuerSerializer$_stringSerializer$lambda_0);
    var tmp_2 = this;
    tmp_2.q36_1 = new JsonIssuerSerializer$_objectSerializer$1();
  }
  protoOf(JsonIssuerSerializer).z1a = function (element) {
    var tmp;
    if (element instanceof JsonPrimitive) {
      tmp = this.p36_1;
    } else {
      tmp = this.q36_1;
    }
    return tmp;
  };
  var JsonIssuerSerializer_instance;
  function JsonIssuerSerializer_getInstance() {
    if (JsonIssuerSerializer_instance == null)
      new JsonIssuerSerializer();
    return JsonIssuerSerializer_instance;
  }
  function JsonIssuerDisplaySerializer() {
    JsonIssuerDisplaySerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_13);
  }
  var JsonIssuerDisplaySerializer_instance;
  function JsonIssuerDisplaySerializer_getInstance() {
    if (JsonIssuerDisplaySerializer_instance == null)
      new JsonIssuerDisplaySerializer();
    return JsonIssuerDisplaySerializer_instance;
  }
  function JsonDisplayableSerializer() {
    JsonDisplayableSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_14);
  }
  var JsonDisplayableSerializer_instance;
  function JsonDisplayableSerializer_getInstance() {
    if (JsonDisplayableSerializer_instance == null)
      new JsonDisplayableSerializer();
    return JsonDisplayableSerializer_instance;
  }
  function JsonLogoSerializer() {
    JsonLogoSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_15);
  }
  var JsonLogoSerializer_instance;
  function JsonLogoSerializer_getInstance() {
    if (JsonLogoSerializer_instance == null)
      new JsonLogoSerializer();
    return JsonLogoSerializer_instance;
  }
  function JsonCredentialDisplaySerializer() {
    JsonCredentialDisplaySerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_16);
  }
  var JsonCredentialDisplaySerializer_instance;
  function JsonCredentialDisplaySerializer_getInstance() {
    if (JsonCredentialDisplaySerializer_instance == null)
      new JsonCredentialDisplaySerializer();
    return JsonCredentialDisplaySerializer_instance;
  }
  function DefaultJsonSupportedCredentialSerializer() {
    DefaultJsonSupportedCredentialSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_17);
  }
  var DefaultJsonSupportedCredentialSerializer_instance;
  function DefaultJsonSupportedCredentialSerializer_getInstance() {
    if (DefaultJsonSupportedCredentialSerializer_instance == null)
      new DefaultJsonSupportedCredentialSerializer();
    return DefaultJsonSupportedCredentialSerializer_instance;
  }
  function JsonImageSerializer() {
    JsonImageSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_19);
  }
  var JsonImageSerializer_instance;
  function JsonImageSerializer_getInstance() {
    if (JsonImageSerializer_instance == null)
      new JsonImageSerializer();
    return JsonImageSerializer_instance;
  }
  function VerifiableCredentialResponseSerializer(baseClass, _format, deferredSerializer, synchronousSerializer) {
    JsonContentPolymorphicSerializer.call(this, baseClass);
    this.t36_1 = _format;
    this.u36_1 = deferredSerializer;
    this.v36_1 = synchronousSerializer;
    var tmp = this;
    var tmp0_elvis_lhs = baseClass.fa();
    tmp.w36_1 = tmp0_elvis_lhs == null ? 'VerifiableCredentialResponse' : tmp0_elvis_lhs;
  }
  protoOf(VerifiableCredentialResponseSerializer).z1a = function (element) {
    var response = FromJsonHelper_instance.b27(element, this.w36_1);
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var key = 'transaction_id';
    if ((isInterface(response, KtMap) ? response : THROW_CCE()).c2(key)) {
      tmp = this.u36_1;
    } else {
      tmp = this.v36_1;
    }
    return tmp;
  };
  function Companion_24() {
  }
  protoOf(Companion_24).d27 = function (json) {
    var map = FromJsonHelper_instance.b27(json, 'Claims');
    // Inline function 'kotlin.collections.associate' call
    var this_0 = map.z();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'io.curity.vc.serialization.Companion.fromJson.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.a1();
      // Inline function 'kotlin.collections.component2' call
      var value = element.b1();
      var pair = to(key, Companion_instance_27.d27(value));
      destination.m2(pair.z9_1, pair.aa_1);
    }
    return new JsonClaims(destination);
  };
  var Companion_instance_26;
  function Companion_getInstance_24() {
    return Companion_instance_26;
  }
  function VcSdJwtAuthorizationDetail$JsonClaims$_serialized$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.associate' call
      var this_0 = this$0.x36_1.z();
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'io.curity.vc.serialization.JsonClaims._serialized.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = element.a1();
        // Inline function 'kotlin.collections.component2' call
        var value = element.b1();
        var pair = to(key, value.y26().a27());
        destination.m2(pair.z9_1, pair.aa_1);
      }
      return new JsonDictionary(destination);
    };
  }
  function Companion_25() {
  }
  protoOf(Companion_25).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'ClaimsItem'));
    return new JsonClaimsItem(unwrapOptionalBoolean(map, 'mandatory'), map.s() ? null : new JsonDictionary(toMap(map)));
  };
  var Companion_instance_27;
  function Companion_getInstance_25() {
    return Companion_instance_27;
  }
  function _get__serializable__azf9o3_5($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.b37_1;
    _serializable$factory_5();
    return this_0.b1();
  }
  function VcSdJwtAuthorizationDetail$JsonClaimsItem$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.JsonClaimsItem._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.a37_1 == null)) {
        this_0.o2(this$0.a37_1.a27());
      }
      if (!(this$0.z36_1 == null)) {
        this_0.m2('mandatory', toJson_2(this$0.z36_1));
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function VcSdJwtAuthorizationDetail_init_$Init$(vct, claims, $this) {
    VcSdJwtAuthorizationDetail.call($this, 'openid_credential', 'vc+sd-jwt', null, vct, claims);
    return $this;
  }
  function VcSdJwtAuthorizationDetail_init_$Create$(vct, claims) {
    return VcSdJwtAuthorizationDetail_init_$Init$(vct, claims, objectCreate(protoOf(VcSdJwtAuthorizationDetail)));
  }
  function JsonClaims(claims) {
    this.x36_1 = claims;
    var tmp = this;
    tmp.y36_1 = lazy(VcSdJwtAuthorizationDetail$JsonClaims$_serialized$lambda(this));
  }
  protoOf(JsonClaims).y26 = function () {
    return this.y36_1.b1();
  };
  function JsonClaimsItem(mandatory, customClaims) {
    customClaims = customClaims === VOID ? null : customClaims;
    this.z36_1 = mandatory;
    this.a37_1 = customClaims;
    var tmp = this;
    tmp.b37_1 = lazy(VcSdJwtAuthorizationDetail$JsonClaimsItem$_serializable$delegate$lambda(this));
  }
  protoOf(JsonClaimsItem).y26 = function () {
    return _get__serializable__azf9o3_5(this);
  };
  function Companion_26() {
  }
  var Companion_instance_28;
  function Companion_getInstance_26() {
    return Companion_instance_28;
  }
  function $serializer_14() {
    $serializer_instance_14 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.VcSdJwtAuthorizationDetail', this, 5);
    tmp0_serialDesc.wy('type', false);
    tmp0_serialDesc.wy('format', true);
    tmp0_serialDesc.wy('credential_configuration_id', true);
    tmp0_serialDesc.wy('vct', true);
    tmp0_serialDesc.wy('claims', true);
    this.c37_1 = tmp0_serialDesc;
  }
  protoOf($serializer_14).d37 = function (encoder, value) {
    var tmp0_desc = this.c37_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.e37_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.f37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.f37_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.g37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.g37_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.h37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, StringSerializer_getInstance(), value.h37_1);
    }
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.i37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, VcSdJwtAuthorizationDetailClaimsSerializer_getInstance(), value.i37_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_14).zn = function (encoder, value) {
    return this.d37(encoder, value instanceof VcSdJwtAuthorizationDetail ? value : THROW_CCE());
  };
  protoOf($serializer_14).ao = function (decoder) {
    var tmp0_desc = this.c37_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.lr(tmp0_desc);
    if (tmp9_input.as()) {
      tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, VcSdJwtAuthorizationDetailClaimsSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, VcSdJwtAuthorizationDetailClaimsSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.mr(tmp0_desc);
    return VcSdJwtAuthorizationDetail_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_14).yn = function () {
    return this.c37_1;
  };
  protoOf($serializer_14).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(VcSdJwtAuthorizationDetailClaimsSerializer_getInstance())];
  };
  var $serializer_instance_14;
  function $serializer_getInstance_15() {
    if ($serializer_instance_14 == null)
      new $serializer_14();
    return $serializer_instance_14;
  }
  function VcSdJwtAuthorizationDetail_init_$Init$_0(seen0, type, format, credentialConfigurationId, vct, claims, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_15().c37_1);
    }
    $this.e37_1 = type;
    if (0 === (seen0 & 2))
      $this.f37_1 = null;
    else
      $this.f37_1 = format;
    if (0 === (seen0 & 4))
      $this.g37_1 = null;
    else
      $this.g37_1 = credentialConfigurationId;
    if (0 === (seen0 & 8))
      $this.h37_1 = null;
    else
      $this.h37_1 = vct;
    if (0 === (seen0 & 16))
      $this.i37_1 = null;
    else
      $this.i37_1 = claims;
    return $this;
  }
  function VcSdJwtAuthorizationDetail_init_$Create$_0(seen0, type, format, credentialConfigurationId, vct, claims, serializationConstructorMarker) {
    return VcSdJwtAuthorizationDetail_init_$Init$_0(seen0, type, format, credentialConfigurationId, vct, claims, serializationConstructorMarker, objectCreate(protoOf(VcSdJwtAuthorizationDetail)));
  }
  function VcSdJwtAuthorizationDetail(type, format, credentialConfigurationId, vct, claims) {
    format = format === VOID ? null : format;
    credentialConfigurationId = credentialConfigurationId === VOID ? null : credentialConfigurationId;
    vct = vct === VOID ? null : vct;
    claims = claims === VOID ? null : claims;
    this.e37_1 = type;
    this.f37_1 = format;
    this.g37_1 = credentialConfigurationId;
    this.h37_1 = vct;
    this.i37_1 = claims;
  }
  function _serializable$factory_5() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_5(receiver);
    }, null);
  }
  function Companion_27() {
    Companion_instance_29 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j37_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(JsonCredentialDisplaySerializer_getInstance()), null, new ArrayListSerializer(StringSerializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12())];
  }
  protoOf(Companion_27).b1b = function () {
    return $serializer_getInstance_16();
  };
  var Companion_instance_29;
  function Companion_getInstance_27() {
    if (Companion_instance_29 == null)
      new Companion_27();
    return Companion_instance_29;
  }
  function $serializer_15() {
    $serializer_instance_15 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.VcSdJwtCredentialConfigurationsSupported', this, 9);
    tmp0_serialDesc.wy('format', false);
    tmp0_serialDesc.wy('vct', false);
    tmp0_serialDesc.wy('claims', true);
    tmp0_serialDesc.wy('order', true);
    tmp0_serialDesc.wy('cryptographic_binding_methods_supported', true);
    tmp0_serialDesc.wy('display', true);
    tmp0_serialDesc.wy('scope', true);
    tmp0_serialDesc.wy('credential_signing_alg_values_supported', true);
    tmp0_serialDesc.wy('proof_types_supported', true);
    this.k37_1 = tmp0_serialDesc;
  }
  protoOf($serializer_15).l37 = function (encoder, value) {
    var tmp0_desc = this.k37_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_27().j37_1;
    tmp1_output.zs(tmp0_desc, 0, value.m37_1);
    tmp1_output.zs(tmp0_desc, 1, value.n37_1);
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.o37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, VcSdJwtClaimsMetadataSerializer_getInstance(), value.o37_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.p37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, tmp2_cached[3], value.p37_1);
    }
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.q37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, tmp2_cached[4], value.q37_1);
    }
    if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.r37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 5, tmp2_cached[5], value.r37_1);
    }
    if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.s37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 6, StringSerializer_getInstance(), value.s37_1);
    }
    if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.t37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 7, tmp2_cached[7], value.t37_1);
    }
    if (tmp1_output.ht(tmp0_desc, 8) ? true : !(value.u37_1 == null)) {
      tmp1_output.dt(tmp0_desc, 8, tmp2_cached[8], value.u37_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_15).zn = function (encoder, value) {
    return this.l37(encoder, value instanceof VcSdJwtCredentialConfigurationsSupported ? value : THROW_CCE());
  };
  protoOf($serializer_15).ao = function (decoder) {
    var tmp0_desc = this.k37_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_input = decoder.lr(tmp0_desc);
    var tmp14_cached = Companion_getInstance_27().j37_1;
    if (tmp13_input.as()) {
      tmp4_local0 = tmp13_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.zr(tmp0_desc, 2, VcSdJwtClaimsMetadataSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.zr(tmp0_desc, 3, tmp14_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.zr(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.zr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.zr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.zr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp13_input.zr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.zr(tmp0_desc, 2, VcSdJwtClaimsMetadataSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.zr(tmp0_desc, 3, tmp14_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.zr(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.zr(tmp0_desc, 5, tmp14_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.zr(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.zr(tmp0_desc, 7, tmp14_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp13_input.zr(tmp0_desc, 8, tmp14_cached[8], tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.mr(tmp0_desc);
    return VcSdJwtCredentialConfigurationsSupported_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
  };
  protoOf($serializer_15).yn = function () {
    return this.k37_1;
  };
  protoOf($serializer_15).lz = function () {
    var tmp0_cached = Companion_getInstance_27().j37_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable(VcSdJwtClaimsMetadataSerializer_getInstance()), get_nullable(tmp0_cached[3]), get_nullable(tmp0_cached[4]), get_nullable(tmp0_cached[5]), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[7]), get_nullable(tmp0_cached[8])];
  };
  var $serializer_instance_15;
  function $serializer_getInstance_16() {
    if ($serializer_instance_15 == null)
      new $serializer_15();
    return $serializer_instance_15;
  }
  function VcSdJwtCredentialConfigurationsSupported_init_$Init$(seen0, format, vct, claims, order, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_16().k37_1);
    }
    $this.m37_1 = format;
    $this.n37_1 = vct;
    if (0 === (seen0 & 4))
      $this.o37_1 = null;
    else
      $this.o37_1 = claims;
    if (0 === (seen0 & 8))
      $this.p37_1 = null;
    else
      $this.p37_1 = order;
    if (0 === (seen0 & 16))
      $this.q37_1 = null;
    else
      $this.q37_1 = cryptographicBindingMethodsSupported;
    if (0 === (seen0 & 32))
      $this.r37_1 = null;
    else
      $this.r37_1 = display;
    if (0 === (seen0 & 64))
      $this.s37_1 = null;
    else
      $this.s37_1 = scope;
    if (0 === (seen0 & 128))
      $this.t37_1 = null;
    else
      $this.t37_1 = credentialSigningAlgValuesSupported;
    if (0 === (seen0 & 256))
      $this.u37_1 = null;
    else
      $this.u37_1 = proofTypesSupported;
    return $this;
  }
  function VcSdJwtCredentialConfigurationsSupported_init_$Create$(seen0, format, vct, claims, order, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, serializationConstructorMarker) {
    return VcSdJwtCredentialConfigurationsSupported_init_$Init$(seen0, format, vct, claims, order, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, serializationConstructorMarker, objectCreate(protoOf(VcSdJwtCredentialConfigurationsSupported)));
  }
  function VcSdJwtCredentialConfigurationsSupported() {
  }
  protoOf(VcSdJwtCredentialConfigurationsSupported).z33 = function () {
    return this.m37_1;
  };
  protoOf(VcSdJwtCredentialConfigurationsSupported).toString = function () {
    return 'VcSdJwtCredentialConfigurationsSupported(format=' + this.m37_1 + ', vct=' + this.n37_1 + ', claims=' + toString_0(this.o37_1) + ', order=' + toString_0(this.p37_1) + ', cryptographicBindingMethodsSupported=' + toString_0(this.q37_1) + ', display=' + toString_0(this.r37_1) + ', scope=' + this.s37_1 + ', credentialSigningAlgValuesSupported=' + toString_0(this.t37_1) + ', proofTypesSupported=' + toString_0(this.u37_1) + ')';
  };
  protoOf(VcSdJwtCredentialConfigurationsSupported).hashCode = function () {
    var result = getStringHashCode(this.m37_1);
    result = imul(result, 31) + getStringHashCode(this.n37_1) | 0;
    result = imul(result, 31) + (this.o37_1 == null ? 0 : this.o37_1.hashCode()) | 0;
    result = imul(result, 31) + (this.p37_1 == null ? 0 : hashCode(this.p37_1)) | 0;
    result = imul(result, 31) + (this.q37_1 == null ? 0 : hashCode(this.q37_1)) | 0;
    result = imul(result, 31) + (this.r37_1 == null ? 0 : hashCode(this.r37_1)) | 0;
    result = imul(result, 31) + (this.s37_1 == null ? 0 : getStringHashCode(this.s37_1)) | 0;
    result = imul(result, 31) + (this.t37_1 == null ? 0 : hashCode(this.t37_1)) | 0;
    result = imul(result, 31) + (this.u37_1 == null ? 0 : hashCode(this.u37_1)) | 0;
    return result;
  };
  protoOf(VcSdJwtCredentialConfigurationsSupported).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VcSdJwtCredentialConfigurationsSupported))
      return false;
    var tmp0_other_with_cast = other instanceof VcSdJwtCredentialConfigurationsSupported ? other : THROW_CCE();
    if (!(this.m37_1 === tmp0_other_with_cast.m37_1))
      return false;
    if (!(this.n37_1 === tmp0_other_with_cast.n37_1))
      return false;
    if (!equals(this.o37_1, tmp0_other_with_cast.o37_1))
      return false;
    if (!equals(this.p37_1, tmp0_other_with_cast.p37_1))
      return false;
    if (!equals(this.q37_1, tmp0_other_with_cast.q37_1))
      return false;
    if (!equals(this.r37_1, tmp0_other_with_cast.r37_1))
      return false;
    if (!(this.s37_1 == tmp0_other_with_cast.s37_1))
      return false;
    if (!equals(this.t37_1, tmp0_other_with_cast.t37_1))
      return false;
    if (!equals(this.u37_1, tmp0_other_with_cast.u37_1))
      return false;
    return true;
  };
  function Companion_28() {
  }
  protoOf(Companion_28).d27 = function (json) {
    var map = FromJsonHelper_instance.b27(json, 'VcSdJwtClaimsMetadata');
    // Inline function 'kotlin.collections.associate' call
    var this_0 = map.z();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'io.curity.vc.serialization.Companion.fromJson.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.a1();
      // Inline function 'kotlin.collections.component2' call
      var value = element.b1();
      var pair = to(key, Companion_instance_31.d27(value));
      destination.m2(pair.z9_1, pair.aa_1);
    }
    return new VcSdJwtClaimsMetadata(destination);
  };
  var Companion_instance_30;
  function Companion_getInstance_28() {
    return Companion_instance_30;
  }
  function _get__serialized__5dtwz6_0($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.w37_1;
    _serialized$factory_0();
    return this_0.b1();
  }
  function VcSdJwtClaimsMetadata$_serialized$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.associate' call
      var this_0 = this$0.v37_1.z();
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'io.curity.vc.serialization.VcSdJwtClaimsMetadata._serialized$delegate.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = element.a1();
        // Inline function 'kotlin.collections.component2' call
        var value = element.b1();
        var pair = to(key, value.y26().a27());
        destination.m2(pair.z9_1, pair.aa_1);
      }
      return new JsonDictionary(destination);
    };
  }
  function VcSdJwtClaimsMetadata(claims) {
    this.v37_1 = claims;
    var tmp = this;
    tmp.w37_1 = lazy(VcSdJwtClaimsMetadata$_serialized$delegate$lambda(this));
  }
  protoOf(VcSdJwtClaimsMetadata).y26 = function () {
    return _get__serialized__5dtwz6_0(this);
  };
  protoOf(VcSdJwtClaimsMetadata).toString = function () {
    return 'VcSdJwtClaimsMetadata(claims=' + toString(this.v37_1) + ')';
  };
  protoOf(VcSdJwtClaimsMetadata).hashCode = function () {
    return hashCode(this.v37_1);
  };
  protoOf(VcSdJwtClaimsMetadata).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VcSdJwtClaimsMetadata))
      return false;
    var tmp0_other_with_cast = other instanceof VcSdJwtClaimsMetadata ? other : THROW_CCE();
    if (!equals(this.v37_1, tmp0_other_with_cast.v37_1))
      return false;
    return true;
  };
  function Companion_29() {
  }
  protoOf(Companion_29).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'VcSdJwtClaimsEntryMetadata'));
    return new VcSdJwtClaimsEntryMetadata(unwrapOptionalString(map, 'value_type'), unwrapDisplays(map, 'display'), unwrapOptionalBoolean(map, 'mandatory'), map.s() ? null : new JsonDictionary(toMap(map)));
  };
  var Companion_instance_31;
  function Companion_getInstance_29() {
    return Companion_instance_31;
  }
  function _get__serializable__azf9o3_6($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.b38_1;
    _serializable$factory_6();
    return this_0.b1();
  }
  function VcSdJwtClaimsEntryMetadata$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.VcSdJwtClaimsEntryMetadata._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.a38_1 == null)) {
        this_0.o2(this$0.a38_1.a27());
      }
      if (!(this$0.x37_1 == null)) {
        this_0.m2('value_type', toJson(this$0.x37_1));
      }
      if (!(this$0.y37_1 == null)) {
        this_0.m2('display', toJsons(this$0.y37_1));
      }
      if (!(this$0.z37_1 == null)) {
        this_0.m2('mandatory', toJson_2(this$0.z37_1));
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function VcSdJwtClaimsEntryMetadata(valueType, display, _mandatory, customClaims) {
    valueType = valueType === VOID ? null : valueType;
    display = display === VOID ? null : display;
    _mandatory = _mandatory === VOID ? null : _mandatory;
    customClaims = customClaims === VOID ? null : customClaims;
    this.x37_1 = valueType;
    this.y37_1 = display;
    this.z37_1 = _mandatory;
    this.a38_1 = customClaims;
    var tmp = this;
    tmp.b38_1 = lazy(VcSdJwtClaimsEntryMetadata$_serializable$delegate$lambda(this));
  }
  protoOf(VcSdJwtClaimsEntryMetadata).y26 = function () {
    return _get__serializable__azf9o3_6(this);
  };
  protoOf(VcSdJwtClaimsEntryMetadata).toString = function () {
    return 'VcSdJwtClaimsEntryMetadata(valueType=' + this.x37_1 + ', display=' + toString_0(this.y37_1) + ', _mandatory=' + this.z37_1 + ', customClaims=' + toString_0(this.a38_1) + ')';
  };
  protoOf(VcSdJwtClaimsEntryMetadata).hashCode = function () {
    var result = this.x37_1 == null ? 0 : getStringHashCode(this.x37_1);
    result = imul(result, 31) + (this.y37_1 == null ? 0 : hashCode(this.y37_1)) | 0;
    result = imul(result, 31) + (this.z37_1 == null ? 0 : getBooleanHashCode(this.z37_1)) | 0;
    result = imul(result, 31) + (this.a38_1 == null ? 0 : hashCode(this.a38_1)) | 0;
    return result;
  };
  protoOf(VcSdJwtClaimsEntryMetadata).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VcSdJwtClaimsEntryMetadata))
      return false;
    var tmp0_other_with_cast = other instanceof VcSdJwtClaimsEntryMetadata ? other : THROW_CCE();
    if (!(this.x37_1 == tmp0_other_with_cast.x37_1))
      return false;
    if (!equals(this.y37_1, tmp0_other_with_cast.y37_1))
      return false;
    if (!(this.z37_1 == tmp0_other_with_cast.z37_1))
      return false;
    if (!equals(this.a38_1, tmp0_other_with_cast.a38_1))
      return false;
    return true;
  };
  function _serialized$factory_0() {
    return getPropertyCallableRef('_serialized', 1, KProperty1, function (receiver) {
      return _get__serialized__5dtwz6_0(receiver);
    }, null);
  }
  function _serializable$factory_6() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_6(receiver);
    }, null);
  }
  function Companion_30() {
  }
  var Companion_instance_32;
  function Companion_getInstance_30() {
    return Companion_instance_32;
  }
  function $serializer_16() {
    $serializer_instance_16 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.VcSdJwtVerifiableCredentialRequest', this, 4);
    tmp0_serialDesc.wy('proof', true);
    tmp0_serialDesc.wy('vct', false);
    tmp0_serialDesc.wy('claims', true);
    tmp0_serialDesc.wy('format', true);
    this.c38_1 = tmp0_serialDesc;
  }
  protoOf($serializer_16).d38 = function (encoder, value) {
    var tmp0_desc = this.c38_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.e38_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), value.e38_1);
    }
    tmp1_output.zs(tmp0_desc, 1, value.f38_1);
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.g38_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), value.g38_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.h38_1 === 'vc+sd-jwt')) {
      tmp1_output.zs(tmp0_desc, 3, value.h38_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_16).zn = function (encoder, value) {
    return this.d38(encoder, value instanceof VcSdJwtVerifiableCredentialRequest ? value : THROW_CCE());
  };
  protoOf($serializer_16).ao = function (decoder) {
    var tmp0_desc = this.c38_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.lr(tmp0_desc);
    if (tmp8_input.as()) {
      tmp4_local0 = tmp8_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.vr(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, ToJsonDictionarySerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.vr(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.mr(tmp0_desc);
    return VcSdJwtVerifiableCredentialRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_16).yn = function () {
    return this.c38_1;
  };
  protoOf($serializer_16).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(ToJsonProofOfPossessionSerializer_getInstance()), StringSerializer_getInstance(), get_nullable(ToJsonDictionarySerializer_getInstance()), StringSerializer_getInstance()];
  };
  var $serializer_instance_16;
  function $serializer_getInstance_17() {
    if ($serializer_instance_16 == null)
      new $serializer_16();
    return $serializer_instance_16;
  }
  function VcSdJwtVerifiableCredentialRequest_init_$Init$(seen0, proof, vct, claims, format, serializationConstructorMarker, $this) {
    if (!(2 === (2 & seen0))) {
      throwMissingFieldException(seen0, 2, $serializer_getInstance_17().c38_1);
    }
    if (0 === (seen0 & 1))
      $this.e38_1 = null;
    else
      $this.e38_1 = proof;
    $this.f38_1 = vct;
    if (0 === (seen0 & 4))
      $this.g38_1 = null;
    else
      $this.g38_1 = claims;
    if (0 === (seen0 & 8))
      $this.h38_1 = 'vc+sd-jwt';
    else
      $this.h38_1 = format;
    return $this;
  }
  function VcSdJwtVerifiableCredentialRequest_init_$Create$(seen0, proof, vct, claims, format, serializationConstructorMarker) {
    return VcSdJwtVerifiableCredentialRequest_init_$Init$(seen0, proof, vct, claims, format, serializationConstructorMarker, objectCreate(protoOf(VcSdJwtVerifiableCredentialRequest)));
  }
  function VcSdJwtVerifiableCredentialRequest(proof, vct, claims, format) {
    proof = proof === VOID ? null : proof;
    claims = claims === VOID ? null : claims;
    format = format === VOID ? 'vc+sd-jwt' : format;
    this.e38_1 = proof;
    this.f38_1 = vct;
    this.g38_1 = claims;
    this.h38_1 = format;
  }
  protoOf(VcSdJwtVerifiableCredentialRequest).toString = function () {
    return 'VcSdJwtVerifiableCredentialRequest(proof=' + toString_0(this.e38_1) + ', vct=' + this.f38_1 + ', claims=' + toString_0(this.g38_1) + ', format=' + this.h38_1 + ')';
  };
  protoOf(VcSdJwtVerifiableCredentialRequest).hashCode = function () {
    var result = this.e38_1 == null ? 0 : hashCode(this.e38_1);
    result = imul(result, 31) + getStringHashCode(this.f38_1) | 0;
    result = imul(result, 31) + (this.g38_1 == null ? 0 : hashCode(this.g38_1)) | 0;
    result = imul(result, 31) + getStringHashCode(this.h38_1) | 0;
    return result;
  };
  protoOf(VcSdJwtVerifiableCredentialRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VcSdJwtVerifiableCredentialRequest))
      return false;
    var tmp0_other_with_cast = other instanceof VcSdJwtVerifiableCredentialRequest ? other : THROW_CCE();
    if (!equals(this.e38_1, tmp0_other_with_cast.e38_1))
      return false;
    if (!(this.f38_1 === tmp0_other_with_cast.f38_1))
      return false;
    if (!equals(this.g38_1, tmp0_other_with_cast.g38_1))
      return false;
    if (!(this.h38_1 === tmp0_other_with_cast.h38_1))
      return false;
    return true;
  };
  function Companion_31() {
  }
  protoOf(Companion_31).b1b = function () {
    return $serializer_getInstance_18();
  };
  var Companion_instance_33;
  function Companion_getInstance_31() {
    return Companion_instance_33;
  }
  function $serializer_17() {
    $serializer_instance_17 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.VcSdJwtVerifiableCredentialResponse', this, 3);
    tmp0_serialDesc.wy('credential', false);
    tmp0_serialDesc.wy('c_nonce', true);
    tmp0_serialDesc.wy('c_nonce_expires_in', true);
    this.i38_1 = tmp0_serialDesc;
  }
  protoOf($serializer_17).j38 = function (encoder, value) {
    var tmp0_desc = this.i38_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.k38_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.l38_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.l38_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.m38_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.m38_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_17).zn = function (encoder, value) {
    return this.j38(encoder, value instanceof VcSdJwtVerifiableCredentialResponse ? value : THROW_CCE());
  };
  protoOf($serializer_17).ao = function (decoder) {
    var tmp0_desc = this.i38_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return VcSdJwtVerifiableCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_17).yn = function () {
    return this.i38_1;
  };
  protoOf($serializer_17).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_17;
  function $serializer_getInstance_18() {
    if ($serializer_instance_17 == null)
      new $serializer_17();
    return $serializer_instance_17;
  }
  function VcSdJwtVerifiableCredentialResponse_init_$Init$(seen0, stringCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_18().i38_1);
    }
    $this.k38_1 = stringCredential;
    if (0 === (seen0 & 2))
      $this.l38_1 = null;
    else
      $this.l38_1 = cNonce;
    if (0 === (seen0 & 4))
      $this.m38_1 = null;
    else
      $this.m38_1 = cNonceExpiresIn;
    return $this;
  }
  function VcSdJwtVerifiableCredentialResponse_init_$Create$(seen0, stringCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
    return VcSdJwtVerifiableCredentialResponse_init_$Init$(seen0, stringCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(VcSdJwtVerifiableCredentialResponse)));
  }
  function VcSdJwtVerifiableCredentialResponse() {
  }
  protoOf(VcSdJwtVerifiableCredentialResponse).n38 = function () {
    return new StringCredential(this.k38_1);
  };
  protoOf(VcSdJwtVerifiableCredentialResponse).toString = function () {
    return 'VcSdJwtVerifiableCredentialResponse(stringCredential=' + this.k38_1 + ', cNonce=' + this.l38_1 + ', cNonceExpiresIn=' + toString_0(this.m38_1) + ')';
  };
  protoOf(VcSdJwtVerifiableCredentialResponse).hashCode = function () {
    var result = getStringHashCode(this.k38_1);
    result = imul(result, 31) + (this.l38_1 == null ? 0 : getStringHashCode(this.l38_1)) | 0;
    result = imul(result, 31) + (this.m38_1 == null ? 0 : this.m38_1.hashCode()) | 0;
    return result;
  };
  protoOf(VcSdJwtVerifiableCredentialResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VcSdJwtVerifiableCredentialResponse))
      return false;
    var tmp0_other_with_cast = other instanceof VcSdJwtVerifiableCredentialResponse ? other : THROW_CCE();
    if (!(this.k38_1 === tmp0_other_with_cast.k38_1))
      return false;
    if (!(this.l38_1 == tmp0_other_with_cast.l38_1))
      return false;
    if (!equals(this.m38_1, tmp0_other_with_cast.m38_1))
      return false;
    return true;
  };
  function VcSdJwtClaimsMetadataSerializer() {
    VcSdJwtClaimsMetadataSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_30);
  }
  var VcSdJwtClaimsMetadataSerializer_instance;
  function VcSdJwtClaimsMetadataSerializer_getInstance() {
    if (VcSdJwtClaimsMetadataSerializer_instance == null)
      new VcSdJwtClaimsMetadataSerializer();
    return VcSdJwtClaimsMetadataSerializer_instance;
  }
  function VcSdJwtClaimsMetadataEntrySerializer() {
    VcSdJwtClaimsMetadataEntrySerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_31);
  }
  var VcSdJwtClaimsMetadataEntrySerializer_instance;
  function VcSdJwtClaimsMetadataEntrySerializer_getInstance() {
    if (VcSdJwtClaimsMetadataEntrySerializer_instance == null)
      new VcSdJwtClaimsMetadataEntrySerializer();
    return VcSdJwtClaimsMetadataEntrySerializer_instance;
  }
  function VcSdJwtAuthorizationDetailClaimsSerializer() {
    VcSdJwtAuthorizationDetailClaimsSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_26);
  }
  var VcSdJwtAuthorizationDetailClaimsSerializer_instance;
  function VcSdJwtAuthorizationDetailClaimsSerializer_getInstance() {
    if (VcSdJwtAuthorizationDetailClaimsSerializer_instance == null)
      new VcSdJwtAuthorizationDetailClaimsSerializer();
    return VcSdJwtAuthorizationDetailClaimsSerializer_instance;
  }
  function VcSdJwtAuthorizationDetailClaimsItemSerializer() {
    VcSdJwtAuthorizationDetailClaimsItemSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_27);
  }
  var VcSdJwtAuthorizationDetailClaimsItemSerializer_instance;
  function VcSdJwtAuthorizationDetailClaimsItemSerializer_getInstance() {
    if (VcSdJwtAuthorizationDetailClaimsItemSerializer_instance == null)
      new VcSdJwtAuthorizationDetailClaimsItemSerializer();
    return VcSdJwtAuthorizationDetailClaimsItemSerializer_instance;
  }
  function JwtVcJsonAuthorizationDetail_init_$Init$(types, credentialSubject, $this) {
    JwtVcJsonAuthorizationDetail.call($this, 'openid_credential', 'jwt_vc_json', null, new JwtVcJsonAuthorizationDetailsCredentialDefinition(types, credentialSubject));
    return $this;
  }
  function JwtVcJsonAuthorizationDetail_init_$Create$(types, credentialSubject) {
    return JwtVcJsonAuthorizationDetail_init_$Init$(types, credentialSubject, objectCreate(protoOf(JwtVcJsonAuthorizationDetail)));
  }
  function Companion_32() {
  }
  var Companion_instance_34;
  function Companion_getInstance_32() {
    return Companion_instance_34;
  }
  function $serializer_18() {
    $serializer_instance_18 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JwtVcJsonAuthorizationDetail', this, 4);
    tmp0_serialDesc.wy('type', false);
    tmp0_serialDesc.wy('format', true);
    tmp0_serialDesc.wy('credential_configuration_id', true);
    tmp0_serialDesc.wy('credential_definition', true);
    this.o38_1 = tmp0_serialDesc;
  }
  protoOf($serializer_18).p38 = function (encoder, value) {
    var tmp0_desc = this.o38_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.q38_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.r38_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.r38_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.s38_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.s38_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.t38_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_20(), value.t38_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_18).zn = function (encoder, value) {
    return this.p38(encoder, value instanceof JwtVcJsonAuthorizationDetail ? value : THROW_CCE());
  };
  protoOf($serializer_18).ao = function (decoder) {
    var tmp0_desc = this.o38_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.lr(tmp0_desc);
    if (tmp8_input.as()) {
      tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_20(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_20(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.mr(tmp0_desc);
    return JwtVcJsonAuthorizationDetail_init_$Create$_0(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_18).yn = function () {
    return this.o38_1;
  };
  protoOf($serializer_18).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_20())];
  };
  var $serializer_instance_18;
  function $serializer_getInstance_19() {
    if ($serializer_instance_18 == null)
      new $serializer_18();
    return $serializer_instance_18;
  }
  function JwtVcJsonAuthorizationDetail_init_$Init$_0(seen0, type, format, credentialConfigurationId, credentialDefinition, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_19().o38_1);
    }
    $this.q38_1 = type;
    if (0 === (seen0 & 2))
      $this.r38_1 = null;
    else
      $this.r38_1 = format;
    if (0 === (seen0 & 4))
      $this.s38_1 = null;
    else
      $this.s38_1 = credentialConfigurationId;
    if (0 === (seen0 & 8))
      $this.t38_1 = null;
    else
      $this.t38_1 = credentialDefinition;
    return $this;
  }
  function JwtVcJsonAuthorizationDetail_init_$Create$_0(seen0, type, format, credentialConfigurationId, credentialDefinition, serializationConstructorMarker) {
    return JwtVcJsonAuthorizationDetail_init_$Init$_0(seen0, type, format, credentialConfigurationId, credentialDefinition, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonAuthorizationDetail)));
  }
  function JwtVcJsonAuthorizationDetail(type, format, credentialConfigurationId, credentialDefinition) {
    format = format === VOID ? null : format;
    credentialConfigurationId = credentialConfigurationId === VOID ? null : credentialConfigurationId;
    credentialDefinition = credentialDefinition === VOID ? null : credentialDefinition;
    this.q38_1 = type;
    this.r38_1 = format;
    this.s38_1 = credentialConfigurationId;
    this.t38_1 = credentialDefinition;
  }
  function Companion_33() {
  }
  protoOf(Companion_33).d27 = function (json) {
    var map = FromJsonHelper_instance.b27(json, 'JsonCredentialSubject');
    // Inline function 'kotlin.collections.associate' call
    var this_0 = map.z();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'io.curity.vc.serialization.Companion.fromJson.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.a1();
      // Inline function 'kotlin.collections.component2' call
      var value = element.b1();
      var pair = to(key, Companion_instance_36.d27(value));
      destination.m2(pair.z9_1, pair.aa_1);
    }
    return new JsonCredentialSubject(destination);
  };
  var Companion_instance_35;
  function Companion_getInstance_33() {
    return Companion_instance_35;
  }
  function JwtVcJsonAuthorizationDetailsCredentialDefinition$JsonCredentialSubject$_serialized$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.associate' call
      var this_0 = this$0.u38_1.z();
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'io.curity.vc.serialization.JsonCredentialSubject._serialized.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = element.a1();
        // Inline function 'kotlin.collections.component2' call
        var value = element.b1();
        var pair = to(key, value.y26().a27());
        destination.m2(pair.z9_1, pair.aa_1);
      }
      return new JsonDictionary(destination);
    };
  }
  function Companion_34() {
  }
  protoOf(Companion_34).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonCredentialSubjectItem'));
    return new JsonCredentialSubjectItem(unwrapOptionalBoolean(map, 'mandatory'), map.s() ? null : new JsonDictionary(toMap(map)));
  };
  var Companion_instance_36;
  function Companion_getInstance_34() {
    return Companion_instance_36;
  }
  function _get__serializable__azf9o3_7($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.y38_1;
    _serializable$factory_7();
    return this_0.b1();
  }
  function JwtVcJsonAuthorizationDetailsCredentialDefinition$JsonCredentialSubjectItem$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.JsonCredentialSubjectItem._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.x38_1 == null)) {
        this_0.o2(this$0.x38_1.a27());
      }
      if (!(this$0.w38_1 == null)) {
        this_0.m2('mandatory', toJson_2(this$0.w38_1));
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JsonCredentialSubject(claims) {
    this.u38_1 = claims;
    var tmp = this;
    tmp.v38_1 = lazy(JwtVcJsonAuthorizationDetailsCredentialDefinition$JsonCredentialSubject$_serialized$lambda(this));
  }
  protoOf(JsonCredentialSubject).y26 = function () {
    return this.v38_1.b1();
  };
  protoOf(JsonCredentialSubject).toString = function () {
    return 'JsonCredentialSubject(claims=' + toString(this.u38_1) + ')';
  };
  protoOf(JsonCredentialSubject).hashCode = function () {
    return hashCode(this.u38_1);
  };
  protoOf(JsonCredentialSubject).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonCredentialSubject))
      return false;
    var tmp0_other_with_cast = other instanceof JsonCredentialSubject ? other : THROW_CCE();
    if (!equals(this.u38_1, tmp0_other_with_cast.u38_1))
      return false;
    return true;
  };
  function JsonCredentialSubjectItem(mandatory, customClaims) {
    customClaims = customClaims === VOID ? null : customClaims;
    this.w38_1 = mandatory;
    this.x38_1 = customClaims;
    var tmp = this;
    tmp.y38_1 = lazy(JwtVcJsonAuthorizationDetailsCredentialDefinition$JsonCredentialSubjectItem$_serializable$delegate$lambda(this));
  }
  protoOf(JsonCredentialSubjectItem).y26 = function () {
    return _get__serializable__azf9o3_7(this);
  };
  protoOf(JsonCredentialSubjectItem).toString = function () {
    return 'JsonCredentialSubjectItem(mandatory=' + this.w38_1 + ', customClaims=' + toString_0(this.x38_1) + ')';
  };
  protoOf(JsonCredentialSubjectItem).hashCode = function () {
    var result = this.w38_1 == null ? 0 : getBooleanHashCode(this.w38_1);
    result = imul(result, 31) + (this.x38_1 == null ? 0 : hashCode(this.x38_1)) | 0;
    return result;
  };
  protoOf(JsonCredentialSubjectItem).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonCredentialSubjectItem))
      return false;
    var tmp0_other_with_cast = other instanceof JsonCredentialSubjectItem ? other : THROW_CCE();
    if (!(this.w38_1 == tmp0_other_with_cast.w38_1))
      return false;
    if (!equals(this.x38_1, tmp0_other_with_cast.x38_1))
      return false;
    return true;
  };
  function Companion_35() {
    Companion_instance_37 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z38_1 = [new LinkedHashSetSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_37;
  function Companion_getInstance_35() {
    if (Companion_instance_37 == null)
      new Companion_35();
    return Companion_instance_37;
  }
  function $serializer_19() {
    $serializer_instance_19 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JwtVcJsonAuthorizationDetailsCredentialDefinition', this, 2);
    tmp0_serialDesc.wy('type', true);
    tmp0_serialDesc.wy('credentialSubject', true);
    this.a39_1 = tmp0_serialDesc;
  }
  protoOf($serializer_19).b39 = function (encoder, value) {
    var tmp0_desc = this.a39_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_35().z38_1;
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.c39_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, tmp2_cached[0], value.c39_1);
    }
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.d39_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance(), value.d39_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_19).zn = function (encoder, value) {
    return this.b39(encoder, value instanceof JwtVcJsonAuthorizationDetailsCredentialDefinition ? value : THROW_CCE());
  };
  protoOf($serializer_19).ao = function (decoder) {
    var tmp0_desc = this.a39_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    var tmp7_cached = Companion_getInstance_35().z38_1;
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JwtVcJsonAuthorizationDetailsCredentialDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_19).yn = function () {
    return this.a39_1;
  };
  protoOf($serializer_19).lz = function () {
    var tmp0_cached = Companion_getInstance_35().z38_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable(JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance())];
  };
  var $serializer_instance_19;
  function $serializer_getInstance_20() {
    if ($serializer_instance_19 == null)
      new $serializer_19();
    return $serializer_instance_19;
  }
  function JwtVcJsonAuthorizationDetailsCredentialDefinition_init_$Init$(seen0, type, credentialSubject, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_20().a39_1);
    }
    if (0 === (seen0 & 1))
      $this.c39_1 = null;
    else
      $this.c39_1 = type;
    if (0 === (seen0 & 2))
      $this.d39_1 = null;
    else
      $this.d39_1 = credentialSubject;
    return $this;
  }
  function JwtVcJsonAuthorizationDetailsCredentialDefinition_init_$Create$(seen0, type, credentialSubject, serializationConstructorMarker) {
    return JwtVcJsonAuthorizationDetailsCredentialDefinition_init_$Init$(seen0, type, credentialSubject, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonAuthorizationDetailsCredentialDefinition)));
  }
  function JwtVcJsonAuthorizationDetailsCredentialDefinition(type, credentialSubject) {
    Companion_getInstance_35();
    type = type === VOID ? null : type;
    credentialSubject = credentialSubject === VOID ? null : credentialSubject;
    this.c39_1 = type;
    this.d39_1 = credentialSubject;
  }
  protoOf(JwtVcJsonAuthorizationDetailsCredentialDefinition).toString = function () {
    return 'JwtVcJsonAuthorizationDetailsCredentialDefinition(type=' + toString_0(this.c39_1) + ', credentialSubject=' + toString_0(this.d39_1) + ')';
  };
  protoOf(JwtVcJsonAuthorizationDetailsCredentialDefinition).hashCode = function () {
    var result = this.c39_1 == null ? 0 : hashCode(this.c39_1);
    result = imul(result, 31) + (this.d39_1 == null ? 0 : this.d39_1.hashCode()) | 0;
    return result;
  };
  protoOf(JwtVcJsonAuthorizationDetailsCredentialDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtVcJsonAuthorizationDetailsCredentialDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof JwtVcJsonAuthorizationDetailsCredentialDefinition ? other : THROW_CCE();
    if (!equals(this.c39_1, tmp0_other_with_cast.c39_1))
      return false;
    if (!equals(this.d39_1, tmp0_other_with_cast.d39_1))
      return false;
    return true;
  };
  function _serializable$factory_7() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_7(receiver);
    }, null);
  }
  function Companion_36() {
    Companion_instance_38 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.e39_1 = [null, null, new ArrayListSerializer(StringSerializer_getInstance()), new ArrayListSerializer(JsonCredentialDisplaySerializer_getInstance()), null, new ArrayListSerializer(StringSerializer_getInstance()), new LinkedHashMapSerializer(StringSerializer_getInstance(), $serializer_getInstance_12()), new ArrayListSerializer(StringSerializer_getInstance())];
  }
  protoOf(Companion_36).b1b = function () {
    return $serializer_getInstance_21();
  };
  var Companion_instance_38;
  function Companion_getInstance_36() {
    if (Companion_instance_38 == null)
      new Companion_36();
    return Companion_instance_38;
  }
  function $serializer_20() {
    $serializer_instance_20 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JwtVcJsonCredentialConfigurationsSupported', this, 8);
    tmp0_serialDesc.wy('format', false);
    tmp0_serialDesc.wy('credential_definition', false);
    tmp0_serialDesc.wy('cryptographic_binding_methods_supported', true);
    tmp0_serialDesc.wy('display', true);
    tmp0_serialDesc.wy('scope', true);
    tmp0_serialDesc.wy('credential_signing_alg_values_supported', true);
    tmp0_serialDesc.wy('proof_types_supported', true);
    tmp0_serialDesc.wy('order', true);
    this.f39_1 = tmp0_serialDesc;
  }
  protoOf($serializer_20).g39 = function (encoder, value) {
    var tmp0_desc = this.f39_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_36().e39_1;
    tmp1_output.zs(tmp0_desc, 0, value.h39_1);
    tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_22(), value.i39_1);
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.j39_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, tmp2_cached[2], value.j39_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.k39_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, tmp2_cached[3], value.k39_1);
    }
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.l39_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, StringSerializer_getInstance(), value.l39_1);
    }
    if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.m39_1 == null)) {
      tmp1_output.dt(tmp0_desc, 5, tmp2_cached[5], value.m39_1);
    }
    if (tmp1_output.ht(tmp0_desc, 6) ? true : !(value.n39_1 == null)) {
      tmp1_output.dt(tmp0_desc, 6, tmp2_cached[6], value.n39_1);
    }
    if (tmp1_output.ht(tmp0_desc, 7) ? true : !(value.o39_1 == null)) {
      tmp1_output.dt(tmp0_desc, 7, tmp2_cached[7], value.o39_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_20).zn = function (encoder, value) {
    return this.g39(encoder, value instanceof JwtVcJsonCredentialConfigurationsSupported ? value : THROW_CCE());
  };
  protoOf($serializer_20).ao = function (decoder) {
    var tmp0_desc = this.f39_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.lr(tmp0_desc);
    var tmp13_cached = Companion_getInstance_36().e39_1;
    if (tmp12_input.as()) {
      tmp4_local0 = tmp12_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.xr(tmp0_desc, 1, $serializer_getInstance_22(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.zr(tmp0_desc, 3, tmp13_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.zr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.zr(tmp0_desc, 6, tmp13_cached[6], tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.zr(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.xr(tmp0_desc, 1, $serializer_getInstance_22(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.zr(tmp0_desc, 2, tmp13_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.zr(tmp0_desc, 3, tmp13_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.zr(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.zr(tmp0_desc, 5, tmp13_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.zr(tmp0_desc, 6, tmp13_cached[6], tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.zr(tmp0_desc, 7, tmp13_cached[7], tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.mr(tmp0_desc);
    return JwtVcJsonCredentialConfigurationsSupported_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_20).yn = function () {
    return this.f39_1;
  };
  protoOf($serializer_20).lz = function () {
    var tmp0_cached = Companion_getInstance_36().e39_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_22(), get_nullable(tmp0_cached[2]), get_nullable(tmp0_cached[3]), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[5]), get_nullable(tmp0_cached[6]), get_nullable(tmp0_cached[7])];
  };
  var $serializer_instance_20;
  function $serializer_getInstance_21() {
    if ($serializer_instance_20 == null)
      new $serializer_20();
    return $serializer_instance_20;
  }
  function JwtVcJsonCredentialConfigurationsSupported_init_$Init$(seen0, format, credentialDefinition, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, order, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_21().f39_1);
    }
    $this.h39_1 = format;
    $this.i39_1 = credentialDefinition;
    if (0 === (seen0 & 4))
      $this.j39_1 = null;
    else
      $this.j39_1 = cryptographicBindingMethodsSupported;
    if (0 === (seen0 & 8))
      $this.k39_1 = null;
    else
      $this.k39_1 = display;
    if (0 === (seen0 & 16))
      $this.l39_1 = null;
    else
      $this.l39_1 = scope;
    if (0 === (seen0 & 32))
      $this.m39_1 = null;
    else
      $this.m39_1 = credentialSigningAlgValuesSupported;
    if (0 === (seen0 & 64))
      $this.n39_1 = null;
    else
      $this.n39_1 = proofTypesSupported;
    if (0 === (seen0 & 128))
      $this.o39_1 = null;
    else
      $this.o39_1 = order;
    return $this;
  }
  function JwtVcJsonCredentialConfigurationsSupported_init_$Create$(seen0, format, credentialDefinition, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, order, serializationConstructorMarker) {
    return JwtVcJsonCredentialConfigurationsSupported_init_$Init$(seen0, format, credentialDefinition, cryptographicBindingMethodsSupported, display, scope, credentialSigningAlgValuesSupported, proofTypesSupported, order, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonCredentialConfigurationsSupported)));
  }
  function JwtVcJsonCredentialConfigurationsSupported() {
  }
  protoOf(JwtVcJsonCredentialConfigurationsSupported).z33 = function () {
    return this.h39_1;
  };
  protoOf(JwtVcJsonCredentialConfigurationsSupported).toString = function () {
    return 'JwtVcJsonCredentialConfigurationsSupported(format=' + this.h39_1 + ', credentialDefinition=' + this.i39_1.toString() + ', cryptographicBindingMethodsSupported=' + toString_0(this.j39_1) + ', display=' + toString_0(this.k39_1) + ', scope=' + this.l39_1 + ', credentialSigningAlgValuesSupported=' + toString_0(this.m39_1) + ', proofTypesSupported=' + toString_0(this.n39_1) + ', order=' + toString_0(this.o39_1) + ')';
  };
  protoOf(JwtVcJsonCredentialConfigurationsSupported).hashCode = function () {
    var result = getStringHashCode(this.h39_1);
    result = imul(result, 31) + this.i39_1.hashCode() | 0;
    result = imul(result, 31) + (this.j39_1 == null ? 0 : hashCode(this.j39_1)) | 0;
    result = imul(result, 31) + (this.k39_1 == null ? 0 : hashCode(this.k39_1)) | 0;
    result = imul(result, 31) + (this.l39_1 == null ? 0 : getStringHashCode(this.l39_1)) | 0;
    result = imul(result, 31) + (this.m39_1 == null ? 0 : hashCode(this.m39_1)) | 0;
    result = imul(result, 31) + (this.n39_1 == null ? 0 : hashCode(this.n39_1)) | 0;
    result = imul(result, 31) + (this.o39_1 == null ? 0 : hashCode(this.o39_1)) | 0;
    return result;
  };
  protoOf(JwtVcJsonCredentialConfigurationsSupported).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtVcJsonCredentialConfigurationsSupported))
      return false;
    var tmp0_other_with_cast = other instanceof JwtVcJsonCredentialConfigurationsSupported ? other : THROW_CCE();
    if (!(this.h39_1 === tmp0_other_with_cast.h39_1))
      return false;
    if (!this.i39_1.equals(tmp0_other_with_cast.i39_1))
      return false;
    if (!equals(this.j39_1, tmp0_other_with_cast.j39_1))
      return false;
    if (!equals(this.k39_1, tmp0_other_with_cast.k39_1))
      return false;
    if (!(this.l39_1 == tmp0_other_with_cast.l39_1))
      return false;
    if (!equals(this.m39_1, tmp0_other_with_cast.m39_1))
      return false;
    if (!equals(this.n39_1, tmp0_other_with_cast.n39_1))
      return false;
    if (!equals(this.o39_1, tmp0_other_with_cast.o39_1))
      return false;
    return true;
  };
  function Companion_37() {
    Companion_instance_39 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p39_1 = [new LinkedHashSetSerializer(StringSerializer_getInstance()), null];
  }
  var Companion_instance_39;
  function Companion_getInstance_37() {
    if (Companion_instance_39 == null)
      new Companion_37();
    return Companion_instance_39;
  }
  function $serializer_21() {
    $serializer_instance_21 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JwtVcJsonMetadataCredentialDefinition', this, 2);
    tmp0_serialDesc.wy('type', false);
    tmp0_serialDesc.wy('credentialSubject', false);
    this.q39_1 = tmp0_serialDesc;
  }
  protoOf($serializer_21).r39 = function (encoder, value) {
    var tmp0_desc = this.q39_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_37().p39_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.s39_1);
    tmp1_output.dt(tmp0_desc, 1, JwtVcJsonCredentialSubjectMetadataSerializer_getInstance(), value.t39_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_21).zn = function (encoder, value) {
    return this.r39(encoder, value instanceof JwtVcJsonMetadataCredentialDefinition ? value : THROW_CCE());
  };
  protoOf($serializer_21).ao = function (decoder) {
    var tmp0_desc = this.q39_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    var tmp7_cached = Companion_getInstance_37().p39_1;
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, JwtVcJsonCredentialSubjectMetadataSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, JwtVcJsonCredentialSubjectMetadataSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JwtVcJsonMetadataCredentialDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_21).yn = function () {
    return this.q39_1;
  };
  protoOf($serializer_21).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_37().p39_1[0], get_nullable(JwtVcJsonCredentialSubjectMetadataSerializer_getInstance())];
  };
  var $serializer_instance_21;
  function $serializer_getInstance_22() {
    if ($serializer_instance_21 == null)
      new $serializer_21();
    return $serializer_instance_21;
  }
  function JwtVcJsonMetadataCredentialDefinition_init_$Init$(seen0, type, credentialSubject, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_22().q39_1);
    }
    $this.s39_1 = type;
    $this.t39_1 = credentialSubject;
    return $this;
  }
  function JwtVcJsonMetadataCredentialDefinition_init_$Create$(seen0, type, credentialSubject, serializationConstructorMarker) {
    return JwtVcJsonMetadataCredentialDefinition_init_$Init$(seen0, type, credentialSubject, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonMetadataCredentialDefinition)));
  }
  function JwtVcJsonMetadataCredentialDefinition() {
  }
  protoOf(JwtVcJsonMetadataCredentialDefinition).toString = function () {
    return 'JwtVcJsonMetadataCredentialDefinition(type=' + toString(this.s39_1) + ', credentialSubject=' + toString_0(this.t39_1) + ')';
  };
  protoOf(JwtVcJsonMetadataCredentialDefinition).hashCode = function () {
    var result = hashCode(this.s39_1);
    result = imul(result, 31) + (this.t39_1 == null ? 0 : this.t39_1.hashCode()) | 0;
    return result;
  };
  protoOf(JwtVcJsonMetadataCredentialDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtVcJsonMetadataCredentialDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof JwtVcJsonMetadataCredentialDefinition ? other : THROW_CCE();
    if (!equals(this.s39_1, tmp0_other_with_cast.s39_1))
      return false;
    if (!equals(this.t39_1, tmp0_other_with_cast.t39_1))
      return false;
    return true;
  };
  function Companion_38() {
  }
  protoOf(Companion_38).d27 = function (json) {
    var map = FromJsonHelper_instance.b27(json, 'JwtVcJsonCredentialSubjectMetadata');
    // Inline function 'kotlin.collections.associate' call
    var this_0 = map.z();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination = LinkedHashMap_init_$Create$_0(capacity);
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'io.curity.vc.serialization.Companion.fromJson.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var key = element.a1();
      // Inline function 'kotlin.collections.component2' call
      var value = element.b1();
      var pair = to(key, Companion_instance_41.d27(value));
      destination.m2(pair.z9_1, pair.aa_1);
    }
    return new JwtVcJsonCredentialSubjectMetadata(destination);
  };
  var Companion_instance_40;
  function Companion_getInstance_38() {
    return Companion_instance_40;
  }
  function JwtVcJsonCredentialSubjectMetadata$_serialized$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.associate' call
      var this_0 = this$0.u39_1.z();
      var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
      // Inline function 'kotlin.collections.associateTo' call
      var destination = LinkedHashMap_init_$Create$_0(capacity);
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'kotlin.collections.plusAssign' call
        // Inline function 'io.curity.vc.serialization.JwtVcJsonCredentialSubjectMetadata._serialized.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = element.a1();
        // Inline function 'kotlin.collections.component2' call
        var value = element.b1();
        var pair = to(key, value.y26().a27());
        destination.m2(pair.z9_1, pair.aa_1);
      }
      return new JsonDictionary(destination);
    };
  }
  function JwtVcJsonCredentialSubjectMetadata(claims) {
    this.u39_1 = claims;
    var tmp = this;
    tmp.v39_1 = lazy(JwtVcJsonCredentialSubjectMetadata$_serialized$lambda(this));
  }
  protoOf(JwtVcJsonCredentialSubjectMetadata).y26 = function () {
    return this.v39_1.b1();
  };
  protoOf(JwtVcJsonCredentialSubjectMetadata).toString = function () {
    return 'JwtVcJsonCredentialSubjectMetadata(claims=' + toString(this.u39_1) + ')';
  };
  protoOf(JwtVcJsonCredentialSubjectMetadata).hashCode = function () {
    return hashCode(this.u39_1);
  };
  protoOf(JwtVcJsonCredentialSubjectMetadata).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtVcJsonCredentialSubjectMetadata))
      return false;
    var tmp0_other_with_cast = other instanceof JwtVcJsonCredentialSubjectMetadata ? other : THROW_CCE();
    if (!equals(this.u39_1, tmp0_other_with_cast.u39_1))
      return false;
    return true;
  };
  function Companion_39() {
  }
  protoOf(Companion_39).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonLogo'));
    return new JwtVcJsonCredentialSubjectEntryMetadata(unwrapOptionalString(map, 'value_type'), unwrapOptionalDisplays(map, 'display'), unwrapOptionalBoolean(map, 'mandatory'), map.s() ? null : new JsonDictionary(toMap(map)));
  };
  var Companion_instance_41;
  function Companion_getInstance_39() {
    return Companion_instance_41;
  }
  function _get__serializable__azf9o3_8($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.a3a_1;
    _serializable$factory_8();
    return this_0.b1();
  }
  function JwtVcJsonCredentialSubjectEntryMetadata$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.JwtVcJsonCredentialSubjectEntryMetadata._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.z39_1 == null)) {
        this_0.o2(this$0.z39_1.a27());
      }
      if (!(this$0.w39_1 == null)) {
        this_0.m2('value_type', toJson(this$0.w39_1));
      }
      if (!(this$0.x39_1 == null)) {
        this_0.m2('display', toJsons(this$0.x39_1));
      }
      if (!(this$0.y39_1 == null)) {
        this_0.m2('mandatory', toJson_2(this$0.y39_1));
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JwtVcJsonCredentialSubjectEntryMetadata(valueType, display, mandatory, customClaims) {
    valueType = valueType === VOID ? null : valueType;
    display = display === VOID ? null : display;
    mandatory = mandatory === VOID ? null : mandatory;
    customClaims = customClaims === VOID ? null : customClaims;
    this.w39_1 = valueType;
    this.x39_1 = display;
    this.y39_1 = mandatory;
    this.z39_1 = customClaims;
    var tmp = this;
    tmp.a3a_1 = lazy(JwtVcJsonCredentialSubjectEntryMetadata$_serializable$delegate$lambda(this));
  }
  protoOf(JwtVcJsonCredentialSubjectEntryMetadata).y26 = function () {
    return _get__serializable__azf9o3_8(this);
  };
  protoOf(JwtVcJsonCredentialSubjectEntryMetadata).toString = function () {
    return 'JwtVcJsonCredentialSubjectEntryMetadata(valueType=' + this.w39_1 + ', display=' + toString_0(this.x39_1) + ', mandatory=' + this.y39_1 + ', customClaims=' + toString_0(this.z39_1) + ')';
  };
  protoOf(JwtVcJsonCredentialSubjectEntryMetadata).hashCode = function () {
    var result = this.w39_1 == null ? 0 : getStringHashCode(this.w39_1);
    result = imul(result, 31) + (this.x39_1 == null ? 0 : hashCode(this.x39_1)) | 0;
    result = imul(result, 31) + (this.y39_1 == null ? 0 : getBooleanHashCode(this.y39_1)) | 0;
    result = imul(result, 31) + (this.z39_1 == null ? 0 : hashCode(this.z39_1)) | 0;
    return result;
  };
  protoOf(JwtVcJsonCredentialSubjectEntryMetadata).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtVcJsonCredentialSubjectEntryMetadata))
      return false;
    var tmp0_other_with_cast = other instanceof JwtVcJsonCredentialSubjectEntryMetadata ? other : THROW_CCE();
    if (!(this.w39_1 == tmp0_other_with_cast.w39_1))
      return false;
    if (!equals(this.x39_1, tmp0_other_with_cast.x39_1))
      return false;
    if (!(this.y39_1 == tmp0_other_with_cast.y39_1))
      return false;
    if (!equals(this.z39_1, tmp0_other_with_cast.z39_1))
      return false;
    return true;
  };
  function _serializable$factory_8() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_8(receiver);
    }, null);
  }
  function Companion_40() {
  }
  protoOf(Companion_40).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'CredentialDefinition'));
    return new CredentialDefinition(unwrapStringSet(map, 'type'), unwrapOptionalJsonDictionary(map, 'credentialSubject'));
  };
  var Companion_instance_42;
  function Companion_getInstance_40() {
    return Companion_instance_42;
  }
  function _get__serializable__azf9o3_9($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.d3a_1;
    _serializable$factory_9();
    return this_0.b1();
  }
  function JwtVcJsonVerifiableCredentialRequest$CredentialDefinition$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.CredentialDefinition._serializable$delegate.<anonymous>.<anonymous>' call
      this_0.m2('type', toJson_3(this$0.b3a_1));
      if (!(this$0.c3a_1 == null)) {
        this_0.m2('credentialSubject', this$0.c3a_1.a27());
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function CredentialDefinition(type, credentialSubject) {
    credentialSubject = credentialSubject === VOID ? null : credentialSubject;
    this.b3a_1 = type;
    this.c3a_1 = credentialSubject;
    var tmp = this;
    tmp.d3a_1 = lazy(JwtVcJsonVerifiableCredentialRequest$CredentialDefinition$_serializable$delegate$lambda(this));
  }
  protoOf(CredentialDefinition).y26 = function () {
    return _get__serializable__azf9o3_9(this);
  };
  protoOf(CredentialDefinition).toString = function () {
    return 'CredentialDefinition(type=' + toString(this.b3a_1) + ', credentialSubject=' + toString_0(this.c3a_1) + ')';
  };
  protoOf(CredentialDefinition).hashCode = function () {
    var result = hashCode(this.b3a_1);
    result = imul(result, 31) + (this.c3a_1 == null ? 0 : hashCode(this.c3a_1)) | 0;
    return result;
  };
  protoOf(CredentialDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CredentialDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof CredentialDefinition ? other : THROW_CCE();
    if (!equals(this.b3a_1, tmp0_other_with_cast.b3a_1))
      return false;
    if (!equals(this.c3a_1, tmp0_other_with_cast.c3a_1))
      return false;
    return true;
  };
  function Companion_41() {
  }
  var Companion_instance_43;
  function Companion_getInstance_41() {
    return Companion_instance_43;
  }
  function $serializer_22() {
    $serializer_instance_22 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JwtVcJsonVerifiableCredentialRequest', this, 3);
    tmp0_serialDesc.wy('proof', true);
    tmp0_serialDesc.wy('credential_definition', false);
    tmp0_serialDesc.wy('format', false);
    this.e3a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_22).f3a = function (encoder, value) {
    var tmp0_desc = this.e3a_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.g3a_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), value.g3a_1);
    }
    tmp1_output.bt(tmp0_desc, 1, JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance(), value.h3a_1);
    tmp1_output.zs(tmp0_desc, 2, value.i3a_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_22).zn = function (encoder, value) {
    return this.f3a(encoder, value instanceof JwtVcJsonVerifiableCredentialRequest ? value : THROW_CCE());
  };
  protoOf($serializer_22).ao = function (decoder) {
    var tmp0_desc = this.e3a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JwtVcJsonVerifiableCredentialRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_22).yn = function () {
    return this.e3a_1;
  };
  protoOf($serializer_22).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(ToJsonProofOfPossessionSerializer_getInstance()), JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_22;
  function $serializer_getInstance_23() {
    if ($serializer_instance_22 == null)
      new $serializer_22();
    return $serializer_instance_22;
  }
  function JwtVcJsonVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, $this) {
    if (!(6 === (6 & seen0))) {
      throwMissingFieldException(seen0, 6, $serializer_getInstance_23().e3a_1);
    }
    if (0 === (seen0 & 1))
      $this.g3a_1 = null;
    else
      $this.g3a_1 = proof;
    $this.h3a_1 = credentialDefinition;
    $this.i3a_1 = format;
    return $this;
  }
  function JwtVcJsonVerifiableCredentialRequest_init_$Create$(seen0, proof, credentialDefinition, format, serializationConstructorMarker) {
    return JwtVcJsonVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonVerifiableCredentialRequest)));
  }
  function JwtVcJsonVerifiableCredentialRequest(proof, credentialDefinition, format) {
    proof = proof === VOID ? null : proof;
    format = format === VOID ? 'jwt_vc_json' : format;
    this.g3a_1 = proof;
    this.h3a_1 = credentialDefinition;
    this.i3a_1 = format;
  }
  protoOf(JwtVcJsonVerifiableCredentialRequest).toString = function () {
    return 'JwtVcJsonVerifiableCredentialRequest(proof=' + toString_0(this.g3a_1) + ', credentialDefinition=' + this.h3a_1.toString() + ', format=' + this.i3a_1 + ')';
  };
  protoOf(JwtVcJsonVerifiableCredentialRequest).hashCode = function () {
    var result = this.g3a_1 == null ? 0 : hashCode(this.g3a_1);
    result = imul(result, 31) + this.h3a_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.i3a_1) | 0;
    return result;
  };
  protoOf(JwtVcJsonVerifiableCredentialRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtVcJsonVerifiableCredentialRequest))
      return false;
    var tmp0_other_with_cast = other instanceof JwtVcJsonVerifiableCredentialRequest ? other : THROW_CCE();
    if (!equals(this.g3a_1, tmp0_other_with_cast.g3a_1))
      return false;
    if (!this.h3a_1.equals(tmp0_other_with_cast.h3a_1))
      return false;
    if (!(this.i3a_1 === tmp0_other_with_cast.i3a_1))
      return false;
    return true;
  };
  function Companion_42() {
  }
  protoOf(Companion_42).b1b = function () {
    return $serializer_getInstance_24();
  };
  var Companion_instance_44;
  function Companion_getInstance_42() {
    return Companion_instance_44;
  }
  function $serializer_23() {
    $serializer_instance_23 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JwtVcJsonLdVerifiableCredentialRequest', this, 3);
    tmp0_serialDesc.wy('proof', true);
    tmp0_serialDesc.wy('credential_definition', false);
    tmp0_serialDesc.wy('format', false);
    this.j3a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_23).k3a = function (encoder, value) {
    var tmp0_desc = this.j3a_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.l3a_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), value.l3a_1);
    }
    tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_7(), value.m3a_1);
    tmp1_output.zs(tmp0_desc, 2, value.n3a_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_23).zn = function (encoder, value) {
    return this.k3a(encoder, value instanceof JwtVcJsonLdVerifiableCredentialRequest ? value : THROW_CCE());
  };
  protoOf($serializer_23).ao = function (decoder) {
    var tmp0_desc = this.j3a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JwtVcJsonLdVerifiableCredentialRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_23).yn = function () {
    return this.j3a_1;
  };
  protoOf($serializer_23).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(ToJsonProofOfPossessionSerializer_getInstance()), $serializer_getInstance_7(), StringSerializer_getInstance()];
  };
  var $serializer_instance_23;
  function $serializer_getInstance_24() {
    if ($serializer_instance_23 == null)
      new $serializer_23();
    return $serializer_instance_23;
  }
  function JwtVcJsonLdVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, $this) {
    if (!(6 === (6 & seen0))) {
      throwMissingFieldException(seen0, 6, $serializer_getInstance_24().j3a_1);
    }
    if (0 === (seen0 & 1))
      $this.l3a_1 = null;
    else
      $this.l3a_1 = proof;
    $this.m3a_1 = credentialDefinition;
    $this.n3a_1 = format;
    return $this;
  }
  function JwtVcJsonLdVerifiableCredentialRequest_init_$Create$(seen0, proof, credentialDefinition, format, serializationConstructorMarker) {
    return JwtVcJsonLdVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonLdVerifiableCredentialRequest)));
  }
  function JwtVcJsonLdVerifiableCredentialRequest(proof, credentialDefinition, format) {
    proof = proof === VOID ? null : proof;
    format = format === VOID ? 'jwt_vc_json-ld' : format;
    this.l3a_1 = proof;
    this.m3a_1 = credentialDefinition;
    this.n3a_1 = format;
  }
  protoOf(JwtVcJsonLdVerifiableCredentialRequest).toString = function () {
    return 'JwtVcJsonLdVerifiableCredentialRequest(proof=' + toString_0(this.l3a_1) + ', credentialDefinition=' + this.m3a_1.toString() + ', format=' + this.n3a_1 + ')';
  };
  protoOf(JwtVcJsonLdVerifiableCredentialRequest).hashCode = function () {
    var result = this.l3a_1 == null ? 0 : hashCode(this.l3a_1);
    result = imul(result, 31) + this.m3a_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.n3a_1) | 0;
    return result;
  };
  protoOf(JwtVcJsonLdVerifiableCredentialRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtVcJsonLdVerifiableCredentialRequest))
      return false;
    var tmp0_other_with_cast = other instanceof JwtVcJsonLdVerifiableCredentialRequest ? other : THROW_CCE();
    if (!equals(this.l3a_1, tmp0_other_with_cast.l3a_1))
      return false;
    if (!this.m3a_1.equals(tmp0_other_with_cast.m3a_1))
      return false;
    if (!(this.n3a_1 === tmp0_other_with_cast.n3a_1))
      return false;
    return true;
  };
  function Companion_43() {
  }
  protoOf(Companion_43).b1b = function () {
    return $serializer_getInstance_25();
  };
  var Companion_instance_45;
  function Companion_getInstance_43() {
    return Companion_instance_45;
  }
  function $serializer_24() {
    $serializer_instance_24 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.LdpVerifiableCredentialRequest', this, 3);
    tmp0_serialDesc.wy('proof', true);
    tmp0_serialDesc.wy('credential_definition', false);
    tmp0_serialDesc.wy('format', false);
    this.o3a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_24).p3a = function (encoder, value) {
    var tmp0_desc = this.o3a_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.q3a_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), value.q3a_1);
    }
    tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_7(), value.r3a_1);
    tmp1_output.zs(tmp0_desc, 2, value.s3a_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_24).zn = function (encoder, value) {
    return this.p3a(encoder, value instanceof LdpVerifiableCredentialRequest ? value : THROW_CCE());
  };
  protoOf($serializer_24).ao = function (decoder) {
    var tmp0_desc = this.o3a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.zr(tmp0_desc, 0, ToJsonProofOfPossessionSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.xr(tmp0_desc, 1, $serializer_getInstance_7(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return LdpVerifiableCredentialRequest_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_24).yn = function () {
    return this.o3a_1;
  };
  protoOf($serializer_24).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(ToJsonProofOfPossessionSerializer_getInstance()), $serializer_getInstance_7(), StringSerializer_getInstance()];
  };
  var $serializer_instance_24;
  function $serializer_getInstance_25() {
    if ($serializer_instance_24 == null)
      new $serializer_24();
    return $serializer_instance_24;
  }
  function LdpVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, $this) {
    if (!(6 === (6 & seen0))) {
      throwMissingFieldException(seen0, 6, $serializer_getInstance_25().o3a_1);
    }
    if (0 === (seen0 & 1))
      $this.q3a_1 = null;
    else
      $this.q3a_1 = proof;
    $this.r3a_1 = credentialDefinition;
    $this.s3a_1 = format;
    return $this;
  }
  function LdpVerifiableCredentialRequest_init_$Create$(seen0, proof, credentialDefinition, format, serializationConstructorMarker) {
    return LdpVerifiableCredentialRequest_init_$Init$(seen0, proof, credentialDefinition, format, serializationConstructorMarker, objectCreate(protoOf(LdpVerifiableCredentialRequest)));
  }
  function LdpVerifiableCredentialRequest(proof, credentialDefinition, format) {
    proof = proof === VOID ? null : proof;
    format = format === VOID ? 'ldp_vc' : format;
    this.q3a_1 = proof;
    this.r3a_1 = credentialDefinition;
    this.s3a_1 = format;
  }
  protoOf(LdpVerifiableCredentialRequest).toString = function () {
    return 'LdpVerifiableCredentialRequest(proof=' + toString_0(this.q3a_1) + ', credentialDefinition=' + this.r3a_1.toString() + ', format=' + this.s3a_1 + ')';
  };
  protoOf(LdpVerifiableCredentialRequest).hashCode = function () {
    var result = this.q3a_1 == null ? 0 : hashCode(this.q3a_1);
    result = imul(result, 31) + this.r3a_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.s3a_1) | 0;
    return result;
  };
  protoOf(LdpVerifiableCredentialRequest).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LdpVerifiableCredentialRequest))
      return false;
    var tmp0_other_with_cast = other instanceof LdpVerifiableCredentialRequest ? other : THROW_CCE();
    if (!equals(this.q3a_1, tmp0_other_with_cast.q3a_1))
      return false;
    if (!this.r3a_1.equals(tmp0_other_with_cast.r3a_1))
      return false;
    if (!(this.s3a_1 === tmp0_other_with_cast.s3a_1))
      return false;
    return true;
  };
  function Companion_44() {
    Companion_instance_46 = this;
    CompositeFromJson.call(this, Companion_instance_0);
    this.u3a_1 = new JsonObject(emptyMap());
  }
  protoOf(Companion_44).v3a = function (toJson) {
    return new BasicCredentialSubject(toJson.f2());
  };
  protoOf(Companion_44).n27 = function (toJson) {
    return this.v3a(toJson instanceof JsonDictionary ? toJson : THROW_CCE());
  };
  var Companion_instance_46;
  function Companion_getInstance_44() {
    if (Companion_instance_46 == null)
      new Companion_44();
    return Companion_instance_46;
  }
  function _get__map__d2qn2m($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.x3a_1;
    _map$factory();
    return this_0.b1();
  }
  function BasicCredentialSubject$_map$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.associateWith' call
      var this_0 = this$0.w3a_1;
      var result = LinkedHashMap_init_$Create$_0(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
      // Inline function 'kotlin.collections.associateWithTo' call
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'io.curity.vc.serialization.BasicCredentialSubject._map$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = Companion_getInstance_44().u3a_1;
        result.m2(element, tmp$ret$0);
      }
      return result;
    };
  }
  function BasicCredentialSubject(_claims) {
    Companion_getInstance_44();
    this.w3a_1 = _claims;
    var tmp = this;
    tmp.x3a_1 = lazy(BasicCredentialSubject$_map$delegate$lambda(this));
  }
  protoOf(BasicCredentialSubject).y26 = function () {
    return new JsonDictionary(_get__map__d2qn2m(this));
  };
  protoOf(BasicCredentialSubject).xl = function () {
    return _get__map__d2qn2m(this);
  };
  protoOf(BasicCredentialSubject).toString = function () {
    return 'BasicCredentialSubject(_claims=' + toString(this.w3a_1) + ')';
  };
  protoOf(BasicCredentialSubject).hashCode = function () {
    return hashCode(this.w3a_1);
  };
  protoOf(BasicCredentialSubject).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BasicCredentialSubject))
      return false;
    var tmp0_other_with_cast = other instanceof BasicCredentialSubject ? other : THROW_CCE();
    if (!equals(this.w3a_1, tmp0_other_with_cast.w3a_1))
      return false;
    return true;
  };
  function _serializable$factory_9() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_9(receiver);
    }, null);
  }
  function _map$factory() {
    return getPropertyCallableRef('_map', 1, KProperty1, function (receiver) {
      return _get__map__d2qn2m(receiver);
    }, null);
  }
  function Companion_45() {
  }
  protoOf(Companion_45).b1b = function () {
    return $serializer_getInstance_26();
  };
  var Companion_instance_47;
  function Companion_getInstance_45() {
    return Companion_instance_47;
  }
  function $serializer_25() {
    $serializer_instance_25 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JwtVcJsonVerifiableCredentialResponse', this, 3);
    tmp0_serialDesc.wy('credential', false);
    tmp0_serialDesc.wy('c_nonce', true);
    tmp0_serialDesc.wy('c_nonce_expires_in', true);
    this.y3a_1 = tmp0_serialDesc;
  }
  protoOf($serializer_25).z3a = function (encoder, value) {
    var tmp0_desc = this.y3a_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.a3b_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.b3b_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.b3b_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.c3b_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.c3b_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_25).zn = function (encoder, value) {
    return this.z3a(encoder, value instanceof JwtVcJsonVerifiableCredentialResponse ? value : THROW_CCE());
  };
  protoOf($serializer_25).ao = function (decoder) {
    var tmp0_desc = this.y3a_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JwtVcJsonVerifiableCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_25).yn = function () {
    return this.y3a_1;
  };
  protoOf($serializer_25).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_25;
  function $serializer_getInstance_26() {
    if ($serializer_instance_25 == null)
      new $serializer_25();
    return $serializer_instance_25;
  }
  function JwtVcJsonVerifiableCredentialResponse_init_$Init$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_26().y3a_1);
    }
    $this.a3b_1 = _credential;
    if (0 === (seen0 & 2))
      $this.b3b_1 = null;
    else
      $this.b3b_1 = cNonce;
    if (0 === (seen0 & 4))
      $this.c3b_1 = null;
    else
      $this.c3b_1 = cNonceExpiresIn;
    return $this;
  }
  function JwtVcJsonVerifiableCredentialResponse_init_$Create$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
    return JwtVcJsonVerifiableCredentialResponse_init_$Init$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonVerifiableCredentialResponse)));
  }
  function JwtVcJsonVerifiableCredentialResponse() {
  }
  protoOf(JwtVcJsonVerifiableCredentialResponse).n38 = function () {
    return new StringCredential(this.a3b_1);
  };
  protoOf(JwtVcJsonVerifiableCredentialResponse).toString = function () {
    return 'JwtVcJsonVerifiableCredentialResponse(_credential=' + this.a3b_1 + ', cNonce=' + this.b3b_1 + ', cNonceExpiresIn=' + toString_0(this.c3b_1) + ')';
  };
  protoOf(JwtVcJsonVerifiableCredentialResponse).hashCode = function () {
    var result = getStringHashCode(this.a3b_1);
    result = imul(result, 31) + (this.b3b_1 == null ? 0 : getStringHashCode(this.b3b_1)) | 0;
    result = imul(result, 31) + (this.c3b_1 == null ? 0 : this.c3b_1.hashCode()) | 0;
    return result;
  };
  protoOf(JwtVcJsonVerifiableCredentialResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtVcJsonVerifiableCredentialResponse))
      return false;
    var tmp0_other_with_cast = other instanceof JwtVcJsonVerifiableCredentialResponse ? other : THROW_CCE();
    if (!(this.a3b_1 === tmp0_other_with_cast.a3b_1))
      return false;
    if (!(this.b3b_1 == tmp0_other_with_cast.b3b_1))
      return false;
    if (!equals(this.c3b_1, tmp0_other_with_cast.c3b_1))
      return false;
    return true;
  };
  function Companion_46() {
  }
  protoOf(Companion_46).b1b = function () {
    return $serializer_getInstance_27();
  };
  var Companion_instance_48;
  function Companion_getInstance_46() {
    return Companion_instance_48;
  }
  function $serializer_26() {
    $serializer_instance_26 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.LdpVcVerifiableCredentialResponse', this, 3);
    tmp0_serialDesc.wy('credential', false);
    tmp0_serialDesc.wy('c_nonce', true);
    tmp0_serialDesc.wy('c_nonce_expires_in', true);
    this.d3b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_26).e3b = function (encoder, value) {
    var tmp0_desc = this.d3b_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.bt(tmp0_desc, 0, SerializableW3CVerifiableCredentialSerializer_getInstance(), value.f3b_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.g3b_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.g3b_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.h3b_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.h3b_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_26).zn = function (encoder, value) {
    return this.e3b(encoder, value instanceof LdpVcVerifiableCredentialResponse ? value : THROW_CCE());
  };
  protoOf($serializer_26).ao = function (decoder) {
    var tmp0_desc = this.d3b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, SerializableW3CVerifiableCredentialSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.xr(tmp0_desc, 0, SerializableW3CVerifiableCredentialSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return LdpVcVerifiableCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_26).yn = function () {
    return this.d3b_1;
  };
  protoOf($serializer_26).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [SerializableW3CVerifiableCredentialSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_26;
  function $serializer_getInstance_27() {
    if ($serializer_instance_26 == null)
      new $serializer_26();
    return $serializer_instance_26;
  }
  function LdpVcVerifiableCredentialResponse_init_$Init$(seen0, w3cCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_27().d3b_1);
    }
    $this.f3b_1 = w3cCredential;
    if (0 === (seen0 & 2))
      $this.g3b_1 = null;
    else
      $this.g3b_1 = cNonce;
    if (0 === (seen0 & 4))
      $this.h3b_1 = null;
    else
      $this.h3b_1 = cNonceExpiresIn;
    return $this;
  }
  function LdpVcVerifiableCredentialResponse_init_$Create$(seen0, w3cCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
    return LdpVcVerifiableCredentialResponse_init_$Init$(seen0, w3cCredential, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(LdpVcVerifiableCredentialResponse)));
  }
  function LdpVcVerifiableCredentialResponse() {
  }
  protoOf(LdpVcVerifiableCredentialResponse).n38 = function () {
    return new DictionaryCredential(this.f3b_1);
  };
  protoOf(LdpVcVerifiableCredentialResponse).toString = function () {
    return 'LdpVcVerifiableCredentialResponse(w3cCredential=' + this.f3b_1.toString() + ', cNonce=' + this.g3b_1 + ', cNonceExpiresIn=' + toString_0(this.h3b_1) + ')';
  };
  protoOf(LdpVcVerifiableCredentialResponse).hashCode = function () {
    var result = this.f3b_1.hashCode();
    result = imul(result, 31) + (this.g3b_1 == null ? 0 : getStringHashCode(this.g3b_1)) | 0;
    result = imul(result, 31) + (this.h3b_1 == null ? 0 : this.h3b_1.hashCode()) | 0;
    return result;
  };
  protoOf(LdpVcVerifiableCredentialResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LdpVcVerifiableCredentialResponse))
      return false;
    var tmp0_other_with_cast = other instanceof LdpVcVerifiableCredentialResponse ? other : THROW_CCE();
    if (!this.f3b_1.equals(tmp0_other_with_cast.f3b_1))
      return false;
    if (!(this.g3b_1 == tmp0_other_with_cast.g3b_1))
      return false;
    if (!equals(this.h3b_1, tmp0_other_with_cast.h3b_1))
      return false;
    return true;
  };
  function Companion_47() {
  }
  protoOf(Companion_47).b1b = function () {
    return $serializer_getInstance_28();
  };
  var Companion_instance_49;
  function Companion_getInstance_47() {
    return Companion_instance_49;
  }
  function $serializer_27() {
    $serializer_instance_27 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vc.serialization.JwtVcJsonLdVerifiableCredentialResponse', this, 3);
    tmp0_serialDesc.wy('credential', false);
    tmp0_serialDesc.wy('c_nonce', true);
    tmp0_serialDesc.wy('c_nonce_expires_in', true);
    this.i3b_1 = tmp0_serialDesc;
  }
  protoOf($serializer_27).j3b = function (encoder, value) {
    var tmp0_desc = this.i3b_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.k3b_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.l3b_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.l3b_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.m3b_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, LongSerializer_getInstance(), value.m3b_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_27).zn = function (encoder, value) {
    return this.j3b(encoder, value instanceof JwtVcJsonLdVerifiableCredentialResponse ? value : THROW_CCE());
  };
  protoOf($serializer_27).ao = function (decoder) {
    var tmp0_desc = this.i3b_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.zr(tmp0_desc, 2, LongSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JwtVcJsonLdVerifiableCredentialResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_27).yn = function () {
    return this.i3b_1;
  };
  protoOf($serializer_27).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  var $serializer_instance_27;
  function $serializer_getInstance_28() {
    if ($serializer_instance_27 == null)
      new $serializer_27();
    return $serializer_instance_27;
  }
  function JwtVcJsonLdVerifiableCredentialResponse_init_$Init$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_28().i3b_1);
    }
    $this.k3b_1 = _credential;
    if (0 === (seen0 & 2))
      $this.l3b_1 = null;
    else
      $this.l3b_1 = cNonce;
    if (0 === (seen0 & 4))
      $this.m3b_1 = null;
    else
      $this.m3b_1 = cNonceExpiresIn;
    return $this;
  }
  function JwtVcJsonLdVerifiableCredentialResponse_init_$Create$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker) {
    return JwtVcJsonLdVerifiableCredentialResponse_init_$Init$(seen0, _credential, cNonce, cNonceExpiresIn, serializationConstructorMarker, objectCreate(protoOf(JwtVcJsonLdVerifiableCredentialResponse)));
  }
  function JwtVcJsonLdVerifiableCredentialResponse() {
  }
  protoOf(JwtVcJsonLdVerifiableCredentialResponse).n38 = function () {
    return new StringCredential(this.k3b_1);
  };
  protoOf(JwtVcJsonLdVerifiableCredentialResponse).toString = function () {
    return 'JwtVcJsonLdVerifiableCredentialResponse(_credential=' + this.k3b_1 + ', cNonce=' + this.l3b_1 + ', cNonceExpiresIn=' + toString_0(this.m3b_1) + ')';
  };
  protoOf(JwtVcJsonLdVerifiableCredentialResponse).hashCode = function () {
    var result = getStringHashCode(this.k3b_1);
    result = imul(result, 31) + (this.l3b_1 == null ? 0 : getStringHashCode(this.l3b_1)) | 0;
    result = imul(result, 31) + (this.m3b_1 == null ? 0 : this.m3b_1.hashCode()) | 0;
    return result;
  };
  protoOf(JwtVcJsonLdVerifiableCredentialResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JwtVcJsonLdVerifiableCredentialResponse))
      return false;
    var tmp0_other_with_cast = other instanceof JwtVcJsonLdVerifiableCredentialResponse ? other : THROW_CCE();
    if (!(this.k3b_1 === tmp0_other_with_cast.k3b_1))
      return false;
    if (!(this.l3b_1 == tmp0_other_with_cast.l3b_1))
      return false;
    if (!equals(this.m3b_1, tmp0_other_with_cast.m3b_1))
      return false;
    return true;
  };
  function Companion_48() {
  }
  protoOf(Companion_48).b1b = function () {
    return DeferredJwtVcJsonCredentialResponseSerializer_getInstance();
  };
  var Companion_instance_50;
  function Companion_getInstance_48() {
    return Companion_instance_50;
  }
  function Deferred(value) {
    this.n3b_1 = value;
  }
  protoOf(Deferred).toString = function () {
    return 'Deferred(value=' + this.n3b_1.toString() + ')';
  };
  protoOf(Deferred).hashCode = function () {
    return this.n3b_1.hashCode();
  };
  protoOf(Deferred).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Deferred))
      return false;
    var tmp0_other_with_cast = other instanceof Deferred ? other : THROW_CCE();
    if (!this.n3b_1.equals(tmp0_other_with_cast.n3b_1))
      return false;
    return true;
  };
  function JwtVcJsonCredentialResponse() {
  }
  function Companion_49() {
  }
  protoOf(Companion_49).b1b = function () {
    return DeferredLdpVcCredentialResponseSerializer_getInstance();
  };
  var Companion_instance_51;
  function Companion_getInstance_49() {
    return Companion_instance_51;
  }
  function Deferred_0(value) {
    this.o3b_1 = value;
  }
  protoOf(Deferred_0).toString = function () {
    return 'Deferred(value=' + this.o3b_1.toString() + ')';
  };
  protoOf(Deferred_0).hashCode = function () {
    return this.o3b_1.hashCode();
  };
  protoOf(Deferred_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Deferred_0))
      return false;
    var tmp0_other_with_cast = other instanceof Deferred_0 ? other : THROW_CCE();
    if (!this.o3b_1.equals(tmp0_other_with_cast.o3b_1))
      return false;
    return true;
  };
  function LdpVcCredentialResponse() {
  }
  function Companion_50() {
  }
  protoOf(Companion_50).b1b = function () {
    return DeferredJwtVcJsonLdCredentialResponseSerializer_getInstance();
  };
  var Companion_instance_52;
  function Companion_getInstance_50() {
    return Companion_instance_52;
  }
  function Deferred_1(value) {
    this.p3b_1 = value;
  }
  protoOf(Deferred_1).toString = function () {
    return 'Deferred(value=' + this.p3b_1.toString() + ')';
  };
  protoOf(Deferred_1).hashCode = function () {
    return this.p3b_1.hashCode();
  };
  protoOf(Deferred_1).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Deferred_1))
      return false;
    var tmp0_other_with_cast = other instanceof Deferred_1 ? other : THROW_CCE();
    if (!this.p3b_1.equals(tmp0_other_with_cast.p3b_1))
      return false;
    return true;
  };
  function JwtVcJsonLdCredentialResponse() {
  }
  function Companion_51() {
  }
  protoOf(Companion_51).b1b = function () {
    return DeferredVcSdJwtCredentialResponseSerializer_getInstance();
  };
  var Companion_instance_53;
  function Companion_getInstance_51() {
    return Companion_instance_53;
  }
  function Deferred_2(value) {
    this.q3b_1 = value;
  }
  protoOf(Deferred_2).toString = function () {
    return 'Deferred(value=' + this.q3b_1.toString() + ')';
  };
  protoOf(Deferred_2).hashCode = function () {
    return this.q3b_1.hashCode();
  };
  protoOf(Deferred_2).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Deferred_2))
      return false;
    var tmp0_other_with_cast = other instanceof Deferred_2 ? other : THROW_CCE();
    if (!this.q3b_1.equals(tmp0_other_with_cast.q3b_1))
      return false;
    return true;
  };
  function VcSdJwtCredentialResponse() {
  }
  function JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer() {
    JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_42);
  }
  var JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_instance;
  function JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_getInstance() {
    if (JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_instance == null)
      new JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer();
    return JwtVcJsonVerifiableCredentialRequestCredentialDefinitionSerializer_instance;
  }
  function DeferredJwtVcJsonCredentialResponseSerializer$_init_$lambda_thkxl0(v) {
    return v.n3b_1;
  }
  function DeferredJwtVcJsonCredentialResponseSerializer$_init_$lambda_thkxl0_0(v) {
    return new Deferred(v);
  }
  function DeferredJwtVcJsonCredentialResponseSerializer() {
    DeferredJwtVcJsonCredentialResponseSerializer_instance = this;
    var tmp = Companion_instance_25.b1b();
    var tmp_0 = DeferredJwtVcJsonCredentialResponseSerializer$_init_$lambda_thkxl0;
    DerivedSerializer.call(this, tmp, tmp_0, DeferredJwtVcJsonCredentialResponseSerializer$_init_$lambda_thkxl0_0);
  }
  var DeferredJwtVcJsonCredentialResponseSerializer_instance;
  function DeferredJwtVcJsonCredentialResponseSerializer_getInstance() {
    if (DeferredJwtVcJsonCredentialResponseSerializer_instance == null)
      new DeferredJwtVcJsonCredentialResponseSerializer();
    return DeferredJwtVcJsonCredentialResponseSerializer_instance;
  }
  function JwtVcJsonCredentialResponseSerializer() {
    JwtVcJsonCredentialResponseSerializer_instance = this;
    VerifiableCredentialResponseSerializer.call(this, getKClass(JwtVcJsonCredentialResponse), 'jwt_vc_json', Companion_instance_50.b1b(), Companion_instance_47.b1b());
  }
  var JwtVcJsonCredentialResponseSerializer_instance;
  function JwtVcJsonCredentialResponseSerializer_getInstance() {
    if (JwtVcJsonCredentialResponseSerializer_instance == null)
      new JwtVcJsonCredentialResponseSerializer();
    return JwtVcJsonCredentialResponseSerializer_instance;
  }
  function DeferredLdpVcCredentialResponseSerializer$_init_$lambda_msrwez(v) {
    return v.o3b_1;
  }
  function DeferredLdpVcCredentialResponseSerializer$_init_$lambda_msrwez_0(v) {
    return new Deferred_0(v);
  }
  function DeferredLdpVcCredentialResponseSerializer() {
    DeferredLdpVcCredentialResponseSerializer_instance = this;
    var tmp = Companion_instance_25.b1b();
    var tmp_0 = DeferredLdpVcCredentialResponseSerializer$_init_$lambda_msrwez;
    DerivedSerializer.call(this, tmp, tmp_0, DeferredLdpVcCredentialResponseSerializer$_init_$lambda_msrwez_0);
  }
  var DeferredLdpVcCredentialResponseSerializer_instance;
  function DeferredLdpVcCredentialResponseSerializer_getInstance() {
    if (DeferredLdpVcCredentialResponseSerializer_instance == null)
      new DeferredLdpVcCredentialResponseSerializer();
    return DeferredLdpVcCredentialResponseSerializer_instance;
  }
  function LdpVcCredentialResponseSerializer() {
    LdpVcCredentialResponseSerializer_instance = this;
    VerifiableCredentialResponseSerializer.call(this, getKClass(LdpVcCredentialResponse), 'ldp_vc', Companion_instance_51.b1b(), Companion_instance_48.b1b());
  }
  var LdpVcCredentialResponseSerializer_instance;
  function LdpVcCredentialResponseSerializer_getInstance() {
    if (LdpVcCredentialResponseSerializer_instance == null)
      new LdpVcCredentialResponseSerializer();
    return LdpVcCredentialResponseSerializer_instance;
  }
  function DeferredJwtVcJsonLdCredentialResponseSerializer$_init_$lambda_k5e34k(v) {
    return v.p3b_1;
  }
  function DeferredJwtVcJsonLdCredentialResponseSerializer$_init_$lambda_k5e34k_0(v) {
    return new Deferred_1(v);
  }
  function DeferredJwtVcJsonLdCredentialResponseSerializer() {
    DeferredJwtVcJsonLdCredentialResponseSerializer_instance = this;
    var tmp = Companion_instance_25.b1b();
    var tmp_0 = DeferredJwtVcJsonLdCredentialResponseSerializer$_init_$lambda_k5e34k;
    DerivedSerializer.call(this, tmp, tmp_0, DeferredJwtVcJsonLdCredentialResponseSerializer$_init_$lambda_k5e34k_0);
  }
  var DeferredJwtVcJsonLdCredentialResponseSerializer_instance;
  function DeferredJwtVcJsonLdCredentialResponseSerializer_getInstance() {
    if (DeferredJwtVcJsonLdCredentialResponseSerializer_instance == null)
      new DeferredJwtVcJsonLdCredentialResponseSerializer();
    return DeferredJwtVcJsonLdCredentialResponseSerializer_instance;
  }
  function JwtVcJsonLdCredentialResponseSerializer() {
    JwtVcJsonLdCredentialResponseSerializer_instance = this;
    VerifiableCredentialResponseSerializer.call(this, getKClass(JwtVcJsonLdCredentialResponse), 'jwt_vc_json-ld', Companion_instance_52.b1b(), Companion_instance_49.b1b());
  }
  var JwtVcJsonLdCredentialResponseSerializer_instance;
  function JwtVcJsonLdCredentialResponseSerializer_getInstance() {
    if (JwtVcJsonLdCredentialResponseSerializer_instance == null)
      new JwtVcJsonLdCredentialResponseSerializer();
    return JwtVcJsonLdCredentialResponseSerializer_instance;
  }
  function JsonSupportedCredentialSerializer() {
    JsonSupportedCredentialSerializer_instance = this;
    JsonContentPolymorphicSerializer.call(this, getKClass(JsonCredentialConfigurationsSupported));
  }
  protoOf(JsonSupportedCredentialSerializer).z1a = function (element) {
    var response = FromJsonHelper_instance.b27(element, 'JsonSupportedCredential');
    var format = getStringOrDefault(response, 'format');
    switch (format) {
      case 'jwt_vc_json':
        return Companion_getInstance_36().b1b();
      case 'vc+sd-jwt':
        return Companion_getInstance_27().b1b();
      default:
        return Companion_instance_17.b1b();
    }
  };
  var JsonSupportedCredentialSerializer_instance;
  function JsonSupportedCredentialSerializer_getInstance() {
    if (JsonSupportedCredentialSerializer_instance == null)
      new JsonSupportedCredentialSerializer();
    return JsonSupportedCredentialSerializer_instance;
  }
  function JwtVcJsonCredentialSubjectMetadataSerializer() {
    JwtVcJsonCredentialSubjectMetadataSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_40);
  }
  var JwtVcJsonCredentialSubjectMetadataSerializer_instance;
  function JwtVcJsonCredentialSubjectMetadataSerializer_getInstance() {
    if (JwtVcJsonCredentialSubjectMetadataSerializer_instance == null)
      new JwtVcJsonCredentialSubjectMetadataSerializer();
    return JwtVcJsonCredentialSubjectMetadataSerializer_instance;
  }
  function JwtVcJsonCredentialSubjectEntryMetadataSerializer() {
    JwtVcJsonCredentialSubjectEntryMetadataSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_41);
  }
  var JwtVcJsonCredentialSubjectEntryMetadataSerializer_instance;
  function JwtVcJsonCredentialSubjectEntryMetadataSerializer_getInstance() {
    if (JwtVcJsonCredentialSubjectEntryMetadataSerializer_instance == null)
      new JwtVcJsonCredentialSubjectEntryMetadataSerializer();
    return JwtVcJsonCredentialSubjectEntryMetadataSerializer_instance;
  }
  function VcSdJwtCredentialResponseSerializer() {
    VcSdJwtCredentialResponseSerializer_instance = this;
    VerifiableCredentialResponseSerializer.call(this, getKClass(VcSdJwtCredentialResponse), 'vc+sd-jwt', Companion_instance_53.b1b(), Companion_instance_33.b1b());
  }
  var VcSdJwtCredentialResponseSerializer_instance;
  function VcSdJwtCredentialResponseSerializer_getInstance() {
    if (VcSdJwtCredentialResponseSerializer_instance == null)
      new VcSdJwtCredentialResponseSerializer();
    return VcSdJwtCredentialResponseSerializer_instance;
  }
  function DeferredVcSdJwtCredentialResponseSerializer$_init_$lambda_obdfzd(v) {
    return v.q3b_1;
  }
  function DeferredVcSdJwtCredentialResponseSerializer$_init_$lambda_obdfzd_0(v) {
    return new Deferred_2(v);
  }
  function DeferredVcSdJwtCredentialResponseSerializer() {
    DeferredVcSdJwtCredentialResponseSerializer_instance = this;
    var tmp = Companion_instance_25.b1b();
    var tmp_0 = DeferredVcSdJwtCredentialResponseSerializer$_init_$lambda_obdfzd;
    DerivedSerializer.call(this, tmp, tmp_0, DeferredVcSdJwtCredentialResponseSerializer$_init_$lambda_obdfzd_0);
  }
  var DeferredVcSdJwtCredentialResponseSerializer_instance;
  function DeferredVcSdJwtCredentialResponseSerializer_getInstance() {
    if (DeferredVcSdJwtCredentialResponseSerializer_instance == null)
      new DeferredVcSdJwtCredentialResponseSerializer();
    return DeferredVcSdJwtCredentialResponseSerializer_instance;
  }
  function JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer() {
    JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_35);
  }
  var JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_instance;
  function JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_getInstance() {
    if (JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_instance == null)
      new JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer();
    return JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectSerializer_instance;
  }
  function JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer() {
    JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_36);
  }
  var JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_instance;
  function JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_getInstance() {
    if (JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_instance == null)
      new JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer();
    return JwtVcJsonAuthorizationDetailsCredentialDefinitionCredentialSubjectItemSerializer_instance;
  }
  function Companion_52() {
  }
  protoOf(Companion_52).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'SerializableW3CVerifiableCredential'));
    return new SerializableW3CVerifiableCredential(unwrapOptionalString(map, 'id'), unwrapStringList(map, '@context'), unwrapStringSet(map, 'type'), unwrapMultiValueJsonDictionary(map, 'credentialSubject'), unwrapIssuer(map, 'issuer'), unwrapString(map, 'issued'), unwrapOptionalProofs(map, 'proof'), unwrapOptionalString(map, 'expirationDate'), unwrapOptionalCredentialStatus(map, 'credentialStatus'), map.s() ? null : new JsonDictionary(toMap(map)));
  };
  protoOf(Companion_52).b1b = function () {
    return SerializableW3CVerifiableCredentialSerializer_getInstance();
  };
  var Companion_instance_54;
  function Companion_getInstance_52() {
    return Companion_instance_54;
  }
  function _get__serializable__azf9o3_10($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.d3c_1;
    _serializable$factory_10();
    return this_0.b1();
  }
  function SerializableW3CVerifiableCredential$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.SerializableW3CVerifiableCredential._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.c3c_1 == null)) {
        this_0.o2(this$0.c3c_1.a27());
      }
      if (!(this$0.t3b_1 == null)) {
        this_0.m2('id', toJson(this$0.t3b_1));
      }
      // Inline function 'kotlin.collections.map' call
      var this_1 = this$0.u3b_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'io.curity.vc.serialization.SerializableW3CVerifiableCredential._serializable$delegate.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$0 = toJson(item);
        destination.e(tmp$ret$0);
      }
      this_0.m2('@context', new JsonArray(destination));
      // Inline function 'kotlin.collections.map' call
      var this_2 = this$0.v3b_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
      var tmp0_iterator_0 = this_2.j();
      while (tmp0_iterator_0.k()) {
        var item_0 = tmp0_iterator_0.l();
        // Inline function 'io.curity.vc.serialization.SerializableW3CVerifiableCredential._serializable$delegate.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$3 = toJson(item_0);
        destination_0.e(tmp$ret$3);
      }
      this_0.m2('type', new JsonArray(destination_0));
      this_0.m2('credentialSubject', toJson_4(this$0.w3b_1));
      this_0.m2('issuer', this$0.x3b_1.a27());
      this_0.m2('issued', toJson(this$0.y3b_1));
      if (!(this$0.z3b_1 == null)) {
        this_0.m2('proof', toJson_4(this$0.z3b_1));
      }
      if (!(this$0.a3c_1 == null)) {
        this_0.m2('expirationDate', toJson(this$0.a3c_1));
      }
      if (!(this$0.b3c_1 == null)) {
        this_0.m2('credentialStatus', this$0.b3c_1.a27());
      }
      var tmp$ret$8 = this_0.r8();
      return new JsonDictionary(tmp$ret$8);
    };
  }
  function SerializableW3CVerifiableCredential(id, context, type, credentialSubject, jsonIssuer, issued, proof, expirationDate, credentialStatus, customClaims) {
    id = id === VOID ? null : id;
    proof = proof === VOID ? null : proof;
    expirationDate = expirationDate === VOID ? null : expirationDate;
    credentialStatus = credentialStatus === VOID ? null : credentialStatus;
    customClaims = customClaims === VOID ? null : customClaims;
    this.t3b_1 = id;
    this.u3b_1 = context;
    this.v3b_1 = type;
    this.w3b_1 = credentialSubject;
    this.x3b_1 = jsonIssuer;
    this.y3b_1 = issued;
    this.z3b_1 = proof;
    this.a3c_1 = expirationDate;
    this.b3c_1 = credentialStatus;
    this.c3c_1 = customClaims;
    var tmp = this;
    tmp.d3c_1 = lazy(SerializableW3CVerifiableCredential$_serializable$delegate$lambda(this));
  }
  protoOf(SerializableW3CVerifiableCredential).e3c = function () {
    return this.x3b_1.f3c();
  };
  protoOf(SerializableW3CVerifiableCredential).y26 = function () {
    return _get__serializable__azf9o3_10(this);
  };
  protoOf(SerializableW3CVerifiableCredential).toString = function () {
    return 'SerializableW3CVerifiableCredential(id=' + this.t3b_1 + ', context=' + toString(this.u3b_1) + ', type=' + toString(this.v3b_1) + ', credentialSubject=' + toString(this.w3b_1) + ', jsonIssuer=' + toString(this.x3b_1) + ', issued=' + this.y3b_1 + ', proof=' + toString_0(this.z3b_1) + ', expirationDate=' + this.a3c_1 + ', credentialStatus=' + toString_0(this.b3c_1) + ', customClaims=' + toString_0(this.c3c_1) + ')';
  };
  protoOf(SerializableW3CVerifiableCredential).hashCode = function () {
    var result = this.t3b_1 == null ? 0 : getStringHashCode(this.t3b_1);
    result = imul(result, 31) + hashCode(this.u3b_1) | 0;
    result = imul(result, 31) + hashCode(this.v3b_1) | 0;
    result = imul(result, 31) + hashCode(this.w3b_1) | 0;
    result = imul(result, 31) + hashCode(this.x3b_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.y3b_1) | 0;
    result = imul(result, 31) + (this.z3b_1 == null ? 0 : hashCode(this.z3b_1)) | 0;
    result = imul(result, 31) + (this.a3c_1 == null ? 0 : getStringHashCode(this.a3c_1)) | 0;
    result = imul(result, 31) + (this.b3c_1 == null ? 0 : this.b3c_1.hashCode()) | 0;
    result = imul(result, 31) + (this.c3c_1 == null ? 0 : hashCode(this.c3c_1)) | 0;
    return result;
  };
  protoOf(SerializableW3CVerifiableCredential).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializableW3CVerifiableCredential))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableW3CVerifiableCredential ? other : THROW_CCE();
    if (!(this.t3b_1 == tmp0_other_with_cast.t3b_1))
      return false;
    if (!equals(this.u3b_1, tmp0_other_with_cast.u3b_1))
      return false;
    if (!equals(this.v3b_1, tmp0_other_with_cast.v3b_1))
      return false;
    if (!equals(this.w3b_1, tmp0_other_with_cast.w3b_1))
      return false;
    if (!equals(this.x3b_1, tmp0_other_with_cast.x3b_1))
      return false;
    if (!(this.y3b_1 === tmp0_other_with_cast.y3b_1))
      return false;
    if (!equals(this.z3b_1, tmp0_other_with_cast.z3b_1))
      return false;
    if (!(this.a3c_1 == tmp0_other_with_cast.a3c_1))
      return false;
    if (!equals(this.b3c_1, tmp0_other_with_cast.b3c_1))
      return false;
    if (!equals(this.c3c_1, tmp0_other_with_cast.c3c_1))
      return false;
    return true;
  };
  function Companion_53() {
  }
  protoOf(Companion_53).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonCredentialStatus'));
    var id = unwrapString(map, 'id');
    var type = unwrapString(map, 'type');
    return new JsonCredentialStatus(id, type, new JsonDictionary(toMap(map)));
  };
  var Companion_instance_55;
  function Companion_getInstance_53() {
    return Companion_instance_55;
  }
  function _get__serializable__azf9o3_11($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.j3c_1;
    _serializable$factory_11();
    return this_0.b1();
  }
  function JsonCredentialStatus$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.JsonCredentialStatus._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.i3c_1 == null)) {
        this_0.o2(this$0.i3c_1.xl());
      }
      this_0.m2('id', JsonPrimitive_0(this$0.g3c_1));
      this_0.m2('type', JsonPrimitive_0(this$0.h3c_1));
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JsonCredentialStatus(id, type, customClaims) {
    customClaims = customClaims === VOID ? null : customClaims;
    this.g3c_1 = id;
    this.h3c_1 = type;
    this.i3c_1 = customClaims;
    var tmp = this;
    tmp.j3c_1 = lazy(JsonCredentialStatus$_serializable$delegate$lambda(this));
  }
  protoOf(JsonCredentialStatus).k2a = function () {
    return this.g3c_1;
  };
  protoOf(JsonCredentialStatus).g36 = function () {
    return this.h3c_1;
  };
  protoOf(JsonCredentialStatus).y26 = function () {
    return _get__serializable__azf9o3_11(this);
  };
  protoOf(JsonCredentialStatus).toString = function () {
    return 'JsonCredentialStatus(id=' + this.g3c_1 + ', type=' + this.h3c_1 + ', customClaims=' + toString_0(this.i3c_1) + ')';
  };
  protoOf(JsonCredentialStatus).hashCode = function () {
    var result = getStringHashCode(this.g3c_1);
    result = imul(result, 31) + getStringHashCode(this.h3c_1) | 0;
    result = imul(result, 31) + (this.i3c_1 == null ? 0 : this.i3c_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonCredentialStatus).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonCredentialStatus))
      return false;
    var tmp0_other_with_cast = other instanceof JsonCredentialStatus ? other : THROW_CCE();
    if (!(this.g3c_1 === tmp0_other_with_cast.g3c_1))
      return false;
    if (!(this.h3c_1 === tmp0_other_with_cast.h3c_1))
      return false;
    if (!equals(this.i3c_1, tmp0_other_with_cast.i3c_1))
      return false;
    return true;
  };
  function Companion_54() {
  }
  protoOf(Companion_54).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'IssuerObject'));
    var id = unwrapString(map, 'id');
    return new IssuerObject_0(id, map.s() ? null : new JsonDictionary(map));
  };
  var Companion_instance_56;
  function Companion_getInstance_54() {
    return Companion_instance_56;
  }
  function _get__serializedMap__cqopou($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.m3c_1;
    _serializedMap$factory();
    return this_0.b1();
  }
  function JsonIssuer$IssuerObject$_serializedMap$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vc.serialization.IssuerObject._serializedMap$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.l3c_1 == null)) {
        this_0.o2(this$0.l3c_1.xl());
      }
      this_0.m2('id', toJson(this$0.k3c_1));
      return this_0.r8();
    };
  }
  function JsonIssuer$IssuerObject$toIssuer$1($thisId, this$0) {
    this.p3c_1 = $thisId;
    MapDictionary.call(this, _get__serializedMap__cqopou(this$0));
    this.o3c_1 = $thisId;
  }
  protoOf(JsonIssuer$IssuerObject$toIssuer$1).k2a = function () {
    return this.o3c_1;
  };
  protoOf(JsonIssuer$IssuerObject$toIssuer$1).toString = function () {
    return this.p3c_1;
  };
  function IssuerURI_0(value) {
    this.m36_1 = value;
  }
  protoOf(IssuerURI_0).f3c = function () {
    return new IssuerURI(this.m36_1);
  };
  protoOf(IssuerURI_0).a27 = function () {
    return toJson(this.m36_1);
  };
  protoOf(IssuerURI_0).toString = function () {
    return 'IssuerURI(value=' + this.m36_1 + ')';
  };
  protoOf(IssuerURI_0).hashCode = function () {
    return getStringHashCode(this.m36_1);
  };
  protoOf(IssuerURI_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IssuerURI_0))
      return false;
    var tmp0_other_with_cast = other instanceof IssuerURI_0 ? other : THROW_CCE();
    if (!(this.m36_1 === tmp0_other_with_cast.m36_1))
      return false;
    return true;
  };
  function IssuerObject_0(id, customClaims) {
    customClaims = customClaims === VOID ? null : customClaims;
    this.k3c_1 = id;
    this.l3c_1 = customClaims;
    var tmp = this;
    tmp.m3c_1 = lazy(JsonIssuer$IssuerObject$_serializedMap$delegate$lambda(this));
  }
  protoOf(IssuerObject_0).f3c = function () {
    var thisId = this.k3c_1;
    return new JsonIssuer$IssuerObject$toIssuer$1(thisId, this);
  };
  protoOf(IssuerObject_0).a27 = function () {
    return new JsonObject(_get__serializedMap__cqopou(this));
  };
  protoOf(IssuerObject_0).toString = function () {
    return 'IssuerObject(id=' + this.k3c_1 + ', customClaims=' + toString_0(this.l3c_1) + ')';
  };
  protoOf(IssuerObject_0).hashCode = function () {
    var result = getStringHashCode(this.k3c_1);
    result = imul(result, 31) + (this.l3c_1 == null ? 0 : hashCode(this.l3c_1)) | 0;
    return result;
  };
  protoOf(IssuerObject_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof IssuerObject_0))
      return false;
    var tmp0_other_with_cast = other instanceof IssuerObject_0 ? other : THROW_CCE();
    if (!(this.k3c_1 === tmp0_other_with_cast.k3c_1))
      return false;
    if (!equals(this.l3c_1, tmp0_other_with_cast.l3c_1))
      return false;
    return true;
  };
  function JsonIssuer() {
  }
  function ToJsonIssuer() {
  }
  function _serializable$factory_10() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_10(receiver);
    }, null);
  }
  function _serializable$factory_11() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_11(receiver);
    }, null);
  }
  function _serializedMap$factory() {
    return getPropertyCallableRef('_serializedMap', 1, KProperty1, function (receiver) {
      return _get__serializedMap__cqopou(receiver);
    }, null);
  }
  function Companion_55() {
    Companion_instance_57 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r3c_1 = [null, null, new ArrayListSerializer($serializer_getInstance_30())];
  }
  var Companion_instance_57;
  function Companion_getInstance_55() {
    if (Companion_instance_57 == null)
      new Companion_55();
    return Companion_instance_57;
  }
  function $serializer_28() {
    $serializer_instance_28 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonPresentationSubmission', this, 3);
    tmp0_serialDesc.wy('id', false);
    tmp0_serialDesc.wy('definition_id', false);
    tmp0_serialDesc.wy('descriptor_map', false);
    this.s3c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_28).t3c = function (encoder, value) {
    var tmp0_desc = this.s3c_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_55().r3c_1;
    tmp1_output.zs(tmp0_desc, 0, value.u3c_1);
    tmp1_output.zs(tmp0_desc, 1, value.v3c_1);
    tmp1_output.bt(tmp0_desc, 2, tmp2_cached[2], value.w3c_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_28).zn = function (encoder, value) {
    return this.t3c(encoder, value instanceof JsonPresentationSubmission ? value : THROW_CCE());
  };
  protoOf($serializer_28).ao = function (decoder) {
    var tmp0_desc = this.s3c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_input = decoder.lr(tmp0_desc);
    var tmp8_cached = Companion_getInstance_55().r3c_1;
    if (tmp7_input.as()) {
      tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp7_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp7_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp7_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp7_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp7_input.xr(tmp0_desc, 2, tmp8_cached[2], tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp7_input.mr(tmp0_desc);
    return JsonPresentationSubmission_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
  };
  protoOf($serializer_28).yn = function () {
    return this.s3c_1;
  };
  protoOf($serializer_28).lz = function () {
    var tmp0_cached = Companion_getInstance_55().r3c_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), tmp0_cached[2]];
  };
  var $serializer_instance_28;
  function $serializer_getInstance_29() {
    if ($serializer_instance_28 == null)
      new $serializer_28();
    return $serializer_instance_28;
  }
  function JsonPresentationSubmission_init_$Init$(seen0, id, definitionId, descriptorMap, serializationConstructorMarker, $this) {
    if (!(7 === (7 & seen0))) {
      throwMissingFieldException(seen0, 7, $serializer_getInstance_29().s3c_1);
    }
    $this.u3c_1 = id;
    $this.v3c_1 = definitionId;
    $this.w3c_1 = descriptorMap;
    return $this;
  }
  function JsonPresentationSubmission_init_$Create$(seen0, id, definitionId, descriptorMap, serializationConstructorMarker) {
    return JsonPresentationSubmission_init_$Init$(seen0, id, definitionId, descriptorMap, serializationConstructorMarker, objectCreate(protoOf(JsonPresentationSubmission)));
  }
  function JsonPresentationSubmission(id, definitionId, descriptorMap) {
    Companion_getInstance_55();
    this.u3c_1 = id;
    this.v3c_1 = definitionId;
    this.w3c_1 = descriptorMap;
  }
  protoOf(JsonPresentationSubmission).toString = function () {
    return 'JsonPresentationSubmission(id=' + this.u3c_1 + ', definitionId=' + this.v3c_1 + ', descriptorMap=' + toString(this.w3c_1) + ')';
  };
  protoOf(JsonPresentationSubmission).hashCode = function () {
    var result = getStringHashCode(this.u3c_1);
    result = imul(result, 31) + getStringHashCode(this.v3c_1) | 0;
    result = imul(result, 31) + hashCode(this.w3c_1) | 0;
    return result;
  };
  protoOf(JsonPresentationSubmission).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonPresentationSubmission))
      return false;
    var tmp0_other_with_cast = other instanceof JsonPresentationSubmission ? other : THROW_CCE();
    if (!(this.u3c_1 === tmp0_other_with_cast.u3c_1))
      return false;
    if (!(this.v3c_1 === tmp0_other_with_cast.v3c_1))
      return false;
    if (!equals(this.w3c_1, tmp0_other_with_cast.w3c_1))
      return false;
    return true;
  };
  function Companion_56() {
  }
  var Companion_instance_58;
  function Companion_getInstance_56() {
    return Companion_instance_58;
  }
  function $serializer_29() {
    $serializer_instance_29 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonDescriptorMapObject', this, 4);
    tmp0_serialDesc.wy('id', false);
    tmp0_serialDesc.wy('format', false);
    tmp0_serialDesc.wy('path', false);
    tmp0_serialDesc.wy('path_nested', false);
    this.x3c_1 = tmp0_serialDesc;
  }
  protoOf($serializer_29).y3c = function (encoder, value) {
    var tmp0_desc = this.x3c_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.z3c_1);
    tmp1_output.zs(tmp0_desc, 1, value.a3d_1);
    tmp1_output.zs(tmp0_desc, 2, value.b3d_1);
    tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_40(), value.c3d_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_29).zn = function (encoder, value) {
    return this.y3c(encoder, value instanceof JsonDescriptorMapObject ? value : THROW_CCE());
  };
  protoOf($serializer_29).ao = function (decoder) {
    var tmp0_desc = this.x3c_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.lr(tmp0_desc);
    if (tmp8_input.as()) {
      tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.vr(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_40(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.vr(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.zr(tmp0_desc, 3, $serializer_getInstance_40(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.mr(tmp0_desc);
    return JsonDescriptorMapObject_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_29).yn = function () {
    return this.x3c_1;
  };
  protoOf($serializer_29).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_40())];
  };
  var $serializer_instance_29;
  function $serializer_getInstance_30() {
    if ($serializer_instance_29 == null)
      new $serializer_29();
    return $serializer_instance_29;
  }
  function JsonDescriptorMapObject_init_$Init$(seen0, id, format, path, pathNested, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen0))) {
      throwMissingFieldException(seen0, 15, $serializer_getInstance_30().x3c_1);
    }
    $this.z3c_1 = id;
    $this.a3d_1 = format;
    $this.b3d_1 = path;
    $this.c3d_1 = pathNested;
    return $this;
  }
  function JsonDescriptorMapObject_init_$Create$(seen0, id, format, path, pathNested, serializationConstructorMarker) {
    return JsonDescriptorMapObject_init_$Init$(seen0, id, format, path, pathNested, serializationConstructorMarker, objectCreate(protoOf(JsonDescriptorMapObject)));
  }
  function JsonDescriptorMapObject(id, format, path, pathNested) {
    this.z3c_1 = id;
    this.a3d_1 = format;
    this.b3d_1 = path;
    this.c3d_1 = pathNested;
  }
  protoOf(JsonDescriptorMapObject).toString = function () {
    return 'JsonDescriptorMapObject(id=' + this.z3c_1 + ', format=' + this.a3d_1 + ', path=' + this.b3d_1 + ', pathNested=' + toString_0(this.c3d_1) + ')';
  };
  protoOf(JsonDescriptorMapObject).hashCode = function () {
    var result = getStringHashCode(this.z3c_1);
    result = imul(result, 31) + getStringHashCode(this.a3d_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.b3d_1) | 0;
    result = imul(result, 31) + (this.c3d_1 == null ? 0 : this.c3d_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonDescriptorMapObject).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonDescriptorMapObject))
      return false;
    var tmp0_other_with_cast = other instanceof JsonDescriptorMapObject ? other : THROW_CCE();
    if (!(this.z3c_1 === tmp0_other_with_cast.z3c_1))
      return false;
    if (!(this.a3d_1 === tmp0_other_with_cast.a3d_1))
      return false;
    if (!(this.b3d_1 === tmp0_other_with_cast.b3d_1))
      return false;
    if (!equals(this.c3d_1, tmp0_other_with_cast.c3d_1))
      return false;
    return true;
  };
  function Companion_57() {
    Companion_instance_59 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.d3d_1 = [null, null, null, null, new ArrayListSerializer($serializer_getInstance_32())];
  }
  var Companion_instance_59;
  function Companion_getInstance_57() {
    if (Companion_instance_59 == null)
      new Companion_57();
    return Companion_instance_59;
  }
  function $serializer_30() {
    $serializer_instance_30 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonPresentationDefinition', this, 5);
    tmp0_serialDesc.wy('id', false);
    tmp0_serialDesc.wy('name', true);
    tmp0_serialDesc.wy('purpose', true);
    tmp0_serialDesc.wy('format', true);
    tmp0_serialDesc.wy('input_descriptors', false);
    this.e3d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_30).f3d = function (encoder, value) {
    var tmp0_desc = this.e3d_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_57().d3d_1;
    tmp1_output.zs(tmp0_desc, 0, value.g3d_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.h3d_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.h3d_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.i3d_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.i3d_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.j3d_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_38(), value.j3d_1);
    }
    tmp1_output.bt(tmp0_desc, 4, tmp2_cached[4], value.k3d_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_30).zn = function (encoder, value) {
    return this.f3d(encoder, value instanceof JsonPresentationDefinition ? value : THROW_CCE());
  };
  protoOf($serializer_30).ao = function (decoder) {
    var tmp0_desc = this.e3d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.lr(tmp0_desc);
    var tmp10_cached = Companion_getInstance_57().d3d_1;
    if (tmp9_input.as()) {
      tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, $serializer_getInstance_38(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.xr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.zr(tmp0_desc, 3, $serializer_getInstance_38(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.xr(tmp0_desc, 4, tmp10_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.mr(tmp0_desc);
    return JsonPresentationDefinition_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_30).yn = function () {
    return this.e3d_1;
  };
  protoOf($serializer_30).lz = function () {
    var tmp0_cached = Companion_getInstance_57().d3d_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_38()), tmp0_cached[4]];
  };
  var $serializer_instance_30;
  function $serializer_getInstance_31() {
    if ($serializer_instance_30 == null)
      new $serializer_30();
    return $serializer_instance_30;
  }
  function JsonPresentationDefinition_init_$Init$(seen0, id, name, purpose, format, inputDescriptors, serializationConstructorMarker, $this) {
    if (!(17 === (17 & seen0))) {
      throwMissingFieldException(seen0, 17, $serializer_getInstance_31().e3d_1);
    }
    $this.g3d_1 = id;
    if (0 === (seen0 & 2))
      $this.h3d_1 = null;
    else
      $this.h3d_1 = name;
    if (0 === (seen0 & 4))
      $this.i3d_1 = null;
    else
      $this.i3d_1 = purpose;
    if (0 === (seen0 & 8))
      $this.j3d_1 = null;
    else
      $this.j3d_1 = format;
    $this.k3d_1 = inputDescriptors;
    return $this;
  }
  function JsonPresentationDefinition_init_$Create$(seen0, id, name, purpose, format, inputDescriptors, serializationConstructorMarker) {
    return JsonPresentationDefinition_init_$Init$(seen0, id, name, purpose, format, inputDescriptors, serializationConstructorMarker, objectCreate(protoOf(JsonPresentationDefinition)));
  }
  function JsonPresentationDefinition(id, name, purpose, format, inputDescriptors) {
    Companion_getInstance_57();
    name = name === VOID ? null : name;
    purpose = purpose === VOID ? null : purpose;
    format = format === VOID ? null : format;
    this.g3d_1 = id;
    this.h3d_1 = name;
    this.i3d_1 = purpose;
    this.j3d_1 = format;
    this.k3d_1 = inputDescriptors;
  }
  protoOf(JsonPresentationDefinition).toString = function () {
    return 'JsonPresentationDefinition(id=' + this.g3d_1 + ', name=' + this.h3d_1 + ', purpose=' + this.i3d_1 + ', format=' + toString_0(this.j3d_1) + ', inputDescriptors=' + toString(this.k3d_1) + ')';
  };
  protoOf(JsonPresentationDefinition).hashCode = function () {
    var result = getStringHashCode(this.g3d_1);
    result = imul(result, 31) + (this.h3d_1 == null ? 0 : getStringHashCode(this.h3d_1)) | 0;
    result = imul(result, 31) + (this.i3d_1 == null ? 0 : getStringHashCode(this.i3d_1)) | 0;
    result = imul(result, 31) + (this.j3d_1 == null ? 0 : this.j3d_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.k3d_1) | 0;
    return result;
  };
  protoOf(JsonPresentationDefinition).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonPresentationDefinition))
      return false;
    var tmp0_other_with_cast = other instanceof JsonPresentationDefinition ? other : THROW_CCE();
    if (!(this.g3d_1 === tmp0_other_with_cast.g3d_1))
      return false;
    if (!(this.h3d_1 == tmp0_other_with_cast.h3d_1))
      return false;
    if (!(this.i3d_1 == tmp0_other_with_cast.i3d_1))
      return false;
    if (!equals(this.j3d_1, tmp0_other_with_cast.j3d_1))
      return false;
    if (!equals(this.k3d_1, tmp0_other_with_cast.k3d_1))
      return false;
    return true;
  };
  function $serializer_31() {
    $serializer_instance_31 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonInputDescriptor', this, 5);
    tmp0_serialDesc.wy('id', false);
    tmp0_serialDesc.wy('name', true);
    tmp0_serialDesc.wy('purpose', true);
    tmp0_serialDesc.wy('constraints', false);
    tmp0_serialDesc.wy('format', true);
    this.l3d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_31).m3d = function (encoder, value) {
    var tmp0_desc = this.l3d_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.n3d_1);
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.o3d_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.o3d_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.p3d_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.p3d_1);
    }
    tmp1_output.bt(tmp0_desc, 3, $serializer_getInstance_33(), value.q3d_1);
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.r3d_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, $serializer_getInstance_38(), value.r3d_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_31).zn = function (encoder, value) {
    return this.m3d(encoder, value instanceof JsonInputDescriptor ? value : THROW_CCE());
  };
  protoOf($serializer_31).ao = function (decoder) {
    var tmp0_desc = this.l3d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_input = decoder.lr(tmp0_desc);
    if (tmp9_input.as()) {
      tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp9_input.xr(tmp0_desc, 3, $serializer_getInstance_33(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, $serializer_getInstance_38(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp9_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp9_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp9_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp9_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp9_input.xr(tmp0_desc, 3, $serializer_getInstance_33(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp9_input.zr(tmp0_desc, 4, $serializer_getInstance_38(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp9_input.mr(tmp0_desc);
    return JsonInputDescriptor_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
  };
  protoOf($serializer_31).yn = function () {
    return this.l3d_1;
  };
  protoOf($serializer_31).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), $serializer_getInstance_33(), get_nullable($serializer_getInstance_38())];
  };
  var $serializer_instance_31;
  function $serializer_getInstance_32() {
    if ($serializer_instance_31 == null)
      new $serializer_31();
    return $serializer_instance_31;
  }
  function JsonInputDescriptor_init_$Init$(seen0, id, name, purpose, constraints, format, serializationConstructorMarker, $this) {
    if (!(9 === (9 & seen0))) {
      throwMissingFieldException(seen0, 9, $serializer_getInstance_32().l3d_1);
    }
    $this.n3d_1 = id;
    if (0 === (seen0 & 2))
      $this.o3d_1 = null;
    else
      $this.o3d_1 = name;
    if (0 === (seen0 & 4))
      $this.p3d_1 = null;
    else
      $this.p3d_1 = purpose;
    $this.q3d_1 = constraints;
    if (0 === (seen0 & 16))
      $this.r3d_1 = null;
    else
      $this.r3d_1 = format;
    return $this;
  }
  function JsonInputDescriptor_init_$Create$(seen0, id, name, purpose, constraints, format, serializationConstructorMarker) {
    return JsonInputDescriptor_init_$Init$(seen0, id, name, purpose, constraints, format, serializationConstructorMarker, objectCreate(protoOf(JsonInputDescriptor)));
  }
  function JsonInputDescriptor() {
  }
  protoOf(JsonInputDescriptor).toString = function () {
    return 'JsonInputDescriptor(id=' + this.n3d_1 + ', name=' + this.o3d_1 + ', purpose=' + this.p3d_1 + ', constraints=' + this.q3d_1.toString() + ', format=' + toString_0(this.r3d_1) + ')';
  };
  protoOf(JsonInputDescriptor).hashCode = function () {
    var result = getStringHashCode(this.n3d_1);
    result = imul(result, 31) + (this.o3d_1 == null ? 0 : getStringHashCode(this.o3d_1)) | 0;
    result = imul(result, 31) + (this.p3d_1 == null ? 0 : getStringHashCode(this.p3d_1)) | 0;
    result = imul(result, 31) + this.q3d_1.hashCode() | 0;
    result = imul(result, 31) + (this.r3d_1 == null ? 0 : this.r3d_1.hashCode()) | 0;
    return result;
  };
  protoOf(JsonInputDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonInputDescriptor))
      return false;
    var tmp0_other_with_cast = other instanceof JsonInputDescriptor ? other : THROW_CCE();
    if (!(this.n3d_1 === tmp0_other_with_cast.n3d_1))
      return false;
    if (!(this.o3d_1 == tmp0_other_with_cast.o3d_1))
      return false;
    if (!(this.p3d_1 == tmp0_other_with_cast.p3d_1))
      return false;
    if (!this.q3d_1.equals(tmp0_other_with_cast.q3d_1))
      return false;
    if (!equals(this.r3d_1, tmp0_other_with_cast.r3d_1))
      return false;
    return true;
  };
  function Companion_58() {
    Companion_instance_60 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s3d_1 = [new ArrayListSerializer($serializer_getInstance_34()), null];
  }
  var Companion_instance_60;
  function Companion_getInstance_58() {
    if (Companion_instance_60 == null)
      new Companion_58();
    return Companion_instance_60;
  }
  function $serializer_32() {
    $serializer_instance_32 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonConstraints', this, 2);
    tmp0_serialDesc.wy('fields', true);
    tmp0_serialDesc.wy('limit_disclosure', true);
    this.t3d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_32).u3d = function (encoder, value) {
    var tmp0_desc = this.t3d_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_58().s3d_1;
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.v3d_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, tmp2_cached[0], value.v3d_1);
    }
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.w3d_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.w3d_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_32).zn = function (encoder, value) {
    return this.u3d(encoder, value instanceof JsonConstraints ? value : THROW_CCE());
  };
  protoOf($serializer_32).ao = function (decoder) {
    var tmp0_desc = this.t3d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    var tmp7_cached = Companion_getInstance_58().s3d_1;
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.zr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonConstraints_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_32).yn = function () {
    return this.t3d_1;
  };
  protoOf($serializer_32).lz = function () {
    var tmp0_cached = Companion_getInstance_58().s3d_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(tmp0_cached[0]), get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_32;
  function $serializer_getInstance_33() {
    if ($serializer_instance_32 == null)
      new $serializer_32();
    return $serializer_instance_32;
  }
  function JsonConstraints_init_$Init$(seen0, fields, limitDisclosure, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_33().t3d_1);
    }
    if (0 === (seen0 & 1))
      $this.v3d_1 = null;
    else
      $this.v3d_1 = fields;
    if (0 === (seen0 & 2))
      $this.w3d_1 = null;
    else
      $this.w3d_1 = limitDisclosure;
    return $this;
  }
  function JsonConstraints_init_$Create$(seen0, fields, limitDisclosure, serializationConstructorMarker) {
    return JsonConstraints_init_$Init$(seen0, fields, limitDisclosure, serializationConstructorMarker, objectCreate(protoOf(JsonConstraints)));
  }
  function JsonConstraints(fields, limitDisclosure) {
    Companion_getInstance_58();
    fields = fields === VOID ? null : fields;
    limitDisclosure = limitDisclosure === VOID ? null : limitDisclosure;
    this.v3d_1 = fields;
    this.w3d_1 = limitDisclosure;
  }
  protoOf(JsonConstraints).toString = function () {
    return 'JsonConstraints(fields=' + toString_0(this.v3d_1) + ', limitDisclosure=' + this.w3d_1 + ')';
  };
  protoOf(JsonConstraints).hashCode = function () {
    var result = this.v3d_1 == null ? 0 : hashCode(this.v3d_1);
    result = imul(result, 31) + (this.w3d_1 == null ? 0 : getStringHashCode(this.w3d_1)) | 0;
    return result;
  };
  protoOf(JsonConstraints).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonConstraints))
      return false;
    var tmp0_other_with_cast = other instanceof JsonConstraints ? other : THROW_CCE();
    if (!equals(this.v3d_1, tmp0_other_with_cast.v3d_1))
      return false;
    if (!(this.w3d_1 == tmp0_other_with_cast.w3d_1))
      return false;
    return true;
  };
  function Companion_59() {
    Companion_instance_61 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x3d_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_61;
  function Companion_getInstance_59() {
    if (Companion_instance_61 == null)
      new Companion_59();
    return Companion_instance_61;
  }
  function $serializer_33() {
    $serializer_instance_33 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonField', this, 6);
    tmp0_serialDesc.wy('id', true);
    tmp0_serialDesc.wy('name', true);
    tmp0_serialDesc.wy('purpose', true);
    tmp0_serialDesc.wy('path', false);
    tmp0_serialDesc.wy('filter', true);
    tmp0_serialDesc.wy('optional', true);
    this.y3d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_33).z3d = function (encoder, value) {
    var tmp0_desc = this.y3d_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_59().x3d_1;
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.a3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.a3e_1);
    }
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.b3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, StringSerializer_getInstance(), value.b3e_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.c3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, StringSerializer_getInstance(), value.c3e_1);
    }
    tmp1_output.bt(tmp0_desc, 3, tmp2_cached[3], value.d3e_1);
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.e3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, JsonFilterSerializer_getInstance(), value.e3e_1);
    }
    if (tmp1_output.ht(tmp0_desc, 5) ? true : !(value.f3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 5, BooleanSerializer_getInstance(), value.f3e_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_33).zn = function (encoder, value) {
    return this.z3d(encoder, value instanceof JsonField ? value : THROW_CCE());
  };
  protoOf($serializer_33).ao = function (decoder) {
    var tmp0_desc = this.y3d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.lr(tmp0_desc);
    var tmp11_cached = Companion_getInstance_59().x3d_1;
    if (tmp10_input.as()) {
      tmp4_local0 = tmp10_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.xr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.zr(tmp0_desc, 4, JsonFilterSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.zr(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.zr(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.zr(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.xr(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.zr(tmp0_desc, 4, JsonFilterSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.zr(tmp0_desc, 5, BooleanSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.mr(tmp0_desc);
    return JsonField_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_33).yn = function () {
    return this.y3d_1;
  };
  protoOf($serializer_33).lz = function () {
    var tmp0_cached = Companion_getInstance_59().x3d_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), tmp0_cached[3], get_nullable(JsonFilterSerializer_getInstance()), get_nullable(BooleanSerializer_getInstance())];
  };
  var $serializer_instance_33;
  function $serializer_getInstance_34() {
    if ($serializer_instance_33 == null)
      new $serializer_33();
    return $serializer_instance_33;
  }
  function JsonField_init_$Init$(seen0, id, name, purpose, path, filter, optional, serializationConstructorMarker, $this) {
    if (!(8 === (8 & seen0))) {
      throwMissingFieldException(seen0, 8, $serializer_getInstance_34().y3d_1);
    }
    if (0 === (seen0 & 1))
      $this.a3e_1 = null;
    else
      $this.a3e_1 = id;
    if (0 === (seen0 & 2))
      $this.b3e_1 = null;
    else
      $this.b3e_1 = name;
    if (0 === (seen0 & 4))
      $this.c3e_1 = null;
    else
      $this.c3e_1 = purpose;
    $this.d3e_1 = path;
    if (0 === (seen0 & 16))
      $this.e3e_1 = null;
    else
      $this.e3e_1 = filter;
    if (0 === (seen0 & 32))
      $this.f3e_1 = null;
    else
      $this.f3e_1 = optional;
    return $this;
  }
  function JsonField_init_$Create$(seen0, id, name, purpose, path, filter, optional, serializationConstructorMarker) {
    return JsonField_init_$Init$(seen0, id, name, purpose, path, filter, optional, serializationConstructorMarker, objectCreate(protoOf(JsonField)));
  }
  function JsonField() {
  }
  protoOf(JsonField).toString = function () {
    return 'JsonField(id=' + this.a3e_1 + ', name=' + this.b3e_1 + ', purpose=' + this.c3e_1 + ', path=' + toString(this.d3e_1) + ', filter=' + toString_0(this.e3e_1) + ', optional=' + this.f3e_1 + ')';
  };
  protoOf(JsonField).hashCode = function () {
    var result = this.a3e_1 == null ? 0 : getStringHashCode(this.a3e_1);
    result = imul(result, 31) + (this.b3e_1 == null ? 0 : getStringHashCode(this.b3e_1)) | 0;
    result = imul(result, 31) + (this.c3e_1 == null ? 0 : getStringHashCode(this.c3e_1)) | 0;
    result = imul(result, 31) + hashCode(this.d3e_1) | 0;
    result = imul(result, 31) + (this.e3e_1 == null ? 0 : hashCode(this.e3e_1)) | 0;
    result = imul(result, 31) + (this.f3e_1 == null ? 0 : getBooleanHashCode(this.f3e_1)) | 0;
    return result;
  };
  protoOf(JsonField).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonField))
      return false;
    var tmp0_other_with_cast = other instanceof JsonField ? other : THROW_CCE();
    if (!(this.a3e_1 == tmp0_other_with_cast.a3e_1))
      return false;
    if (!(this.b3e_1 == tmp0_other_with_cast.b3e_1))
      return false;
    if (!(this.c3e_1 == tmp0_other_with_cast.c3e_1))
      return false;
    if (!equals(this.d3e_1, tmp0_other_with_cast.d3e_1))
      return false;
    if (!equals(this.e3e_1, tmp0_other_with_cast.e3e_1))
      return false;
    if (!(this.f3e_1 == tmp0_other_with_cast.f3e_1))
      return false;
    return true;
  };
  function Companion_60() {
  }
  var Companion_instance_62;
  function Companion_getInstance_60() {
    return Companion_instance_62;
  }
  function AbstractJsonFilter() {
  }
  function Companion_61() {
  }
  protoOf(Companion_61).b1b = function () {
    return $serializer_getInstance_35();
  };
  var Companion_instance_63;
  function Companion_getInstance_61() {
    return Companion_instance_63;
  }
  function $serializer_34() {
    $serializer_instance_34 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonArrayContainsFilter', this, 2);
    tmp0_serialDesc.wy('type', false);
    tmp0_serialDesc.wy('contains', false);
    this.g3e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_34).h3e = function (encoder, value) {
    var tmp0_desc = this.g3e_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.i3e_1);
    tmp1_output.bt(tmp0_desc, 1, $serializer_getInstance_36(), value.j3e_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_34).zn = function (encoder, value) {
    return this.h3e(encoder, value instanceof JsonArrayContainsFilter ? value : THROW_CCE());
  };
  protoOf($serializer_34).ao = function (decoder) {
    var tmp0_desc = this.g3e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, $serializer_getInstance_36(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonArrayContainsFilter_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_34).yn = function () {
    return this.g3e_1;
  };
  protoOf($serializer_34).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), $serializer_getInstance_36()];
  };
  var $serializer_instance_34;
  function $serializer_getInstance_35() {
    if ($serializer_instance_34 == null)
      new $serializer_34();
    return $serializer_instance_34;
  }
  function JsonArrayContainsFilter_init_$Init$(seen0, type, contains, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_35().g3e_1);
    }
    AbstractJsonFilter.call($this);
    $this.i3e_1 = type;
    $this.j3e_1 = contains;
    return $this;
  }
  function JsonArrayContainsFilter_init_$Create$(seen0, type, contains, serializationConstructorMarker) {
    return JsonArrayContainsFilter_init_$Init$(seen0, type, contains, serializationConstructorMarker, objectCreate(protoOf(JsonArrayContainsFilter)));
  }
  function JsonArrayContainsFilter() {
  }
  protoOf(JsonArrayContainsFilter).toString = function () {
    return 'JsonArrayContainsFilter(type=' + this.i3e_1 + ', contains=' + this.j3e_1.toString() + ')';
  };
  protoOf(JsonArrayContainsFilter).hashCode = function () {
    var result = getStringHashCode(this.i3e_1);
    result = imul(result, 31) + this.j3e_1.hashCode() | 0;
    return result;
  };
  protoOf(JsonArrayContainsFilter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonArrayContainsFilter))
      return false;
    var tmp0_other_with_cast = other instanceof JsonArrayContainsFilter ? other : THROW_CCE();
    if (!(this.i3e_1 === tmp0_other_with_cast.i3e_1))
      return false;
    if (!this.j3e_1.equals(tmp0_other_with_cast.j3e_1))
      return false;
    return true;
  };
  function $serializer_35() {
    $serializer_instance_35 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonContains', this, 2);
    tmp0_serialDesc.wy('type', false);
    tmp0_serialDesc.wy('pattern', false);
    this.k3e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_35).l3e = function (encoder, value) {
    var tmp0_desc = this.k3e_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.m3e_1);
    tmp1_output.zs(tmp0_desc, 1, value.n3e_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_35).zn = function (encoder, value) {
    return this.l3e(encoder, value instanceof JsonContains ? value : THROW_CCE());
  };
  protoOf($serializer_35).ao = function (decoder) {
    var tmp0_desc = this.k3e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonContains_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_35).yn = function () {
    return this.k3e_1;
  };
  protoOf($serializer_35).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_35;
  function $serializer_getInstance_36() {
    if ($serializer_instance_35 == null)
      new $serializer_35();
    return $serializer_instance_35;
  }
  function JsonContains_init_$Init$(seen0, type, pattern, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_36().k3e_1);
    }
    $this.m3e_1 = type;
    $this.n3e_1 = pattern;
    return $this;
  }
  function JsonContains_init_$Create$(seen0, type, pattern, serializationConstructorMarker) {
    return JsonContains_init_$Init$(seen0, type, pattern, serializationConstructorMarker, objectCreate(protoOf(JsonContains)));
  }
  function JsonContains() {
  }
  protoOf(JsonContains).toString = function () {
    return 'JsonContains(type=' + this.m3e_1 + ', pattern=' + this.n3e_1 + ')';
  };
  protoOf(JsonContains).hashCode = function () {
    var result = getStringHashCode(this.m3e_1);
    result = imul(result, 31) + getStringHashCode(this.n3e_1) | 0;
    return result;
  };
  protoOf(JsonContains).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonContains))
      return false;
    var tmp0_other_with_cast = other instanceof JsonContains ? other : THROW_CCE();
    if (!(this.m3e_1 === tmp0_other_with_cast.m3e_1))
      return false;
    if (!(this.n3e_1 === tmp0_other_with_cast.n3e_1))
      return false;
    return true;
  };
  function Companion_62() {
  }
  protoOf(Companion_62).b1b = function () {
    return $serializer_getInstance_37();
  };
  var Companion_instance_64;
  function Companion_getInstance_62() {
    return Companion_instance_64;
  }
  function $serializer_36() {
    $serializer_instance_36 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonStringFilter', this, 2);
    tmp0_serialDesc.wy('type', false);
    tmp0_serialDesc.wy('pattern', false);
    this.o3e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_36).p3e = function (encoder, value) {
    var tmp0_desc = this.o3e_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.q3e_1);
    tmp1_output.zs(tmp0_desc, 1, value.r3e_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_36).zn = function (encoder, value) {
    return this.p3e(encoder, value instanceof JsonStringFilter ? value : THROW_CCE());
  };
  protoOf($serializer_36).ao = function (decoder) {
    var tmp0_desc = this.o3e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonStringFilter_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_36).yn = function () {
    return this.o3e_1;
  };
  protoOf($serializer_36).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_36;
  function $serializer_getInstance_37() {
    if ($serializer_instance_36 == null)
      new $serializer_36();
    return $serializer_instance_36;
  }
  function JsonStringFilter_init_$Init$(seen0, type, pattern, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_37().o3e_1);
    }
    AbstractJsonFilter.call($this);
    $this.q3e_1 = type;
    $this.r3e_1 = pattern;
    return $this;
  }
  function JsonStringFilter_init_$Create$(seen0, type, pattern, serializationConstructorMarker) {
    return JsonStringFilter_init_$Init$(seen0, type, pattern, serializationConstructorMarker, objectCreate(protoOf(JsonStringFilter)));
  }
  function JsonStringFilter() {
  }
  protoOf(JsonStringFilter).toString = function () {
    return 'JsonStringFilter(type=' + this.q3e_1 + ', pattern=' + this.r3e_1 + ')';
  };
  protoOf(JsonStringFilter).hashCode = function () {
    var result = getStringHashCode(this.q3e_1);
    result = imul(result, 31) + getStringHashCode(this.r3e_1) | 0;
    return result;
  };
  protoOf(JsonStringFilter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonStringFilter))
      return false;
    var tmp0_other_with_cast = other instanceof JsonStringFilter ? other : THROW_CCE();
    if (!(this.q3e_1 === tmp0_other_with_cast.q3e_1))
      return false;
    if (!(this.r3e_1 === tmp0_other_with_cast.r3e_1))
      return false;
    return true;
  };
  function Companion_63() {
  }
  protoOf(Companion_63).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonFormat'));
    return new JsonFormat(unwrapOptionalAlgFormat(map, 'jwt_vc_json'), unwrapOptionalAlgFormat(map, 'jwt_vp_json'), unwrapOptionalVcSdJwtAlgsFormat(map, 'vc+sd-jwt'), unwrapOptionalProofTypeFormat(map, 'ldp_vc'), unwrapOptionalProofTypeFormat(map, 'ldp_vp'), new JsonDictionary(toMap(map)));
  };
  var Companion_instance_65;
  function Companion_getInstance_63() {
    return Companion_instance_65;
  }
  function _get__serializable__azf9o3_12($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.y3e_1;
    _serializable$factory_12();
    return this_0.b1();
  }
  function $serializer_37() {
    $serializer_instance_37 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonFormat', this, 6);
    tmp0_serialDesc.wy('jwt_vc_json', true);
    tmp0_serialDesc.wy('jwt_vp_json', true);
    tmp0_serialDesc.wy('vc+sd-jwt', true);
    tmp0_serialDesc.wy('ldp_vc', true);
    tmp0_serialDesc.wy('ldp_vp', true);
    tmp0_serialDesc.wy('customFormats', true);
    this.z3e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_37).a3f = function (encoder, value) {
    var tmp0_desc = this.z3e_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.s3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, $serializer_getInstance_39(), value.s3e_1);
    }
    if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.t3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 1, $serializer_getInstance_39(), value.t3e_1);
    }
    if (tmp1_output.ht(tmp0_desc, 2) ? true : !(value.u3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 2, $serializer_getInstance_42(), value.u3e_1);
    }
    if (tmp1_output.ht(tmp0_desc, 3) ? true : !(value.v3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 3, $serializer_getInstance_41(), value.v3e_1);
    }
    if (tmp1_output.ht(tmp0_desc, 4) ? true : !(value.w3e_1 == null)) {
      tmp1_output.dt(tmp0_desc, 4, $serializer_getInstance_41(), value.w3e_1);
    }
    if (tmp1_output.ht(tmp0_desc, 5) ? true : !equals(value.x3e_1, new JsonDictionary(emptyMap()))) {
      tmp1_output.bt(tmp0_desc, 5, ToJsonDictionarySerializer_getInstance(), value.x3e_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_37).zn = function (encoder, value) {
    return this.a3f(encoder, value instanceof JsonFormat ? value : THROW_CCE());
  };
  protoOf($serializer_37).ao = function (decoder) {
    var tmp0_desc = this.z3e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp11_input = decoder.lr(tmp0_desc);
    if (tmp11_input.as()) {
      tmp4_local0 = tmp11_input.zr(tmp0_desc, 0, $serializer_getInstance_39(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.zr(tmp0_desc, 1, $serializer_getInstance_39(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.zr(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.zr(tmp0_desc, 3, $serializer_getInstance_41(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.zr(tmp0_desc, 4, $serializer_getInstance_41(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.xr(tmp0_desc, 5, ToJsonDictionarySerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.zr(tmp0_desc, 0, $serializer_getInstance_39(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.zr(tmp0_desc, 1, $serializer_getInstance_39(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.zr(tmp0_desc, 2, $serializer_getInstance_42(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.zr(tmp0_desc, 3, $serializer_getInstance_41(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.zr(tmp0_desc, 4, $serializer_getInstance_41(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.xr(tmp0_desc, 5, ToJsonDictionarySerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.mr(tmp0_desc);
    return JsonFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_37).yn = function () {
    return this.z3e_1;
  };
  protoOf($serializer_37).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable($serializer_getInstance_39()), get_nullable($serializer_getInstance_39()), get_nullable($serializer_getInstance_42()), get_nullable($serializer_getInstance_41()), get_nullable($serializer_getInstance_41()), ToJsonDictionarySerializer_getInstance()];
  };
  var $serializer_instance_37;
  function $serializer_getInstance_38() {
    if ($serializer_instance_37 == null)
      new $serializer_37();
    return $serializer_instance_37;
  }
  function JsonFormat_init_$Init$(seen0, jwtVcJson, jwtVpJson, vcSdJwt, ldpVc, ldpVp, customFormats, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_38().z3e_1);
    }
    if (0 === (seen0 & 1))
      $this.s3e_1 = null;
    else
      $this.s3e_1 = jwtVcJson;
    if (0 === (seen0 & 2))
      $this.t3e_1 = null;
    else
      $this.t3e_1 = jwtVpJson;
    if (0 === (seen0 & 4))
      $this.u3e_1 = null;
    else
      $this.u3e_1 = vcSdJwt;
    if (0 === (seen0 & 8))
      $this.v3e_1 = null;
    else
      $this.v3e_1 = ldpVc;
    if (0 === (seen0 & 16))
      $this.w3e_1 = null;
    else
      $this.w3e_1 = ldpVp;
    if (0 === (seen0 & 32))
      $this.x3e_1 = new JsonDictionary(emptyMap());
    else
      $this.x3e_1 = customFormats;
    var tmp = $this;
    tmp.y3e_1 = lazy(JsonFormat$_init_$lambda_oj59w($this));
    return $this;
  }
  function JsonFormat_init_$Create$(seen0, jwtVcJson, jwtVpJson, vcSdJwt, ldpVc, ldpVp, customFormats, serializationConstructorMarker) {
    return JsonFormat_init_$Init$(seen0, jwtVcJson, jwtVpJson, vcSdJwt, ldpVc, ldpVp, customFormats, serializationConstructorMarker, objectCreate(protoOf(JsonFormat)));
  }
  function JsonFormat$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vp.serialization.JsonFormat._serializable$delegate.<anonymous>.<anonymous>' call
      this_0.o2(this$0.x3e_1.a27());
      if (!(this$0.s3e_1 == null)) {
        this_0.m2('jwt_vc_json', this$0.s3e_1.a27());
      }
      if (!(this$0.t3e_1 == null)) {
        this_0.m2('jwt_vp_json', this$0.t3e_1.a27());
      }
      if (!(this$0.v3e_1 == null)) {
        this_0.m2('ldp_vc', this$0.v3e_1.a27());
      }
      if (!(this$0.w3e_1 == null)) {
        this_0.m2('ldp_vp', this$0.w3e_1.a27());
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JsonFormat$_init_$lambda_oj59w(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vp.serialization.JsonFormat.<init>.<anonymous>.<anonymous>' call
      this_0.o2(this$0.x3e_1.a27());
      if (!(this$0.s3e_1 == null)) {
        this_0.m2('jwt_vc_json', this$0.s3e_1.a27());
      }
      if (!(this$0.t3e_1 == null)) {
        this_0.m2('jwt_vp_json', this$0.t3e_1.a27());
      }
      if (!(this$0.v3e_1 == null)) {
        this_0.m2('ldp_vc', this$0.v3e_1.a27());
      }
      if (!(this$0.w3e_1 == null)) {
        this_0.m2('ldp_vp', this$0.w3e_1.a27());
      }
      var tmp$ret$2 = this_0.r8();
      return new JsonDictionary(tmp$ret$2);
    };
  }
  function JsonFormat(jwtVcJson, jwtVpJson, vcSdJwt, ldpVc, ldpVp, customFormats) {
    jwtVcJson = jwtVcJson === VOID ? null : jwtVcJson;
    jwtVpJson = jwtVpJson === VOID ? null : jwtVpJson;
    vcSdJwt = vcSdJwt === VOID ? null : vcSdJwt;
    ldpVc = ldpVc === VOID ? null : ldpVc;
    ldpVp = ldpVp === VOID ? null : ldpVp;
    customFormats = customFormats === VOID ? new JsonDictionary(emptyMap()) : customFormats;
    this.s3e_1 = jwtVcJson;
    this.t3e_1 = jwtVpJson;
    this.u3e_1 = vcSdJwt;
    this.v3e_1 = ldpVc;
    this.w3e_1 = ldpVp;
    this.x3e_1 = customFormats;
    var tmp = this;
    tmp.y3e_1 = lazy(JsonFormat$_serializable$delegate$lambda(this));
  }
  protoOf(JsonFormat).y26 = function () {
    return _get__serializable__azf9o3_12(this);
  };
  protoOf(JsonFormat).toString = function () {
    return 'JsonFormat(jwtVcJson=' + toString_0(this.s3e_1) + ', jwtVpJson=' + toString_0(this.t3e_1) + ', vcSdJwt=' + toString_0(this.u3e_1) + ', ldpVc=' + toString_0(this.v3e_1) + ', ldpVp=' + toString_0(this.w3e_1) + ', customFormats=' + toString(this.x3e_1) + ')';
  };
  protoOf(JsonFormat).hashCode = function () {
    var result = this.s3e_1 == null ? 0 : this.s3e_1.hashCode();
    result = imul(result, 31) + (this.t3e_1 == null ? 0 : this.t3e_1.hashCode()) | 0;
    result = imul(result, 31) + (this.u3e_1 == null ? 0 : this.u3e_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v3e_1 == null ? 0 : this.v3e_1.hashCode()) | 0;
    result = imul(result, 31) + (this.w3e_1 == null ? 0 : this.w3e_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.x3e_1) | 0;
    return result;
  };
  protoOf(JsonFormat).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonFormat))
      return false;
    var tmp0_other_with_cast = other instanceof JsonFormat ? other : THROW_CCE();
    if (!equals(this.s3e_1, tmp0_other_with_cast.s3e_1))
      return false;
    if (!equals(this.t3e_1, tmp0_other_with_cast.t3e_1))
      return false;
    if (!equals(this.u3e_1, tmp0_other_with_cast.u3e_1))
      return false;
    if (!equals(this.v3e_1, tmp0_other_with_cast.v3e_1))
      return false;
    if (!equals(this.w3e_1, tmp0_other_with_cast.w3e_1))
      return false;
    if (!equals(this.x3e_1, tmp0_other_with_cast.x3e_1))
      return false;
    return true;
  };
  function Companion_64() {
    Companion_instance_66 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.i33_1 = [new LinkedHashSetSerializer(StringSerializer_getInstance())];
  }
  protoOf(Companion_64).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonAlgFormat'));
    return new JsonAlgFormat(unwrapStringSet(map, 'alg'));
  };
  protoOf(Companion_64).b1b = function () {
    return $serializer_getInstance_39();
  };
  var Companion_instance_66;
  function Companion_getInstance_64() {
    if (Companion_instance_66 == null)
      new Companion_64();
    return Companion_instance_66;
  }
  function $serializer_38() {
    $serializer_instance_38 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonAlgFormat', this, 1);
    tmp0_serialDesc.wy('alg', false);
    this.d3f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_38).e3f = function (encoder, value) {
    var tmp0_desc = this.d3f_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_64().i33_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.b3f_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_38).zn = function (encoder, value) {
    return this.e3f(encoder, value instanceof JsonAlgFormat ? value : THROW_CCE());
  };
  protoOf($serializer_38).ao = function (decoder) {
    var tmp0_desc = this.d3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    var tmp6_cached = Companion_getInstance_64().i33_1;
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return JsonAlgFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_38).yn = function () {
    return this.d3f_1;
  };
  protoOf($serializer_38).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_64().i33_1[0]];
  };
  var $serializer_instance_38;
  function $serializer_getInstance_39() {
    if ($serializer_instance_38 == null)
      new $serializer_38();
    return $serializer_instance_38;
  }
  function JsonAlgFormat_init_$Init$(seen0, alg, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_39().d3f_1);
    }
    $this.b3f_1 = alg;
    return $this;
  }
  function JsonAlgFormat_init_$Create$(seen0, alg, serializationConstructorMarker) {
    return JsonAlgFormat_init_$Init$(seen0, alg, serializationConstructorMarker, objectCreate(protoOf(JsonAlgFormat)));
  }
  function JsonAlgFormat(alg) {
    Companion_getInstance_64();
    this.b3f_1 = alg;
  }
  protoOf(JsonAlgFormat).a27 = function () {
    return Default_getInstance().a19(Companion_getInstance_64().b1b(), this);
  };
  protoOf(JsonAlgFormat).toString = function () {
    return 'JsonAlgFormat(alg=' + toString(this.b3f_1) + ')';
  };
  protoOf(JsonAlgFormat).hashCode = function () {
    return hashCode(this.b3f_1);
  };
  protoOf(JsonAlgFormat).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonAlgFormat))
      return false;
    var tmp0_other_with_cast = other instanceof JsonAlgFormat ? other : THROW_CCE();
    if (!equals(this.b3f_1, tmp0_other_with_cast.b3f_1))
      return false;
    return true;
  };
  function Companion_65() {
  }
  var Companion_instance_67;
  function Companion_getInstance_65() {
    return Companion_instance_67;
  }
  function $serializer_39() {
    $serializer_instance_39 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonPathNested', this, 2);
    tmp0_serialDesc.wy('format', false);
    tmp0_serialDesc.wy('path', false);
    this.f3f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_39).g3f = function (encoder, value) {
    var tmp0_desc = this.f3f_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    tmp1_output.zs(tmp0_desc, 0, value.h3f_1);
    tmp1_output.zs(tmp0_desc, 1, value.i3f_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_39).zn = function (encoder, value) {
    return this.g3f(encoder, value instanceof JsonPathNested ? value : THROW_CCE());
  };
  protoOf($serializer_39).ao = function (decoder) {
    var tmp0_desc = this.f3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.vr(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.vr(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonPathNested_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_39).yn = function () {
    return this.f3f_1;
  };
  protoOf($serializer_39).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance()];
  };
  var $serializer_instance_39;
  function $serializer_getInstance_40() {
    if ($serializer_instance_39 == null)
      new $serializer_39();
    return $serializer_instance_39;
  }
  function JsonPathNested_init_$Init$(seen0, format, path, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_40().f3f_1);
    }
    $this.h3f_1 = format;
    $this.i3f_1 = path;
    return $this;
  }
  function JsonPathNested_init_$Create$(seen0, format, path, serializationConstructorMarker) {
    return JsonPathNested_init_$Init$(seen0, format, path, serializationConstructorMarker, objectCreate(protoOf(JsonPathNested)));
  }
  function JsonPathNested(format, path) {
    this.h3f_1 = format;
    this.i3f_1 = path;
  }
  protoOf(JsonPathNested).toString = function () {
    return 'JsonPathNested(format=' + this.h3f_1 + ', path=' + this.i3f_1 + ')';
  };
  protoOf(JsonPathNested).hashCode = function () {
    var result = getStringHashCode(this.h3f_1);
    result = imul(result, 31) + getStringHashCode(this.i3f_1) | 0;
    return result;
  };
  protoOf(JsonPathNested).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonPathNested))
      return false;
    var tmp0_other_with_cast = other instanceof JsonPathNested ? other : THROW_CCE();
    if (!(this.h3f_1 === tmp0_other_with_cast.h3f_1))
      return false;
    if (!(this.i3f_1 === tmp0_other_with_cast.i3f_1))
      return false;
    return true;
  };
  function Companion_66() {
    Companion_instance_68 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.k33_1 = [new LinkedHashSetSerializer(StringSerializer_getInstance())];
  }
  protoOf(Companion_66).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonProofTypeFormat'));
    return new JsonProofTypeFormat(unwrapStringSet(map, 'proof_type'));
  };
  protoOf(Companion_66).b1b = function () {
    return $serializer_getInstance_41();
  };
  var Companion_instance_68;
  function Companion_getInstance_66() {
    if (Companion_instance_68 == null)
      new Companion_66();
    return Companion_instance_68;
  }
  function $serializer_40() {
    $serializer_instance_40 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonProofTypeFormat', this, 1);
    tmp0_serialDesc.wy('proof_type', false);
    this.j3f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_40).k3f = function (encoder, value) {
    var tmp0_desc = this.j3f_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_66().k33_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.c3f_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_40).zn = function (encoder, value) {
    return this.k3f(encoder, value instanceof JsonProofTypeFormat ? value : THROW_CCE());
  };
  protoOf($serializer_40).ao = function (decoder) {
    var tmp0_desc = this.j3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    var tmp6_cached = Companion_getInstance_66().k33_1;
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.xr(tmp0_desc, 0, tmp6_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return JsonProofTypeFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_40).yn = function () {
    return this.j3f_1;
  };
  protoOf($serializer_40).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [Companion_getInstance_66().k33_1[0]];
  };
  var $serializer_instance_40;
  function $serializer_getInstance_41() {
    if ($serializer_instance_40 == null)
      new $serializer_40();
    return $serializer_instance_40;
  }
  function JsonProofTypeFormat_init_$Init$(seen0, proofType, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen0))) {
      throwMissingFieldException(seen0, 1, $serializer_getInstance_41().j3f_1);
    }
    $this.c3f_1 = proofType;
    return $this;
  }
  function JsonProofTypeFormat_init_$Create$(seen0, proofType, serializationConstructorMarker) {
    return JsonProofTypeFormat_init_$Init$(seen0, proofType, serializationConstructorMarker, objectCreate(protoOf(JsonProofTypeFormat)));
  }
  function JsonProofTypeFormat(proofType) {
    Companion_getInstance_66();
    this.c3f_1 = proofType;
  }
  protoOf(JsonProofTypeFormat).a27 = function () {
    return Default_getInstance().a19(Companion_getInstance_66().b1b(), this);
  };
  protoOf(JsonProofTypeFormat).toString = function () {
    return 'JsonProofTypeFormat(proofType=' + toString(this.c3f_1) + ')';
  };
  protoOf(JsonProofTypeFormat).hashCode = function () {
    return hashCode(this.c3f_1);
  };
  protoOf(JsonProofTypeFormat).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonProofTypeFormat))
      return false;
    var tmp0_other_with_cast = other instanceof JsonProofTypeFormat ? other : THROW_CCE();
    if (!equals(this.c3f_1, tmp0_other_with_cast.c3f_1))
      return false;
    return true;
  };
  function Companion_67() {
    Companion_instance_69 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.j33_1 = [new LinkedHashSetSerializer(StringSerializer_getInstance()), new LinkedHashSetSerializer(StringSerializer_getInstance())];
  }
  protoOf(Companion_67).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'JsonVcSdJwtAlgsFormat'));
    return new JsonVcSdJwtAlgsFormat(unwrapStringSet(map, 'sd-jwt_alg_values'), unwrapStringSet(map, 'kb-jwt_alg_values'));
  };
  protoOf(Companion_67).b1b = function () {
    return $serializer_getInstance_42();
  };
  var Companion_instance_69;
  function Companion_getInstance_67() {
    if (Companion_instance_69 == null)
      new Companion_67();
    return Companion_instance_69;
  }
  function $serializer_41() {
    $serializer_instance_41 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonVcSdJwtAlgsFormat', this, 2);
    tmp0_serialDesc.wy('sd-jwt_alg_values', false);
    tmp0_serialDesc.wy('kb-jwt_alg_values', false);
    this.l3f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_41).m3f = function (encoder, value) {
    var tmp0_desc = this.l3f_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    var tmp2_cached = Companion_getInstance_67().j33_1;
    tmp1_output.bt(tmp0_desc, 0, tmp2_cached[0], value.n3f_1);
    tmp1_output.bt(tmp0_desc, 1, tmp2_cached[1], value.o3f_1);
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_41).zn = function (encoder, value) {
    return this.m3f(encoder, value instanceof JsonVcSdJwtAlgsFormat ? value : THROW_CCE());
  };
  protoOf($serializer_41).ao = function (decoder) {
    var tmp0_desc = this.l3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.lr(tmp0_desc);
    var tmp7_cached = Companion_getInstance_67().j33_1;
    if (tmp6_input.as()) {
      tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.xr(tmp0_desc, 0, tmp7_cached[0], tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.xr(tmp0_desc, 1, tmp7_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.mr(tmp0_desc);
    return JsonVcSdJwtAlgsFormat_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_41).yn = function () {
    return this.l3f_1;
  };
  protoOf($serializer_41).lz = function () {
    var tmp0_cached = Companion_getInstance_67().j33_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [tmp0_cached[0], tmp0_cached[1]];
  };
  var $serializer_instance_41;
  function $serializer_getInstance_42() {
    if ($serializer_instance_41 == null)
      new $serializer_41();
    return $serializer_instance_41;
  }
  function JsonVcSdJwtAlgsFormat_init_$Init$(seen0, sdJwtAlgValues, kbJwtAlgValues, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen0))) {
      throwMissingFieldException(seen0, 3, $serializer_getInstance_42().l3f_1);
    }
    $this.n3f_1 = sdJwtAlgValues;
    $this.o3f_1 = kbJwtAlgValues;
    return $this;
  }
  function JsonVcSdJwtAlgsFormat_init_$Create$(seen0, sdJwtAlgValues, kbJwtAlgValues, serializationConstructorMarker) {
    return JsonVcSdJwtAlgsFormat_init_$Init$(seen0, sdJwtAlgValues, kbJwtAlgValues, serializationConstructorMarker, objectCreate(protoOf(JsonVcSdJwtAlgsFormat)));
  }
  function JsonVcSdJwtAlgsFormat(sdJwtAlgValues, kbJwtAlgValues) {
    Companion_getInstance_67();
    this.n3f_1 = sdJwtAlgValues;
    this.o3f_1 = kbJwtAlgValues;
  }
  protoOf(JsonVcSdJwtAlgsFormat).a27 = function () {
    return Default_getInstance().a19(Companion_getInstance_67().b1b(), this);
  };
  protoOf(JsonVcSdJwtAlgsFormat).toString = function () {
    return 'JsonVcSdJwtAlgsFormat(sdJwtAlgValues=' + toString(this.n3f_1) + ', kbJwtAlgValues=' + toString(this.o3f_1) + ')';
  };
  protoOf(JsonVcSdJwtAlgsFormat).hashCode = function () {
    var result = hashCode(this.n3f_1);
    result = imul(result, 31) + hashCode(this.o3f_1) | 0;
    return result;
  };
  protoOf(JsonVcSdJwtAlgsFormat).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonVcSdJwtAlgsFormat))
      return false;
    var tmp0_other_with_cast = other instanceof JsonVcSdJwtAlgsFormat ? other : THROW_CCE();
    if (!equals(this.n3f_1, tmp0_other_with_cast.n3f_1))
      return false;
    if (!equals(this.o3f_1, tmp0_other_with_cast.o3f_1))
      return false;
    return true;
  };
  function _serializable$factory_12() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_12(receiver);
    }, null);
  }
  function Companion_68() {
  }
  protoOf(Companion_68).d27 = function (json) {
    var tmp;
    var tmp_0;
    if (json instanceof JsonPrimitive) {
      tmp_0 = json.d1b();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = new JsonStringVerifiablePresentation(json.e1b());
    } else {
      tmp = new JsonDictionaryVerifiablePresentation(new JsonDictionary(FromJsonHelper_instance.b27(json, 'JsonDictionaryVerifiablePresentation')));
    }
    return tmp;
  };
  protoOf(Companion_68).b1b = function () {
    return JsonVerifiablePresentationSerializer_getInstance();
  };
  protoOf(Companion_68).wz = function (typeParamsSerializers) {
    return this.b1b();
  };
  var Companion_instance_70;
  function Companion_getInstance_68() {
    return Companion_instance_70;
  }
  function JsonStringVerifiablePresentation(value) {
    this.p3f_1 = value;
  }
  protoOf(JsonStringVerifiablePresentation).a27 = function () {
    return JsonPrimitive_0(this.p3f_1);
  };
  protoOf(JsonStringVerifiablePresentation).toString = function () {
    return 'JsonStringVerifiablePresentation(value=' + this.p3f_1 + ')';
  };
  protoOf(JsonStringVerifiablePresentation).hashCode = function () {
    return getStringHashCode(this.p3f_1);
  };
  protoOf(JsonStringVerifiablePresentation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonStringVerifiablePresentation))
      return false;
    var tmp0_other_with_cast = other instanceof JsonStringVerifiablePresentation ? other : THROW_CCE();
    if (!(this.p3f_1 === tmp0_other_with_cast.p3f_1))
      return false;
    return true;
  };
  function JsonDictionaryVerifiablePresentation(value) {
    this.q3f_1 = value;
  }
  protoOf(JsonDictionaryVerifiablePresentation).y26 = function () {
    return this.q3f_1;
  };
  protoOf(JsonDictionaryVerifiablePresentation).toString = function () {
    return 'JsonDictionaryVerifiablePresentation(value=' + this.q3f_1.toString() + ')';
  };
  protoOf(JsonDictionaryVerifiablePresentation).hashCode = function () {
    return this.q3f_1.hashCode();
  };
  protoOf(JsonDictionaryVerifiablePresentation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonDictionaryVerifiablePresentation))
      return false;
    var tmp0_other_with_cast = other instanceof JsonDictionaryVerifiablePresentation ? other : THROW_CCE();
    if (!this.q3f_1.equals(tmp0_other_with_cast.q3f_1))
      return false;
    return true;
  };
  function JsonVerifiablePresentation() {
  }
  function Companion_69() {
  }
  var Companion_instance_71;
  function Companion_getInstance_69() {
    return Companion_instance_71;
  }
  function $serializer_42() {
    $serializer_instance_42 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.curity.vp.serialization.JsonVerifierDirectPostAuthorizationResponse', this, 1);
    tmp0_serialDesc.wy('redirect_uri', true);
    this.r3f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_42).s3f = function (encoder, value) {
    var tmp0_desc = this.r3f_1;
    var tmp1_output = encoder.lr(tmp0_desc);
    if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.t3f_1 == null)) {
      tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.t3f_1);
    }
    tmp1_output.mr(tmp0_desc);
  };
  protoOf($serializer_42).zn = function (encoder, value) {
    return this.s3f(encoder, value instanceof JsonVerifierDirectPostAuthorizationResponse ? value : THROW_CCE());
  };
  protoOf($serializer_42).ao = function (decoder) {
    var tmp0_desc = this.r3f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.lr(tmp0_desc);
    if (tmp5_input.as()) {
      tmp4_local0 = tmp5_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.bs(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.zr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.mr(tmp0_desc);
    return JsonVerifierDirectPostAuthorizationResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_42).yn = function () {
    return this.r3f_1;
  };
  protoOf($serializer_42).lz = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [get_nullable(StringSerializer_getInstance())];
  };
  var $serializer_instance_42;
  function $serializer_getInstance_43() {
    if ($serializer_instance_42 == null)
      new $serializer_42();
    return $serializer_instance_42;
  }
  function JsonVerifierDirectPostAuthorizationResponse_init_$Init$(seen0, redirectUri, serializationConstructorMarker, $this) {
    if (!(0 === (0 & seen0))) {
      throwMissingFieldException(seen0, 0, $serializer_getInstance_43().r3f_1);
    }
    if (0 === (seen0 & 1))
      $this.t3f_1 = null;
    else
      $this.t3f_1 = redirectUri;
    return $this;
  }
  function JsonVerifierDirectPostAuthorizationResponse_init_$Create$(seen0, redirectUri, serializationConstructorMarker) {
    return JsonVerifierDirectPostAuthorizationResponse_init_$Init$(seen0, redirectUri, serializationConstructorMarker, objectCreate(protoOf(JsonVerifierDirectPostAuthorizationResponse)));
  }
  function JsonVerifierDirectPostAuthorizationResponse(redirectUri) {
    redirectUri = redirectUri === VOID ? null : redirectUri;
    this.t3f_1 = redirectUri;
  }
  protoOf(JsonVerifierDirectPostAuthorizationResponse).u3f = function () {
    return this.t3f_1;
  };
  protoOf(JsonVerifierDirectPostAuthorizationResponse).toString = function () {
    return 'JsonVerifierDirectPostAuthorizationResponse(redirectUri=' + this.t3f_1 + ')';
  };
  protoOf(JsonVerifierDirectPostAuthorizationResponse).hashCode = function () {
    return this.t3f_1 == null ? 0 : getStringHashCode(this.t3f_1);
  };
  protoOf(JsonVerifierDirectPostAuthorizationResponse).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsonVerifierDirectPostAuthorizationResponse))
      return false;
    var tmp0_other_with_cast = other instanceof JsonVerifierDirectPostAuthorizationResponse ? other : THROW_CCE();
    if (!(this.t3f_1 == tmp0_other_with_cast.t3f_1))
      return false;
    return true;
  };
  function JsonFilterSerializer() {
    JsonFilterSerializer_instance = this;
    JsonContentPolymorphicSerializer.call(this, getKClass(AbstractJsonFilter));
  }
  protoOf(JsonFilterSerializer).z1a = function (element) {
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    var this_0 = get_jsonObject(element);
    // Inline function 'kotlin.collections.containsKey' call
    var key = 'contains';
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c2(key)) {
      tmp = Companion_instance_63.b1b();
    } else {
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_1 = get_jsonObject(element);
      if ((isInterface(this_1, KtMap) ? this_1 : THROW_CCE()).c2('pattern')) {
        tmp = Companion_instance_64.b1b();
      } else {
        var message = 'Unsupported filter: ' + get_jsonObject(element).toString();
        throw IllegalStateException_init_$Create$(toString(message));
      }
    }
    return tmp;
  };
  var JsonFilterSerializer_instance;
  function JsonFilterSerializer_getInstance() {
    if (JsonFilterSerializer_instance == null)
      new JsonFilterSerializer();
    return JsonFilterSerializer_instance;
  }
  function SerializableW3CVerifiablePresentationSerializer() {
    SerializableW3CVerifiablePresentationSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_72);
  }
  var SerializableW3CVerifiablePresentationSerializer_instance;
  function SerializableW3CVerifiablePresentationSerializer_getInstance() {
    if (SerializableW3CVerifiablePresentationSerializer_instance == null)
      new SerializableW3CVerifiablePresentationSerializer();
    return SerializableW3CVerifiablePresentationSerializer_instance;
  }
  function JsonVerifiablePresentationSerializer() {
    JsonVerifiablePresentationSerializer_instance = this;
    JsonSerializer.call(this, Companion_instance_70);
  }
  var JsonVerifiablePresentationSerializer_instance;
  function JsonVerifiablePresentationSerializer_getInstance() {
    if (JsonVerifiablePresentationSerializer_instance == null)
      new JsonVerifiablePresentationSerializer();
    return JsonVerifiablePresentationSerializer_instance;
  }
  function Companion_70() {
  }
  protoOf(Companion_70).d27 = function (json) {
    var map = toMutableMap(FromJsonHelper_instance.b27(json, 'SerializableW3CVerifiablePresentation'));
    return new SerializableW3CVerifiablePresentation(unwrapOptionalString(map, 'id'), unwrapStringList(map, '@context'), unwrapStringList(map, 'type'), unwrapOptionalString(map, 'holder'), unwrapOptionalProofs(map, 'proof'), unwrapOptionalVerifiableCredentials(map, 'verifiableCredential'), map.s() ? null : new JsonDictionary(toMap(map)));
  };
  var Companion_instance_72;
  function Companion_getInstance_70() {
    return Companion_instance_72;
  }
  function _get__serializable__azf9o3_13($this) {
    // Inline function 'kotlin.getValue' call
    var this_0 = $this.e3g_1;
    _serializable$factory_13();
    return this_0.b1();
  }
  function SerializableW3CVerifiablePresentation$_serializable$delegate$lambda$lambda(it) {
    var tmp;
    if (it instanceof StringCredential) {
      tmp = JsonPrimitive_0(it.o2h_1);
    } else {
      if (it instanceof DictionaryCredential) {
        var tmp_0 = it.p2h_1;
        tmp = new JsonObject(isInterface(tmp_0, KtMap) ? tmp_0 : THROW_CCE());
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function SerializableW3CVerifiablePresentation$_serializable$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.buildMap' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.collections.buildMapInternal' call
      // Inline function 'kotlin.apply' call
      var this_0 = LinkedHashMap_init_$Create$();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.vp.serialization.SerializableW3CVerifiablePresentation._serializable$delegate.<anonymous>.<anonymous>' call
      if (!(this$0.d3g_1 == null)) {
        this_0.o2(this$0.d3g_1.a27());
      }
      if (!(this$0.x3f_1 == null)) {
        this_0.m2('id', toJson(this$0.x3f_1));
      }
      // Inline function 'kotlin.collections.map' call
      var this_1 = this$0.y3f_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'io.curity.vp.serialization.SerializableW3CVerifiablePresentation._serializable$delegate.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$0 = toJson(item);
        destination.e(tmp$ret$0);
      }
      this_0.m2('@context', new JsonArray(destination));
      // Inline function 'kotlin.collections.map' call
      var this_2 = this$0.z3f_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
      var tmp0_iterator_0 = this_2.j();
      while (tmp0_iterator_0.k()) {
        var item_0 = tmp0_iterator_0.l();
        // Inline function 'io.curity.vp.serialization.SerializableW3CVerifiablePresentation._serializable$delegate.<anonymous>.<anonymous>.<anonymous>' call
        var tmp$ret$3 = toJson(item_0);
        destination_0.e(tmp$ret$3);
      }
      this_0.m2('type', new JsonArray(destination_0));
      if (!(this$0.a3g_1 == null)) {
        this_0.m2('holder', toJson(this$0.a3g_1));
      }
      if (!(this$0.b3g_1 == null)) {
        this_0.m2('proof', toJson_4(this$0.b3g_1));
      }
      if (!(this$0.c3g_1 == null)) {
        this_0.m2('verifiableCredential', this$0.c3g_1.l27(SerializableW3CVerifiablePresentation$_serializable$delegate$lambda$lambda));
      }
      var tmp$ret$8 = this_0.r8();
      return new JsonDictionary(tmp$ret$8);
    };
  }
  function SerializableW3CVerifiablePresentation(id, context, type, holder, proof, verifiableCredential, customClaims) {
    id = id === VOID ? null : id;
    holder = holder === VOID ? null : holder;
    proof = proof === VOID ? null : proof;
    verifiableCredential = verifiableCredential === VOID ? null : verifiableCredential;
    customClaims = customClaims === VOID ? null : customClaims;
    this.x3f_1 = id;
    this.y3f_1 = context;
    this.z3f_1 = type;
    this.a3g_1 = holder;
    this.b3g_1 = proof;
    this.c3g_1 = verifiableCredential;
    this.d3g_1 = customClaims;
    var tmp = this;
    tmp.e3g_1 = lazy(SerializableW3CVerifiablePresentation$_serializable$delegate$lambda(this));
  }
  protoOf(SerializableW3CVerifiablePresentation).y26 = function () {
    return _get__serializable__azf9o3_13(this);
  };
  protoOf(SerializableW3CVerifiablePresentation).toString = function () {
    return 'SerializableW3CVerifiablePresentation(id=' + this.x3f_1 + ', context=' + toString(this.y3f_1) + ', type=' + toString(this.z3f_1) + ', holder=' + this.a3g_1 + ', proof=' + toString_0(this.b3g_1) + ', verifiableCredential=' + toString_0(this.c3g_1) + ', customClaims=' + toString_0(this.d3g_1) + ')';
  };
  protoOf(SerializableW3CVerifiablePresentation).hashCode = function () {
    var result = this.x3f_1 == null ? 0 : getStringHashCode(this.x3f_1);
    result = imul(result, 31) + hashCode(this.y3f_1) | 0;
    result = imul(result, 31) + hashCode(this.z3f_1) | 0;
    result = imul(result, 31) + (this.a3g_1 == null ? 0 : getStringHashCode(this.a3g_1)) | 0;
    result = imul(result, 31) + (this.b3g_1 == null ? 0 : hashCode(this.b3g_1)) | 0;
    result = imul(result, 31) + (this.c3g_1 == null ? 0 : this.c3g_1.hashCode()) | 0;
    result = imul(result, 31) + (this.d3g_1 == null ? 0 : hashCode(this.d3g_1)) | 0;
    return result;
  };
  protoOf(SerializableW3CVerifiablePresentation).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerializableW3CVerifiablePresentation))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableW3CVerifiablePresentation ? other : THROW_CCE();
    if (!(this.x3f_1 == tmp0_other_with_cast.x3f_1))
      return false;
    if (!equals(this.y3f_1, tmp0_other_with_cast.y3f_1))
      return false;
    if (!equals(this.z3f_1, tmp0_other_with_cast.z3f_1))
      return false;
    if (!(this.a3g_1 == tmp0_other_with_cast.a3g_1))
      return false;
    if (!equals(this.b3g_1, tmp0_other_with_cast.b3g_1))
      return false;
    if (!equals(this.c3g_1, tmp0_other_with_cast.c3g_1))
      return false;
    if (!equals(this.d3g_1, tmp0_other_with_cast.d3g_1))
      return false;
    return true;
  };
  function _serializable$factory_13() {
    return getPropertyCallableRef('_serializable', 1, KProperty1, function (receiver) {
      return _get__serializable__azf9o3_13(receiver);
    }, null);
  }
  function Companion_71() {
  }
  protoOf(Companion_71).left = function (left) {
    return new Either(left, null);
  };
  protoOf(Companion_71).right = function (right) {
    return new Either(null, right);
  };
  var Companion_instance_73;
  function Companion_getInstance_71() {
    return Companion_instance_73;
  }
  function Either(_left, _right) {
    this.f3g_1 = _left;
    this.g3g_1 = _right;
  }
  protoOf(Either).map = function (whenLeft, whenRight) {
    return !(this.f3g_1 == null) ? whenLeft(this.f3g_1) : whenRight(ensureNotNull(this.g3g_1));
  };
  function ToJsonString() {
  }
  function JSObject(_dictionary) {
    this.h3g_1 = _dictionary;
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.h3g_1.f2();
    tmp.keys = copyToArray(this_0);
  }
  protoOf(JSObject).f2 = function () {
    return this.keys;
  };
  protoOf(JSObject).get = function (key) {
    return this.h3g_1.vl(key);
  };
  function JSIssuerObject(issuer) {
    JSObject.call(this, issuer);
    this.id = issuer.k2a();
  }
  protoOf(JSIssuerObject).k2a = function () {
    return this.id;
  };
  function JSProofObject(proof) {
    JSObject.call(this, proof);
    this.type = proof.g36();
  }
  protoOf(JSProofObject).g36 = function () {
    return this.type;
  };
  function JSCredentialStatusObject(status) {
    JSObject.call(this, status);
    this.id = status.k2a();
    this.type = status.g36();
  }
  protoOf(JSCredentialStatusObject).k2a = function () {
    return this.id;
  };
  protoOf(JSCredentialStatusObject).g36 = function () {
    return this.type;
  };
  function JsPair(first, second) {
    this.first = first;
    this.second = second;
  }
  protoOf(JsPair).mm = function () {
    return this.first;
  };
  protoOf(JsPair).l3g = function () {
    return this.second;
  };
  function getRootCause(_this__u8e3s4) {
    var result = _this__u8e3s4;
    $l$loop: while (true) {
      var tmp0_elvis_lhs = result.cause;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      result = tmp;
    }
    return result;
  }
  function createJSObject(dictionary) {
    return new JSObject(dictionary);
  }
  function JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition(type, credentialSubjectClaims) {
    this.type = type;
    this.credentialSubjectClaims = credentialSubjectClaims;
  }
  protoOf(JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition).g36 = function () {
    return this.type;
  };
  protoOf(JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition).m3g = function () {
    return this.credentialSubjectClaims;
  };
  function JSJwtVcJsonVerifiableCredentialRequest(jwtProof, credentialDefinition) {
    this.jwtProof = jwtProof;
    this.credentialDefinition = credentialDefinition;
  }
  protoOf(JSJwtVcJsonVerifiableCredentialRequest).n3g = function () {
    return this.jwtProof;
  };
  protoOf(JSJwtVcJsonVerifiableCredentialRequest).o3g = function () {
    return this.credentialDefinition;
  };
  protoOf(JSJwtVcJsonVerifiableCredentialRequest).toJson = function () {
    var serializable = convertJwtVcJsonRequest(this);
    // Inline function 'kotlinx.serialization.encodeToString' call
    var this_0 = Default_getInstance();
    // Inline function 'kotlinx.serialization.serializer' call
    var this_1 = this_0.dp();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_2 = serializer(this_1, createKType(getKClass(JwtVcJsonVerifiableCredentialRequest), arrayOf([]), false));
    var tmp$ret$1 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
    return this_0.bp(tmp$ret$1, serializable);
  };
  function JSJwtVcJsonLdVerifiableCredentialRequest(jwtProof, types, context, credentialSubjectClaims) {
    this.jwtProof = jwtProof;
    this.types = types;
    this.context = context;
    this.credentialSubjectClaims = credentialSubjectClaims;
  }
  protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).n3g = function () {
    return this.jwtProof;
  };
  protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).p3g = function () {
    return this.types;
  };
  protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).b9 = function () {
    return this.context;
  };
  protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).m3g = function () {
    return this.credentialSubjectClaims;
  };
  protoOf(JSJwtVcJsonLdVerifiableCredentialRequest).toJson = function () {
    var serializable = convertJwtVcJsonLdRequest(this);
    return Default_getInstance().bp(Companion_instance_44.b1b(), serializable);
  };
  function JSLdpVerifiableCredentialRequest(jwtProof, context, types, credentialSubjectClaims) {
    this.jwtProof = jwtProof;
    this.context = context;
    this.types = types;
    this.credentialSubjectClaims = credentialSubjectClaims;
  }
  protoOf(JSLdpVerifiableCredentialRequest).n3g = function () {
    return this.jwtProof;
  };
  protoOf(JSLdpVerifiableCredentialRequest).b9 = function () {
    return this.context;
  };
  protoOf(JSLdpVerifiableCredentialRequest).p3g = function () {
    return this.types;
  };
  protoOf(JSLdpVerifiableCredentialRequest).m3g = function () {
    return this.credentialSubjectClaims;
  };
  protoOf(JSLdpVerifiableCredentialRequest).toJson = function () {
    var serializable = convertLdpVcJsonRequest(this);
    return Default_getInstance().bp(Companion_instance_45.b1b(), serializable);
  };
  function convertJwtVcJsonRequest(request) {
    return new JwtVcJsonVerifiableCredentialRequest(new JwtProofOfPossession(request.jwtProof), convertJsJwtVcJsonVerifiableCredentialRequestCredentialDefinition(request.credentialDefinition));
  }
  function convertJwtVcJsonLdRequest(request) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = request.types;
    var destination = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'convertJwtVcJsonLdRequest.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination.e(element);
      }
    }
    var types = toSet(destination);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = request.context;
    var destination_0 = ArrayList_init_$Create$_0();
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'convertJwtVcJsonLdRequest.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element_0)) {
        destination_0.e(element_0);
      }
    }
    var context = toList_0(destination_0);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = request.credentialSubjectClaims;
    var destination_1 = ArrayList_init_$Create$_0();
    var inductionVariable_1 = 0;
    var last_1 = this_2.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = this_2[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'convertJwtVcJsonLdRequest.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element_1)) {
        destination_1.e(element_1);
      }
    }
    var claims = toSet(destination_1);
    return new JwtVcJsonLdVerifiableCredentialRequest(new JwtProofOfPossession(request.jwtProof), new JsonCredentialDefinition(context, types, new BasicCredentialSubject(claims)));
  }
  function convertLdpVcJsonRequest(request) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = request.types;
    var destination = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'convertLdpVcJsonRequest.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination.e(element);
      }
    }
    var types = toSet(destination);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = request.credentialSubjectClaims;
    var destination_0 = ArrayList_init_$Create$_0();
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'convertLdpVcJsonRequest.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element_0)) {
        destination_0.e(element_0);
      }
    }
    var claims = toSet(destination_0);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = request.context;
    var destination_1 = ArrayList_init_$Create$_0();
    var inductionVariable_1 = 0;
    var last_1 = this_2.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = this_2[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      // Inline function 'convertLdpVcJsonRequest.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element_1)) {
        destination_1.e(element_1);
      }
    }
    var context = toList_0(destination_1);
    var tmp = new JwtProofOfPossession(request.jwtProof);
    var tmp0_credentialSubject = new BasicCredentialSubject(claims);
    return new LdpVerifiableCredentialRequest(tmp, new JsonCredentialDefinition(context, types, tmp0_credentialSubject));
  }
  function convertJsJwtVcJsonVerifiableCredentialRequestCredentialDefinition(credentialDefinition) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = credentialDefinition.credentialSubjectClaims;
    var destination = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'convertJsJwtVcJsonVerifiableCredentialRequestCredentialDefinition.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element)) {
        destination.e(element);
      }
    }
    var claims = toSet(destination);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = credentialDefinition.type;
    var destination_0 = ArrayList_init_$Create$_0();
    var inductionVariable_0 = 0;
    var last_0 = this_1.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_1[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'convertJsJwtVcJsonVerifiableCredentialRequestCredentialDefinition.<anonymous>' call
      // Inline function 'kotlin.text.isNotBlank' call
      if (!isBlank(element_0)) {
        destination_0.e(element_0);
      }
    }
    return new CredentialDefinition(toSet(destination_0), new BasicCredentialSubject(claims));
  }
  function JSDeferredJsonCredentialResponse(_response) {
    this.q3g_1 = _response;
    this.acceptanceToken = this.q3g_1.j36_1;
    this.cNonce = this.q3g_1.k36_1;
    var tmp = this;
    var tmp1_safe_receiver = this.q3g_1.l36_1;
    tmp.cNonceExpiresIn = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.l1();
  }
  protoOf(JSDeferredJsonCredentialResponse).r3g = function () {
    return this.acceptanceToken;
  };
  protoOf(JSDeferredJsonCredentialResponse).s3g = function () {
    return this.cNonce;
  };
  protoOf(JSDeferredJsonCredentialResponse).t3g = function () {
    return this.cNonceExpiresIn;
  };
  protoOf(JSDeferredJsonCredentialResponse).toJson = function () {
    return Default_getInstance().bp(Companion_instance_25.b1b(), this.q3g_1);
  };
  function JSJwtVcJsonVerifiableCredentialResponse(_response) {
    this.u3g_1 = _response;
    this.credential = this.u3g_1.n38().o2h_1;
    this.cNonce = this.u3g_1.b3b_1;
    var tmp = this;
    var tmp2_safe_receiver = this.u3g_1.c3b_1;
    tmp.cNonceExpiresIn = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.l1();
  }
  protoOf(JSJwtVcJsonVerifiableCredentialResponse).n38 = function () {
    return this.credential;
  };
  protoOf(JSJwtVcJsonVerifiableCredentialResponse).s3g = function () {
    return this.cNonce;
  };
  protoOf(JSJwtVcJsonVerifiableCredentialResponse).t3g = function () {
    return this.cNonceExpiresIn;
  };
  protoOf(JSJwtVcJsonVerifiableCredentialResponse).toJson = function () {
    return Default_getInstance().bp(Companion_instance_47.b1b(), this.u3g_1);
  };
  function JSLdpVerifiableCredentialResponse(_response) {
    this.v3g_1 = _response;
    this.credential = Companion_instance_74.w3g(this.v3g_1.n38().p2h_1);
    this.cNonce = this.v3g_1.g3b_1;
    var tmp = this;
    var tmp3_safe_receiver = this.v3g_1.h3b_1;
    tmp.cNonceExpiresIn = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.l1();
  }
  protoOf(JSLdpVerifiableCredentialResponse).n38 = function () {
    return this.credential;
  };
  protoOf(JSLdpVerifiableCredentialResponse).s3g = function () {
    return this.cNonce;
  };
  protoOf(JSLdpVerifiableCredentialResponse).t3g = function () {
    return this.cNonceExpiresIn;
  };
  protoOf(JSLdpVerifiableCredentialResponse).toJson = function () {
    return Default_getInstance().bp(Companion_instance_48.b1b(), this.v3g_1);
  };
  function JSJwtVcJsonLdVerifiableCredentialResponse(_response) {
    this.x3g_1 = _response;
    this.credential = this.x3g_1.n38().o2h_1;
    this.cNonce = this.x3g_1.l3b_1;
    var tmp = this;
    var tmp4_safe_receiver = this.x3g_1.m3b_1;
    tmp.cNonceExpiresIn = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.l1();
  }
  protoOf(JSJwtVcJsonLdVerifiableCredentialResponse).n38 = function () {
    return this.credential;
  };
  protoOf(JSJwtVcJsonLdVerifiableCredentialResponse).s3g = function () {
    return this.cNonce;
  };
  protoOf(JSJwtVcJsonLdVerifiableCredentialResponse).t3g = function () {
    return this.cNonceExpiresIn;
  };
  protoOf(JSJwtVcJsonLdVerifiableCredentialResponse).toJson = function () {
    return Default_getInstance().bp(Companion_instance_49.b1b(), this.x3g_1);
  };
  function convertJwtVcJsonResponse(response) {
    var tmp;
    if (response instanceof Deferred) {
      tmp = Companion_instance_73.right(new JSDeferredJsonCredentialResponse(response.n3b_1));
    } else {
      if (response instanceof JwtVcJsonVerifiableCredentialResponse) {
        tmp = Companion_instance_73.left(new JSJwtVcJsonVerifiableCredentialResponse(response));
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function convertJwtVcJsonLdResponse(response) {
    var tmp;
    if (response instanceof Deferred_1) {
      tmp = Companion_instance_73.right(new JSDeferredJsonCredentialResponse(response.p3b_1));
    } else {
      if (response instanceof JwtVcJsonLdVerifiableCredentialResponse) {
        tmp = Companion_instance_73.left(new JSJwtVcJsonLdVerifiableCredentialResponse(response));
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function convertLdpVcJsonResponse(response) {
    var tmp;
    if (response instanceof Deferred_0) {
      tmp = Companion_instance_73.right(new JSDeferredJsonCredentialResponse(response.o3b_1));
    } else {
      if (response instanceof LdpVcVerifiableCredentialResponse) {
        tmp = Companion_instance_73.left(new JSLdpVerifiableCredentialResponse(response));
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function JsDisplayable() {
  }
  function JsIssuerDisplay() {
  }
  function JsDisplayableSet() {
  }
  function JsServerMetadata$credentialsSupported$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = this$0.b3h_1.t33_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(this_0.m());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = this_0.z().j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'JsServerMetadata.credentialsSupported$delegate.<anonymous>.<anonymous>' call
        // Inline function 'js.core.tupleOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$7 = [item.a1(), new JsCredentialIssuerSupportedCredential(item.b1())];
        destination.e(tmp$ret$7);
      }
      var tmp$ret$10 = copyToArray(destination);
      return new Map(tmp$ret$10);
    };
  }
  function JsServerMetadata$display$delegate$lambda(this$0) {
    return function () {
      var tmp9_safe_receiver = this$0.b3h_1.v33_1;
      var tmp;
      if (tmp9_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp9_safe_receiver, 10));
        var tmp0_iterator = tmp9_safe_receiver.j();
        while (tmp0_iterator.k()) {
          var item = tmp0_iterator.l();
          // Inline function 'JsServerMetadata.display$delegate.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new JsIssuerDisplayAdapter(item);
          destination.e(tmp$ret$0);
        }
        tmp = destination;
      }
      var tmp10_safe_receiver = tmp;
      var tmp_0;
      if (tmp10_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_0 = copyToArray(tmp10_safe_receiver);
      }
      return tmp_0;
    };
  }
  function JsServerMetadata(inner) {
    this.b3h_1 = inner;
    var tmp = this;
    var tmp8_safe_receiver = this.b3h_1.o33_1;
    var tmp_0;
    if (tmp8_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp8_safe_receiver);
    }
    tmp.authorizationServers = tmp_0;
    this.credentialEndpoint = this.b3h_1.p33_1;
    this.batchCredentialEndpoint = this.b3h_1.q33_1;
    var tmp_1 = this;
    tmp_1.c3h_1 = lazy(JsServerMetadata$credentialsSupported$delegate$lambda(this));
    this.credentialIssuer = this.b3h_1.u33_1;
    var tmp_2 = this;
    tmp_2.d3h_1 = lazy(JsServerMetadata$display$delegate$lambda(this));
  }
  protoOf(JsServerMetadata).e3h = function () {
    return this.b3h_1;
  };
  protoOf(JsServerMetadata).f3h = function () {
    return this.authorizationServers;
  };
  protoOf(JsServerMetadata).g3h = function () {
    return this.credentialEndpoint;
  };
  protoOf(JsServerMetadata).h3h = function () {
    return this.batchCredentialEndpoint;
  };
  protoOf(JsServerMetadata).i3h = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c3h_1;
    credentialsSupported$factory();
    return this_0.b1();
  };
  protoOf(JsServerMetadata).j3h = function () {
    return this.credentialIssuer;
  };
  protoOf(JsServerMetadata).k3h = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d3h_1;
    display$factory();
    return this_0.b1();
  };
  function JsDisplayableAdapter$customClaims$delegate$lambda(this$0) {
    return function () {
      return new JSObject(this$0.inner.h34_1);
    };
  }
  function JsDisplayableAdapter(inner) {
    this.inner = inner;
    this.l3h_1 = this.inner.g34_1;
    this.m3h_1 = this.inner.f34_1;
    var tmp = this;
    tmp.n3h_1 = lazy(JsDisplayableAdapter$customClaims$delegate$lambda(this));
  }
  protoOf(JsDisplayableAdapter).o3h = function () {
    return this.inner;
  };
  protoOf(JsDisplayableAdapter).y3g = function () {
    return this.l3h_1;
  };
  protoOf(JsDisplayableAdapter).r2 = function () {
    return this.m3h_1;
  };
  protoOf(JsDisplayableAdapter).z3g = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n3h_1;
    customClaims$factory();
    return this_0.b1();
  };
  function JsIssuerDisplayAdapter$customClaims$delegate$lambda(this$0) {
    return function () {
      return new JSObject(this$0.inner.d34_1);
    };
  }
  function JsIssuerDisplayAdapter(inner) {
    this.inner = inner;
    this.p3h_1 = this.inner.b34_1;
    this.q3h_1 = this.inner.a34_1;
    var tmp = this;
    var tmp11_safe_receiver = this.inner.c34_1;
    var tmp_0;
    if (tmp11_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'JsIssuerDisplayAdapter.logo.<anonymous>' call
      tmp_0 = new JsLogo(tmp11_safe_receiver);
    }
    tmp.r3h_1 = tmp_0;
    var tmp_1 = this;
    tmp_1.s3h_1 = lazy(JsIssuerDisplayAdapter$customClaims$delegate$lambda(this));
  }
  protoOf(JsIssuerDisplayAdapter).o3h = function () {
    return this.inner;
  };
  protoOf(JsIssuerDisplayAdapter).y3g = function () {
    return this.p3h_1;
  };
  protoOf(JsIssuerDisplayAdapter).r2 = function () {
    return this.q3h_1;
  };
  protoOf(JsIssuerDisplayAdapter).a3h = function () {
    return this.r3h_1;
  };
  protoOf(JsIssuerDisplayAdapter).z3g = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s3h_1;
    customClaims$factory_0();
    return this_0.b1();
  };
  function JsCredentialDisplayAdapter(inner) {
    this.description = inner.q34_1;
    this.backgroundColor = inner.r34_1;
    this.textColor = inner.t34_1;
    var tmp = this;
    var tmp12_safe_receiver = inner.p34_1;
    var tmp_0;
    if (tmp12_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'JsCredentialDisplayAdapter.logo.<anonymous>' call
      tmp_0 = new JsLogo(tmp12_safe_receiver);
    }
    tmp.logo = tmp_0;
    this.locale = inner.o34_1;
    this.name = inner.n34_1;
    this.customClaims = JsonToJsConverter_instance.n28(inner.xl());
  }
  protoOf(JsCredentialDisplayAdapter).t3h = function () {
    return this.description;
  };
  protoOf(JsCredentialDisplayAdapter).u3h = function () {
    return this.backgroundColor;
  };
  protoOf(JsCredentialDisplayAdapter).v3h = function () {
    return this.textColor;
  };
  protoOf(JsCredentialDisplayAdapter).a3h = function () {
    return this.logo;
  };
  protoOf(JsCredentialDisplayAdapter).y3g = function () {
    return this.locale;
  };
  protoOf(JsCredentialDisplayAdapter).r2 = function () {
    return this.name;
  };
  protoOf(JsCredentialDisplayAdapter).z3g = function () {
    return this.customClaims;
  };
  function JsLogo$asJson$delegate$lambda(this$0) {
    return function () {
      return JsonToJsConverter_instance.n28(this$0.w3h_1.xl());
    };
  }
  function JsLogo(inner) {
    this.w3h_1 = inner;
    this.url = this.w3h_1.j34_1;
    this.altText = this.w3h_1.k34_1;
    var tmp = this;
    tmp.x3h_1 = lazy(JsLogo$asJson$delegate$lambda(this));
  }
  protoOf(JsLogo).y3h = function () {
    return this.url;
  };
  protoOf(JsLogo).z3h = function () {
    return this.altText;
  };
  protoOf(JsLogo).a3i = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x3h_1;
    asJson$factory();
    return this_0.b1();
  };
  function JsCredentialDisplay$customClaims$delegate$lambda(this$0) {
    return function () {
      return new JSObject(this$0.inner.u34_1);
    };
  }
  function JsCredentialDisplay$logo$delegate$lambda(this$0) {
    return function () {
      var tmp13_safe_receiver = this$0.inner.p34_1;
      var tmp;
      if (tmp13_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsCredentialDisplay.logo$delegate.<anonymous>.<anonymous>' call
        tmp = new JsLogo(tmp13_safe_receiver);
      }
      return tmp;
    };
  }
  function JsCredentialDisplay(inner) {
    this.inner = inner;
    this.b3i_1 = this.inner.o34_1;
    this.c3i_1 = this.inner.n34_1;
    var tmp = this;
    tmp.d3i_1 = lazy(JsCredentialDisplay$customClaims$delegate$lambda(this));
    this.description = this.inner.q34_1;
    this.backgroundColor = this.inner.r34_1;
    this.textColor = this.inner.t34_1;
    var tmp_0 = this;
    tmp_0.e3i_1 = lazy(JsCredentialDisplay$logo$delegate$lambda(this));
  }
  protoOf(JsCredentialDisplay).o3h = function () {
    return this.inner;
  };
  protoOf(JsCredentialDisplay).y3g = function () {
    return this.b3i_1;
  };
  protoOf(JsCredentialDisplay).r2 = function () {
    return this.c3i_1;
  };
  protoOf(JsCredentialDisplay).z3g = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d3i_1;
    customClaims$factory_1();
    return this_0.b1();
  };
  protoOf(JsCredentialDisplay).t3h = function () {
    return this.description;
  };
  protoOf(JsCredentialDisplay).u3h = function () {
    return this.backgroundColor;
  };
  protoOf(JsCredentialDisplay).v3h = function () {
    return this.textColor;
  };
  protoOf(JsCredentialDisplay).a3h = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e3i_1;
    logo$factory();
    return this_0.b1();
  };
  function JsCredentialIssuerSupportedCredential$display$delegate$lambda(this$0) {
    return function () {
      var tmp14_subject = this$0.f3i_1;
      var tmp;
      if (tmp14_subject instanceof DefaultJsonCredentialConfigurationsSupported) {
        tmp = this$0.f3i_1.y34_1;
      } else {
        if (tmp14_subject instanceof JwtVcJsonCredentialConfigurationsSupported) {
          tmp = this$0.f3i_1.k39_1;
        } else {
          if (tmp14_subject instanceof VcSdJwtCredentialConfigurationsSupported) {
            tmp = this$0.f3i_1.r37_1;
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
      var displays = tmp;
      var tmp_0;
      if (displays == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsCredentialIssuerSupportedCredential.display$delegate.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(displays, 10));
        var tmp0_iterator = displays.j();
        while (tmp0_iterator.k()) {
          var item = tmp0_iterator.l();
          // Inline function 'JsCredentialIssuerSupportedCredential.display$delegate.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new JsCredentialDisplay(item);
          destination.e(tmp$ret$0);
        }
        tmp_0 = new JsDisplayableSetAdapter(destination);
      }
      return tmp_0;
    };
  }
  function JsCredentialIssuerSupportedCredential(inner) {
    this.f3i_1 = inner;
    this.format = this.f3i_1.z33();
    var tmp = this;
    tmp.g3i_1 = lazy(JsCredentialIssuerSupportedCredential$display$delegate$lambda(this));
  }
  protoOf(JsCredentialIssuerSupportedCredential).e3h = function () {
    return this.f3i_1;
  };
  protoOf(JsCredentialIssuerSupportedCredential).z33 = function () {
    return this.format;
  };
  protoOf(JsCredentialIssuerSupportedCredential).k3h = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g3i_1;
    display$factory_0();
    return this_0.b1();
  };
  function JsCredentialStatus(inner) {
    this.inner = inner;
    this.id = this.inner.g3c_1;
    this.type = this.inner.h3c_1;
  }
  protoOf(JsCredentialStatus).o3h = function () {
    return this.inner;
  };
  protoOf(JsCredentialStatus).k2a = function () {
    return this.id;
  };
  protoOf(JsCredentialStatus).g36 = function () {
    return this.type;
  };
  function JsSdValue() {
  }
  function JsSdObject$buildNestedDisclosure$lambda($disclosures) {
    return function (property, _unused_var__etf5q3) {
      var tmp;
      if (!(property.disclosureString == null)) {
        var this_0 = $disclosures;
        var item = property.disclosureString;
        // Inline function 'kotlin.js.asDynamic' call
        tmp = this_0.push(item);
      }
      return Unit_instance;
    };
  }
  function JsSdObject(members) {
    this.members = members;
  }
  protoOf(JsSdObject).h3i = function () {
    return this.members;
  };
  protoOf(JsSdObject).buildNestedDisclosure = function (disclosures) {
    this.members.forEach(JsSdObject$buildNestedDisclosure$lambda(disclosures));
  };
  function JsSdArray(elements) {
    this.elements = elements;
  }
  protoOf(JsSdArray).i3i = function () {
    return this.elements;
  };
  protoOf(JsSdArray).buildNestedDisclosure = function (disclosures) {
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = this.elements;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'JsSdArray.buildNestedDisclosure.<anonymous>' call
      if (!(element.disclosureString == null)) {
        // Inline function 'js.core.push' call
        var item = element.disclosureString;
        // Inline function 'kotlin.js.asDynamic' call
        disclosures.push(item);
      }
    }
  };
  function JsSdPrimitive(value) {
    this.value = value;
  }
  protoOf(JsSdPrimitive).b1 = function () {
    return this.value;
  };
  protoOf(JsSdPrimitive).buildNestedDisclosure = function (disclosures) {
  };
  function JsSdProperty(name, value, disclosureString) {
    disclosureString = disclosureString === VOID ? null : disclosureString;
    this.name = name;
    this.value = value;
    this.disclosureString = disclosureString;
    this.isSelectivelyDisclosable = !(this.disclosureString == null);
  }
  protoOf(JsSdProperty).r2 = function () {
    return this.name;
  };
  protoOf(JsSdProperty).b1 = function () {
    return this.value;
  };
  protoOf(JsSdProperty).j3i = function () {
    return this.disclosureString;
  };
  protoOf(JsSdProperty).k3i = function () {
    return this.isSelectivelyDisclosable;
  };
  protoOf(JsSdProperty).isDisclosedBy = function (disclosures) {
    return contains(disclosures, this.disclosureString);
  };
  function JsSdArrayValue(value, disclosureString) {
    disclosureString = disclosureString === VOID ? null : disclosureString;
    this.value = value;
    this.disclosureString = disclosureString;
    this.isSelectivelyDisclosable = !(this.disclosureString == null);
  }
  protoOf(JsSdArrayValue).b1 = function () {
    return this.value;
  };
  protoOf(JsSdArrayValue).j3i = function () {
    return this.disclosureString;
  };
  protoOf(JsSdArrayValue).k3i = function () {
    return this.isSelectivelyDisclosable;
  };
  protoOf(JsSdArrayValue).isDisclosedBy = function (disclosures) {
    return contains(disclosures, this.disclosureString);
  };
  function JsCredentialIssuer(credentialIssuer) {
    this.credentialIssuer = credentialIssuer;
    this.id = this.credentialIssuer.t32_1.u33_1;
    var tmp = this;
    var tmp18_safe_receiver = this.credentialIssuer.t32_1.v33_1;
    var tmp19_safe_receiver = tmp18_safe_receiver == null ? null : firstOrNull(tmp18_safe_receiver);
    var tmp0_elvis_lhs = tmp19_safe_receiver == null ? null : tmp19_safe_receiver.a34_1;
    tmp.name = tmp0_elvis_lhs == null ? '<no name>' : tmp0_elvis_lhs;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.credentialIssuer.t32_1.t33_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(this_0.m());
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_0.z().j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'JsCredentialIssuer.credentialsSupported.<anonymous>' call
      // Inline function 'js.core.tupleOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$7 = [item.a1(), new JsCredentialIssuerSupportedCredential(item.b1())];
      destination.e(tmp$ret$7);
    }
    var tmp$ret$10 = copyToArray(destination);
    tmp_0.credentialsSupported = new Map(tmp$ret$10);
    this.authorizationEndpoint = this.credentialIssuer.u32_1.s35_1;
    this.tokenEndpoint = this.credentialIssuer.u32_1.t35_1;
  }
  protoOf(JsCredentialIssuer).j3h = function () {
    return this.credentialIssuer;
  };
  protoOf(JsCredentialIssuer).k2a = function () {
    return this.id;
  };
  protoOf(JsCredentialIssuer).r2 = function () {
    return this.name;
  };
  protoOf(JsCredentialIssuer).i3h = function () {
    return this.credentialsSupported;
  };
  protoOf(JsCredentialIssuer).l3i = function () {
    return this.authorizationEndpoint;
  };
  protoOf(JsCredentialIssuer).m3i = function () {
    return this.tokenEndpoint;
  };
  function JsUserVerifiableCredential$credential$delegate$lambda(this$0) {
    return function () {
      return new JSCredentialResponse(this$0.n3i_1.e33_1);
    };
  }
  function JsUserVerifiableCredential(userVerifiableCredential) {
    this.n3i_1 = userVerifiableCredential;
    this.id = this.n3i_1.a33_1;
    this.issuerId = this.n3i_1.b33_1;
    this.issuedAt = this.n3i_1.c33_1.f1m().p3();
    var tmp = this;
    tmp.o3i_1 = lazy(JsUserVerifiableCredential$credential$delegate$lambda(this));
    this.userDefinedName = this.n3i_1.d33_1;
  }
  protoOf(JsUserVerifiableCredential).p3i = function () {
    return this.n3i_1;
  };
  protoOf(JsUserVerifiableCredential).k2a = function () {
    return this.id;
  };
  protoOf(JsUserVerifiableCredential).q3i = function () {
    return this.issuerId;
  };
  protoOf(JsUserVerifiableCredential).r3i = function () {
    return this.issuedAt;
  };
  protoOf(JsUserVerifiableCredential).n38 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o3i_1;
    credential$factory();
    return this_0.b1();
  };
  protoOf(JsUserVerifiableCredential).s3i = function () {
    return this.userDefinedName;
  };
  protoOf(JsUserVerifiableCredential).withUserDefinedName = function (newName) {
    return new JsUserVerifiableCredential(this.n3i_1.g33(VOID, VOID, VOID, newName));
  };
  function JsLdpVcJsonLdCredential$value$delegate$lambda(this$0) {
    return function () {
      return new JSW3CVerifiableCredential(this$0.inner.k32());
    };
  }
  function JsLdpVcJsonLdCredential(inner) {
    this.inner = inner;
    var tmp = this;
    tmp.t3i_1 = lazy(JsLdpVcJsonLdCredential$value$delegate$lambda(this));
  }
  protoOf(JsLdpVcJsonLdCredential).o3h = function () {
    return this.inner;
  };
  protoOf(JsLdpVcJsonLdCredential).b1 = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t3i_1;
    value$factory();
    return this_0.b1();
  };
  function JSCredentialResponse$jwtVcJsonLd$delegate$lambda(this$0) {
    return function () {
      var tmp20_subject = this$0.inner;
      var tmp;
      if (isInterface(tmp20_subject, ValidatedJwtVcJsonLdCredentialResponse)) {
        tmp = new JsJwtVcJsonLdCredential(this$0.inner);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JSCredentialResponse$jwtVcJson$delegate$lambda(this$0) {
    return function () {
      var tmp21_subject = this$0.inner;
      var tmp;
      if (isInterface(tmp21_subject, ValidatedJwtVcJsonCredentialResponse)) {
        tmp = new JsJwtVcJsonCredential(this$0.inner);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JSCredentialResponse$didJwtVcJson$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.inner instanceof DidValidatedJwtVcJsonCredentialResponse) {
        tmp = new JsDidJwtVcJsonCredential(this$0.inner);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JSCredentialResponse$ldp$delegate$lambda(this$0) {
    return function () {
      var tmp23_subject = this$0.inner;
      var tmp;
      if (isInterface(tmp23_subject, ValidatedLdpVcCredentialResponse)) {
        tmp = new JsLdpVcJsonLdCredential(this$0.inner);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JSCredentialResponse$vcSdJwt$delegate$lambda(this$0) {
    return function () {
      var tmp;
      if (this$0.inner instanceof DefaultValidatedVcSdJwtCredentialResponse) {
        tmp = new JsVcSdJwtCredential(this$0.inner);
      } else {
        tmp = null;
      }
      return tmp;
    };
  }
  function JSCredentialResponse(inner) {
    this.inner = inner;
    var tmp = this;
    tmp.u3i_1 = lazy(JSCredentialResponse$jwtVcJsonLd$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.v3i_1 = lazy(JSCredentialResponse$jwtVcJson$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.w3i_1 = lazy(JSCredentialResponse$didJwtVcJson$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.x3i_1 = lazy(JSCredentialResponse$ldp$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.y3i_1 = lazy(JSCredentialResponse$vcSdJwt$delegate$lambda(this));
  }
  protoOf(JSCredentialResponse).o3h = function () {
    return this.inner;
  };
  protoOf(JSCredentialResponse).z3i = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u3i_1;
    jwtVcJsonLd$factory();
    return this_0.b1();
  };
  protoOf(JSCredentialResponse).a3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v3i_1;
    jwtVcJson$factory();
    return this_0.b1();
  };
  protoOf(JSCredentialResponse).b3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w3i_1;
    didJwtVcJson$factory();
    return this_0.b1();
  };
  protoOf(JSCredentialResponse).c3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x3i_1;
    ldp$factory();
    return this_0.b1();
  };
  protoOf(JSCredentialResponse).d3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y3i_1;
    vcSdJwt$factory();
    return this_0.b1();
  };
  protoOf(JSCredentialResponse).match = function (onJwtVcJsonLd, onJwtVcJson, onLdp, onVcSdJwt) {
    var tmp25_subject = this.inner;
    var tmp;
    if (isInterface(tmp25_subject, ValidatedJwtVcJsonCredentialResponse)) {
      tmp = onJwtVcJson(ensureNotNull(this.jwtVcJson));
    } else {
      if (isInterface(tmp25_subject, ValidatedJwtVcJsonLdCredentialResponse)) {
        tmp = onJwtVcJsonLd(ensureNotNull(this.jwtVcJsonLd));
      } else {
        if (isInterface(tmp25_subject, ValidatedLdpVcCredentialResponse)) {
          tmp = onLdp(ensureNotNull(this.ldp));
        } else {
          if (isInterface(tmp25_subject, ValidatedVcSdJwtCredentialResponse)) {
            tmp = onVcSdJwt(ensureNotNull(this.vcSdJwt));
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    return tmp;
  };
  function JsJwtVcJsonLdCredential(inner) {
    this.inner = inner;
    this.value = this.inner.k31();
  }
  protoOf(JsJwtVcJsonLdCredential).o3h = function () {
    return this.inner;
  };
  protoOf(JsJwtVcJsonLdCredential).b1 = function () {
    return this.value;
  };
  function JsJwtVcJsonCredential(inner) {
    this.inner = inner;
    this.value = this.inner.k31();
  }
  protoOf(JsJwtVcJsonCredential).o3h = function () {
    return this.inner;
  };
  protoOf(JsJwtVcJsonCredential).b1 = function () {
    return this.value;
  };
  function JsDidJwtVcJsonCredential$claimDisplayables$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = this$0.e3j_1.h31_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(this_0.m());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = this_0.z().j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'JsDidJwtVcJsonCredential.claimDisplayables$delegate.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = item.a1();
        // Inline function 'kotlin.collections.component2' call
        var value = item.b1();
        // Inline function 'js.core.tupleOf' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
        var tmp0_iterator_0 = value.j();
        while (tmp0_iterator_0.k()) {
          var item_0 = tmp0_iterator_0.l();
          // Inline function 'JsDidJwtVcJsonCredential.claimDisplayables$delegate.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$3 = new JsDisplayableAdapter(item_0);
          destination_0.e(tmp$ret$3);
        }
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$12 = [key, new JsDisplayableSetAdapter(destination_0)];
        destination.e(tmp$ret$12);
      }
      var tmp$ret$15 = copyToArray(destination);
      return new Map(tmp$ret$15);
    };
  }
  function JsDidJwtVcJsonCredential$credentialDisplay$delegate$lambda(this$0) {
    return function () {
      var tmp26_safe_receiver = this$0.e3j_1.i31_1;
      var tmp;
      if (tmp26_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsDidJwtVcJsonCredential.credentialDisplay$delegate.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp26_safe_receiver, 10));
        var tmp0_iterator = tmp26_safe_receiver.j();
        while (tmp0_iterator.k()) {
          var item = tmp0_iterator.l();
          // Inline function 'JsDidJwtVcJsonCredential.credentialDisplay$delegate.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new JsCredentialDisplay(item);
          destination.e(tmp$ret$0);
        }
        tmp = new JsDisplayableSetAdapter(destination);
      }
      return tmp;
    };
  }
  function JsDidJwtVcJsonCredential$subjectStringProperties$delegate$lambda(this$0) {
    return function () {
      var item = this$0.e3j_1.g31_1.w3b_1.mm();
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_0 = item.f2();
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'JsDidJwtVcJsonCredential.subjectStringProperties$delegate.<anonymous>.<anonymous>' call
        var field = item.vl(element);
        var tmp;
        if (field instanceof JsonPrimitive) {
          // Inline function 'js.core.tupleOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.arrayOf' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp = [element, field.e1b()];
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.e(tmp0_safe_receiver);
        }
      }
      var tmp$ret$10 = copyToArray(destination);
      return new Map(tmp$ret$10);
    };
  }
  function JsDidJwtVcJsonCredential(inner) {
    this.e3j_1 = inner;
    var tmp = this;
    tmp.f3j_1 = lazy(JsDidJwtVcJsonCredential$claimDisplayables$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.g3j_1 = lazy(JsDidJwtVcJsonCredential$credentialDisplay$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.h3j_1 = lazy(JsDidJwtVcJsonCredential$subjectStringProperties$delegate$lambda(this));
  }
  protoOf(JsDidJwtVcJsonCredential).i3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f3j_1;
    claimDisplayables$factory();
    return this_0.b1();
  };
  protoOf(JsDidJwtVcJsonCredential).j3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g3j_1;
    credentialDisplay$factory();
    return this_0.b1();
  };
  protoOf(JsDidJwtVcJsonCredential).k3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h3j_1;
    subjectStringProperties$factory();
    return this_0.b1();
  };
  function JsSelectivelyDiscloseableClaim(name, value, isSelectivelyDiscloseable) {
    this.name = name;
    this.value = value;
    this.isSelectivelyDiscloseable = isSelectivelyDiscloseable;
  }
  protoOf(JsSelectivelyDiscloseableClaim).r2 = function () {
    return this.name;
  };
  protoOf(JsSelectivelyDiscloseableClaim).b1 = function () {
    return this.value;
  };
  protoOf(JsSelectivelyDiscloseableClaim).l3j = function () {
    return this.isSelectivelyDiscloseable;
  };
  protoOf(JsSelectivelyDiscloseableClaim).ba = function () {
    return this.name;
  };
  protoOf(JsSelectivelyDiscloseableClaim).ca = function () {
    return this.value;
  };
  protoOf(JsSelectivelyDiscloseableClaim).qj = function () {
    return this.isSelectivelyDiscloseable;
  };
  protoOf(JsSelectivelyDiscloseableClaim).m3j = function (name, value, isSelectivelyDiscloseable) {
    return new JsSelectivelyDiscloseableClaim(name, value, isSelectivelyDiscloseable);
  };
  protoOf(JsSelectivelyDiscloseableClaim).copy = function (name, value, isSelectivelyDiscloseable, $super) {
    name = name === VOID ? this.name : name;
    value = value === VOID ? this.value : value;
    isSelectivelyDiscloseable = isSelectivelyDiscloseable === VOID ? this.isSelectivelyDiscloseable : isSelectivelyDiscloseable;
    return this.m3j(name, value, isSelectivelyDiscloseable);
  };
  protoOf(JsSelectivelyDiscloseableClaim).toString = function () {
    return 'JsSelectivelyDiscloseableClaim(name=' + this.name + ', value=' + toString_0(this.value) + ', isSelectivelyDiscloseable=' + this.isSelectivelyDiscloseable + ')';
  };
  protoOf(JsSelectivelyDiscloseableClaim).hashCode = function () {
    var result = getStringHashCode(this.name);
    result = imul(result, 31) + (this.value == null ? 0 : hashCode(this.value)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.isSelectivelyDiscloseable) | 0;
    return result;
  };
  protoOf(JsSelectivelyDiscloseableClaim).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof JsSelectivelyDiscloseableClaim))
      return false;
    var tmp0_other_with_cast = other instanceof JsSelectivelyDiscloseableClaim ? other : THROW_CCE();
    if (!(this.name === tmp0_other_with_cast.name))
      return false;
    if (!equals(this.value, tmp0_other_with_cast.value))
      return false;
    if (!(this.isSelectivelyDiscloseable === tmp0_other_with_cast.isSelectivelyDiscloseable))
      return false;
    return true;
  };
  function JsVcSdJwtCredential$claimDisplayables$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = this$0.n3j_1.u30_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(this_0.m());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator = this_0.z().j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'JsVcSdJwtCredential.claimDisplayables$delegate.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = item.a1();
        // Inline function 'kotlin.collections.component2' call
        var value = item.b1();
        // Inline function 'js.core.tupleOf' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(value, 10));
        var tmp0_iterator_0 = value.j();
        while (tmp0_iterator_0.k()) {
          var item_0 = tmp0_iterator_0.l();
          // Inline function 'JsVcSdJwtCredential.claimDisplayables$delegate.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$3 = new JsDisplayableAdapter(item_0);
          destination_0.e(tmp$ret$3);
        }
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$12 = [key, new JsDisplayableSetAdapter(destination_0)];
        destination.e(tmp$ret$12);
      }
      var tmp$ret$15 = copyToArray(destination);
      return new Map(tmp$ret$15);
    };
  }
  function JsVcSdJwtCredential$credentialDisplay$delegate$lambda(this$0) {
    return function () {
      var tmp27_safe_receiver = this$0.n3j_1.v30_1;
      var tmp;
      if (tmp27_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'JsVcSdJwtCredential.credentialDisplay$delegate.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp27_safe_receiver, 10));
        var tmp0_iterator = tmp27_safe_receiver.j();
        while (tmp0_iterator.k()) {
          var item = tmp0_iterator.l();
          // Inline function 'JsVcSdJwtCredential.credentialDisplay$delegate.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$0 = new JsCredentialDisplay(item);
          destination.e(tmp$ret$0);
        }
        tmp = new JsDisplayableSetAdapter(destination);
      }
      return tmp;
    };
  }
  function JsVcSdJwtCredential$customStringClaims$delegate$lambda(this$0) {
    return function () {
      var customClaims = this$0.n3j_1.z30_1.g2w_1;
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_0 = customClaims.f2();
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'JsVcSdJwtCredential.customStringClaims$delegate.<anonymous>.<anonymous>' call
        var claim = ensureNotNull(customClaims.e2(element));
        var field = claim.s2w_1;
        var tmp;
        if (field instanceof Primitive) {
          var tmp28_safe_receiver = field.n2w_1;
          var tmp0_elvis_lhs = tmp28_safe_receiver == null ? null : tmp28_safe_receiver.e1b();
          tmp = new JsSelectivelyDiscloseableClaim(element, tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, !(claim.t2w_1 == null));
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.e(tmp0_safe_receiver);
        }
      }
      return copyToArray(destination);
    };
  }
  function JsVcSdJwtCredential(inner) {
    this.n3j_1 = inner;
    var tmp = this;
    tmp.o3j_1 = lazy(JsVcSdJwtCredential$claimDisplayables$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.p3j_1 = lazy(JsVcSdJwtCredential$credentialDisplay$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.q3j_1 = lazy(JsVcSdJwtCredential$customStringClaims$delegate$lambda(this));
    this.customSdClaims = JsSdValue_0(this.n3j_1.z30_1);
  }
  protoOf(JsVcSdJwtCredential).i3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o3j_1;
    claimDisplayables$factory_0();
    return this_0.b1();
  };
  protoOf(JsVcSdJwtCredential).j3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p3j_1;
    credentialDisplay$factory_0();
    return this_0.b1();
  };
  protoOf(JsVcSdJwtCredential).r3j = function () {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.q3j_1;
    customStringClaims$factory();
    return this_0.b1();
  };
  protoOf(JsVcSdJwtCredential).s3j = function () {
    return this.customSdClaims;
  };
  function JsDisplayableSetAdapter(inner) {
    this.t3j_1 = inner;
  }
  protoOf(JsDisplayableSetAdapter).getBestMatchForLocales = function (preferredLocales) {
    var tmp$ret$10;
    $l$block_2: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(preferredLocales.length);
      var inductionVariable = 0;
      var last = preferredLocales.length;
      while (inductionVariable < last) {
        var item = preferredLocales[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>' call
        var tmp$ret$0 = new Locale(item);
        destination.e(tmp$ret$0);
      }
      var tmp0_iterator = destination.j();
      while (tmp0_iterator.k()) {
        var element = tmp0_iterator.l();
        // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>' call
        var tmp;
        if (element.ql_1) {
          var tmp$ret$4;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator_0 = this.t3j_1.j();
            while (tmp0_iterator_0.k()) {
              var element_0 = tmp0_iterator_0.l();
              // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>.<anonymous>' call
              if (element.sl(element_0.locale)) {
                tmp$ret$4 = element_0;
                break $l$block;
              }
            }
            tmp$ret$4 = null;
          }
          tmp = tmp$ret$4;
        } else {
          var tmp$ret$6;
          $l$block_0: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var tmp0_iterator_1 = this.t3j_1.j();
            while (tmp0_iterator_1.k()) {
              var element_1 = tmp0_iterator_1.l();
              // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>.<anonymous>' call
              if (element.toString() === element_1.locale) {
                tmp$ret$6 = element_1;
                break $l$block_0;
              }
            }
            tmp$ret$6 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$6;
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            var tmp$ret$8;
            $l$block_1: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var tmp0_iterator_2 = this.t3j_1.j();
              while (tmp0_iterator_2.k()) {
                var element_2 = tmp0_iterator_2.l();
                // Inline function 'JsDisplayableSetAdapter.getBestMatchForLocales.<anonymous>.<anonymous>' call
                if (element.sl(element_2.locale)) {
                  tmp$ret$8 = element_2;
                  break $l$block_1;
                }
              }
              tmp$ret$8 = null;
            }
            tmp_0 = tmp$ret$8;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          tmp = tmp_0;
        }
        var result = tmp;
        if (!(result == null)) {
          tmp$ret$10 = result;
          break $l$block_2;
        }
      }
      tmp$ret$10 = null;
    }
    var tmp0_elvis_lhs_0 = tmp$ret$10;
    return tmp0_elvis_lhs_0 == null ? firstOrNull(this.t3j_1) : tmp0_elvis_lhs_0;
  };
  function JsSdValue_0(value) {
    var tmp;
    if (value instanceof Object_0) {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = value.g2w_1.g2();
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'JsSdValue.<anonymous>' call
        // Inline function 'js.core.tupleOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$6 = [item.r2w_1, new JsSdProperty(item.r2w_1, JsSdValue_0(item.s2w_1), item.t2w_1)];
        destination.e(tmp$ret$6);
      }
      var tmp$ret$9 = copyToArray(destination);
      tmp = new JsSdObject(new Map(tmp$ret$9));
    } else {
      if (value instanceof Array_0) {
        // Inline function 'kotlin.collections.toTypedArray' call
        // Inline function 'kotlin.collections.map' call
        var this_1 = value.k2w_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_0 = ArrayList_init_$Create$(this_1.length);
        var inductionVariable = 0;
        var last = this_1.length;
        while (inductionVariable < last) {
          var item_0 = this_1[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'JsSdValue.<anonymous>' call
          var tmp$ret$10 = new JsSdArrayValue(JsSdValue_0(item_0.x2w_1), item_0.y2w_1);
          destination_0.e(tmp$ret$10);
        }
        var tmp$ret$13 = copyToArray(destination_0);
        tmp = new JsSdArray(tmp$ret$13);
      } else {
        if (value instanceof Primitive) {
          var tmp17_safe_receiver = value.n2w_1;
          tmp = new JsSdPrimitive(tmp17_safe_receiver == null ? null : tmp17_safe_receiver.e1b());
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function inner(_this__u8e3s4) {
    return _this__u8e3s4.b3h_1;
  }
  function inner_0(_this__u8e3s4) {
    return _this__u8e3s4.f3i_1;
  }
  function createJsCredentialIssuer(credentialIssuer) {
    return new JsCredentialIssuer(credentialIssuer);
  }
  function inner_1(_this__u8e3s4) {
    return _this__u8e3s4.n3i_1;
  }
  function createJsUserVerifiableCredential(inner) {
    return new JsUserVerifiableCredential(inner);
  }
  function createJsCredentialIssuerSupportedCredential(inner) {
    return new JsCredentialIssuerSupportedCredential(inner);
  }
  function credentialsSupported$factory() {
    return getPropertyCallableRef('credentialsSupported', 1, KProperty1, function (receiver) {
      return receiver.credentialsSupported;
    }, null);
  }
  function display$factory() {
    return getPropertyCallableRef('display', 1, KProperty1, function (receiver) {
      return receiver.display;
    }, null);
  }
  function customClaims$factory() {
    return getPropertyCallableRef('customClaims', 1, KProperty1, function (receiver) {
      return receiver.customClaims;
    }, null);
  }
  function customClaims$factory_0() {
    return getPropertyCallableRef('customClaims', 1, KProperty1, function (receiver) {
      return receiver.customClaims;
    }, null);
  }
  function asJson$factory() {
    return getPropertyCallableRef('asJson', 1, KProperty1, function (receiver) {
      return receiver.asJson;
    }, null);
  }
  function customClaims$factory_1() {
    return getPropertyCallableRef('customClaims', 1, KProperty1, function (receiver) {
      return receiver.customClaims;
    }, null);
  }
  function logo$factory() {
    return getPropertyCallableRef('logo', 1, KProperty1, function (receiver) {
      return receiver.logo;
    }, null);
  }
  function display$factory_0() {
    return getPropertyCallableRef('display', 1, KProperty1, function (receiver) {
      return receiver.display;
    }, null);
  }
  function credential$factory() {
    return getPropertyCallableRef('credential', 1, KProperty1, function (receiver) {
      return receiver.credential;
    }, null);
  }
  function value$factory() {
    return getPropertyCallableRef('value', 1, KProperty1, function (receiver) {
      return receiver.value;
    }, null);
  }
  function jwtVcJsonLd$factory() {
    return getPropertyCallableRef('jwtVcJsonLd', 1, KProperty1, function (receiver) {
      return receiver.jwtVcJsonLd;
    }, null);
  }
  function jwtVcJson$factory() {
    return getPropertyCallableRef('jwtVcJson', 1, KProperty1, function (receiver) {
      return receiver.jwtVcJson;
    }, null);
  }
  function didJwtVcJson$factory() {
    return getPropertyCallableRef('didJwtVcJson', 1, KProperty1, function (receiver) {
      return receiver.didJwtVcJson;
    }, null);
  }
  function ldp$factory() {
    return getPropertyCallableRef('ldp', 1, KProperty1, function (receiver) {
      return receiver.ldp;
    }, null);
  }
  function vcSdJwt$factory() {
    return getPropertyCallableRef('vcSdJwt', 1, KProperty1, function (receiver) {
      return receiver.vcSdJwt;
    }, null);
  }
  function claimDisplayables$factory() {
    return getPropertyCallableRef('claimDisplayables', 1, KProperty1, function (receiver) {
      return receiver.claimDisplayables;
    }, null);
  }
  function credentialDisplay$factory() {
    return getPropertyCallableRef('credentialDisplay', 1, KProperty1, function (receiver) {
      return receiver.credentialDisplay;
    }, null);
  }
  function subjectStringProperties$factory() {
    return getPropertyCallableRef('subjectStringProperties', 1, KProperty1, function (receiver) {
      return receiver.subjectStringProperties;
    }, null);
  }
  function claimDisplayables$factory_0() {
    return getPropertyCallableRef('claimDisplayables', 1, KProperty1, function (receiver) {
      return receiver.claimDisplayables;
    }, null);
  }
  function credentialDisplay$factory_0() {
    return getPropertyCallableRef('credentialDisplay', 1, KProperty1, function (receiver) {
      return receiver.credentialDisplay;
    }, null);
  }
  function customStringClaims$factory() {
    return getPropertyCallableRef('customStringClaims', 1, KProperty1, function (receiver) {
      return receiver.customStringClaims;
    }, null);
  }
  function Companion_72() {
  }
  protoOf(Companion_72).w3g = function (credential) {
    return new JSW3CVerifiableCredential(credential);
  };
  var Companion_instance_74;
  function Companion_getInstance_72() {
    return Companion_instance_74;
  }
  function JSW3CVerifiableCredential(_credential) {
    this.u3j_1 = _credential;
  }
  protoOf(JSW3CVerifiableCredential).k2a = function () {
    return this.u3j_1.t3b_1;
  };
  protoOf(JSW3CVerifiableCredential).b9 = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.u3j_1.u3b_1;
    return copyToArray(this_0);
  };
  protoOf(JSW3CVerifiableCredential).p3g = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = this.u3j_1.v3b_1;
    return copyToArray(this_0);
  };
  protoOf(JSW3CVerifiableCredential).v3j = function () {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.u3j_1.w3b_1.qm();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.j();
    while (tmp0_iterator.k()) {
      var item = tmp0_iterator.l();
      // Inline function 'JSW3CVerifiableCredential.<get-credentialSubject>.<anonymous>' call
      var tmp$ret$0 = new JSObject(item);
      destination.e(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(JSW3CVerifiableCredential).e3c = function () {
    var iss = this.u3j_1.x3b_1.q3c();
    var tmp;
    if (iss instanceof IssuerObject_0) {
      tmp = Companion_instance_73.right(new JSIssuerObject(iss.f3c()));
    } else {
      if (iss instanceof IssuerURI_0) {
        tmp = Companion_instance_73.left(iss.m36_1);
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  };
  protoOf(JSW3CVerifiableCredential).w3j = function () {
    return this.u3j_1.y3b_1;
  };
  protoOf(JSW3CVerifiableCredential).x3j = function () {
    var tmp29_safe_receiver = this.u3j_1.z3b_1;
    var tmp30_safe_receiver = tmp29_safe_receiver == null ? null : tmp29_safe_receiver.qm();
    var tmp;
    if (tmp30_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(tmp30_safe_receiver, 10));
      var tmp0_iterator = tmp30_safe_receiver.j();
      while (tmp0_iterator.k()) {
        var item = tmp0_iterator.l();
        // Inline function 'JSW3CVerifiableCredential.<get-proof>.<anonymous>' call
        var tmp$ret$0 = new JSProofObject(item);
        destination.e(tmp$ret$0);
      }
      tmp = destination;
    }
    var tmp31_safe_receiver = tmp;
    var tmp_0;
    if (tmp31_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp31_safe_receiver);
    }
    return tmp_0;
  };
  protoOf(JSW3CVerifiableCredential).y3j = function () {
    return this.u3j_1.a3c_1;
  };
  protoOf(JSW3CVerifiableCredential).z3j = function () {
    var tmp32_safe_receiver = this.u3j_1.b3c_1;
    var tmp;
    if (tmp32_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'JSW3CVerifiableCredential.<get-credentialStatus>.<anonymous>' call
      tmp = new JSCredentialStatusObject(tmp32_safe_receiver);
    }
    return tmp;
  };
  protoOf(JSW3CVerifiableCredential).z3g = function () {
    var tmp33_safe_receiver = this.u3j_1.c3c_1;
    var tmp;
    if (tmp33_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'JSW3CVerifiableCredential.<get-customClaims>.<anonymous>' call
      tmp = new JSObject(tmp33_safe_receiver);
    }
    return tmp;
  };
  protoOf(JSW3CVerifiableCredential).toJson = function () {
    return Default_getInstance().bp(Companion_instance_54.b1b(), this.u3j_1);
  };
  //region block: post-declaration
  protoOf($serializer).mz = typeParametersSerializers;
  protoOf($serializer_0).mz = typeParametersSerializers;
  protoOf($serializer_1).mz = typeParametersSerializers;
  protoOf($serializer_2).mz = typeParametersSerializers;
  protoOf($serializer_3).mz = typeParametersSerializers;
  protoOf($serializer_4).mz = typeParametersSerializers;
  protoOf($serializer_5).mz = typeParametersSerializers;
  protoOf($serializer_6).mz = typeParametersSerializers;
  protoOf($serializer_7).mz = typeParametersSerializers;
  protoOf($serializer_8).mz = typeParametersSerializers;
  protoOf($serializer_9).mz = typeParametersSerializers;
  protoOf(JsonIssuerDisplay).f2 = get_keys;
  protoOf(JsonIssuerDisplay).vl = get;
  protoOf(JsonIssuerDisplay).a27 = toJson_0;
  protoOf(JsonIssuerDisplay).xl = toMap_0;
  protoOf(JsonDisplayable).f2 = get_keys;
  protoOf(JsonDisplayable).vl = get;
  protoOf(JsonDisplayable).a27 = toJson_0;
  protoOf(JsonDisplayable).xl = toMap_0;
  protoOf(JsonLogo).f2 = get_keys;
  protoOf(JsonLogo).vl = get;
  protoOf(JsonLogo).a27 = toJson_0;
  protoOf(JsonLogo).xl = toMap_0;
  protoOf(JsonCredentialDisplay).f2 = get_keys;
  protoOf(JsonCredentialDisplay).vl = get;
  protoOf(JsonCredentialDisplay).a27 = toJson_0;
  protoOf(JsonCredentialDisplay).xl = toMap_0;
  protoOf(DefaultJsonCredentialConfigurationsSupported).f2 = get_keys;
  protoOf(DefaultJsonCredentialConfigurationsSupported).vl = get;
  protoOf(DefaultJsonCredentialConfigurationsSupported).a27 = toJson_0;
  protoOf(DefaultJsonCredentialConfigurationsSupported).xl = toMap_0;
  protoOf($serializer_10).mz = typeParametersSerializers;
  protoOf(JsonImage).f2 = get_keys;
  protoOf(JsonImage).vl = get;
  protoOf(JsonImage).a27 = toJson_0;
  protoOf(JsonImage).xl = toMap_0;
  protoOf($serializer_11).mz = typeParametersSerializers;
  protoOf($serializer_12).mz = typeParametersSerializers;
  protoOf(JwtProofOfPossession).f2 = get_keys;
  protoOf(JwtProofOfPossession).vl = get;
  protoOf(JwtProofOfPossession).a27 = toJson_0;
  protoOf(JsonProofOfPossession).f2 = get_keys;
  protoOf(JsonProofOfPossession).vl = get;
  protoOf(JsonProofOfPossession).xl = toMap_0;
  protoOf(JsonProofOfPossession).a27 = toJson_0;
  protoOf(JsonProof).f2 = get_keys;
  protoOf(JsonProof).vl = get;
  protoOf(JsonProof).xl = toMap_0;
  protoOf(JsonProof).a27 = toJson_0;
  protoOf($serializer_13).mz = typeParametersSerializers;
  protoOf(JsonClaims).f2 = get_keys;
  protoOf(JsonClaims).vl = get;
  protoOf(JsonClaims).a27 = toJson_0;
  protoOf(JsonClaims).xl = toMap_0;
  protoOf(JsonClaimsItem).f2 = get_keys;
  protoOf(JsonClaimsItem).vl = get;
  protoOf(JsonClaimsItem).a27 = toJson_0;
  protoOf(JsonClaimsItem).xl = toMap_0;
  protoOf($serializer_14).mz = typeParametersSerializers;
  protoOf($serializer_15).mz = typeParametersSerializers;
  protoOf(VcSdJwtClaimsMetadata).f2 = get_keys;
  protoOf(VcSdJwtClaimsMetadata).vl = get;
  protoOf(VcSdJwtClaimsMetadata).a27 = toJson_0;
  protoOf(VcSdJwtClaimsMetadata).xl = toMap_0;
  protoOf(VcSdJwtClaimsEntryMetadata).f2 = get_keys;
  protoOf(VcSdJwtClaimsEntryMetadata).vl = get;
  protoOf(VcSdJwtClaimsEntryMetadata).a27 = toJson_0;
  protoOf(VcSdJwtClaimsEntryMetadata).xl = toMap_0;
  protoOf($serializer_16).mz = typeParametersSerializers;
  protoOf($serializer_17).mz = typeParametersSerializers;
  protoOf($serializer_18).mz = typeParametersSerializers;
  protoOf(JsonCredentialSubject).f2 = get_keys;
  protoOf(JsonCredentialSubject).vl = get;
  protoOf(JsonCredentialSubject).a27 = toJson_0;
  protoOf(JsonCredentialSubject).xl = toMap_0;
  protoOf(JsonCredentialSubjectItem).f2 = get_keys;
  protoOf(JsonCredentialSubjectItem).vl = get;
  protoOf(JsonCredentialSubjectItem).a27 = toJson_0;
  protoOf(JsonCredentialSubjectItem).xl = toMap_0;
  protoOf($serializer_19).mz = typeParametersSerializers;
  protoOf($serializer_20).mz = typeParametersSerializers;
  protoOf($serializer_21).mz = typeParametersSerializers;
  protoOf(JwtVcJsonCredentialSubjectMetadata).f2 = get_keys;
  protoOf(JwtVcJsonCredentialSubjectMetadata).vl = get;
  protoOf(JwtVcJsonCredentialSubjectMetadata).a27 = toJson_0;
  protoOf(JwtVcJsonCredentialSubjectMetadata).xl = toMap_0;
  protoOf(JwtVcJsonCredentialSubjectEntryMetadata).f2 = get_keys;
  protoOf(JwtVcJsonCredentialSubjectEntryMetadata).vl = get;
  protoOf(JwtVcJsonCredentialSubjectEntryMetadata).a27 = toJson_0;
  protoOf(JwtVcJsonCredentialSubjectEntryMetadata).xl = toMap_0;
  protoOf(CredentialDefinition).f2 = get_keys;
  protoOf(CredentialDefinition).vl = get;
  protoOf(CredentialDefinition).a27 = toJson_0;
  protoOf(CredentialDefinition).xl = toMap_0;
  protoOf($serializer_22).mz = typeParametersSerializers;
  protoOf($serializer_23).mz = typeParametersSerializers;
  protoOf($serializer_24).mz = typeParametersSerializers;
  protoOf(BasicCredentialSubject).f2 = get_keys;
  protoOf(BasicCredentialSubject).vl = get;
  protoOf(BasicCredentialSubject).a27 = toJson_0;
  protoOf($serializer_25).mz = typeParametersSerializers;
  protoOf($serializer_26).mz = typeParametersSerializers;
  protoOf($serializer_27).mz = typeParametersSerializers;
  protoOf(SerializableW3CVerifiableCredential).f2 = get_keys;
  protoOf(SerializableW3CVerifiableCredential).vl = get;
  protoOf(SerializableW3CVerifiableCredential).a27 = toJson_0;
  protoOf(SerializableW3CVerifiableCredential).xl = toMap_0;
  protoOf(JsonCredentialStatus).f2 = get_keys;
  protoOf(JsonCredentialStatus).vl = get;
  protoOf(JsonCredentialStatus).a27 = toJson_0;
  protoOf(JsonCredentialStatus).xl = toMap_0;
  protoOf(IssuerURI_0).q3c = toJsonIssuer;
  protoOf(IssuerObject_0).q3c = toJsonIssuer;
  protoOf($serializer_28).mz = typeParametersSerializers;
  protoOf($serializer_29).mz = typeParametersSerializers;
  protoOf($serializer_30).mz = typeParametersSerializers;
  protoOf($serializer_31).mz = typeParametersSerializers;
  protoOf($serializer_32).mz = typeParametersSerializers;
  protoOf($serializer_33).mz = typeParametersSerializers;
  protoOf($serializer_34).mz = typeParametersSerializers;
  protoOf($serializer_35).mz = typeParametersSerializers;
  protoOf($serializer_36).mz = typeParametersSerializers;
  protoOf($serializer_37).mz = typeParametersSerializers;
  protoOf(JsonFormat).f2 = get_keys;
  protoOf(JsonFormat).vl = get;
  protoOf(JsonFormat).xl = toMap_0;
  protoOf(JsonFormat).a27 = toJson_0;
  protoOf($serializer_38).mz = typeParametersSerializers;
  protoOf($serializer_39).mz = typeParametersSerializers;
  protoOf($serializer_40).mz = typeParametersSerializers;
  protoOf($serializer_41).mz = typeParametersSerializers;
  protoOf(JsonDictionaryVerifiablePresentation).a27 = toJson_0;
  protoOf(JsonDictionaryVerifiablePresentation).f2 = get_keys;
  protoOf(JsonDictionaryVerifiablePresentation).vl = get;
  protoOf(JsonDictionaryVerifiablePresentation).xl = toMap_0;
  protoOf($serializer_42).mz = typeParametersSerializers;
  protoOf(SerializableW3CVerifiablePresentation).f2 = get_keys;
  protoOf(SerializableW3CVerifiablePresentation).vl = get;
  protoOf(SerializableW3CVerifiablePresentation).a27 = toJson_0;
  protoOf(SerializableW3CVerifiablePresentation).xl = toMap_0;
  defineProp(protoOf(JsServerMetadata), 'credentialsSupported', protoOf(JsServerMetadata).i3h);
  defineProp(protoOf(JsServerMetadata), 'display', protoOf(JsServerMetadata).k3h);
  defineProp(protoOf(JsDisplayableAdapter), 'locale', function () {
    return this.y3g();
  });
  defineProp(protoOf(JsDisplayableAdapter), 'name', function () {
    return this.r2();
  });
  defineProp(protoOf(JsDisplayableAdapter), 'customClaims', function () {
    return this.z3g();
  });
  defineProp(protoOf(JsIssuerDisplayAdapter), 'locale', function () {
    return this.y3g();
  });
  defineProp(protoOf(JsIssuerDisplayAdapter), 'name', function () {
    return this.r2();
  });
  defineProp(protoOf(JsIssuerDisplayAdapter), 'logo', function () {
    return this.a3h();
  });
  defineProp(protoOf(JsIssuerDisplayAdapter), 'customClaims', function () {
    return this.z3g();
  });
  defineProp(protoOf(JsLogo), 'asJson', protoOf(JsLogo).a3i);
  defineProp(protoOf(JsCredentialDisplay), 'locale', function () {
    return this.y3g();
  });
  defineProp(protoOf(JsCredentialDisplay), 'name', function () {
    return this.r2();
  });
  defineProp(protoOf(JsCredentialDisplay), 'customClaims', function () {
    return this.z3g();
  });
  defineProp(protoOf(JsCredentialDisplay), 'logo', protoOf(JsCredentialDisplay).a3h);
  defineProp(protoOf(JsCredentialIssuerSupportedCredential), 'display', protoOf(JsCredentialIssuerSupportedCredential).k3h);
  protoOf(JsSdObject).getNestedDisclosures = getNestedDisclosures;
  protoOf(JsSdArray).getNestedDisclosures = getNestedDisclosures;
  protoOf(JsSdPrimitive).getNestedDisclosures = getNestedDisclosures;
  defineProp(protoOf(JsUserVerifiableCredential), 'credential', protoOf(JsUserVerifiableCredential).n38);
  defineProp(protoOf(JsLdpVcJsonLdCredential), 'value', protoOf(JsLdpVcJsonLdCredential).b1);
  defineProp(protoOf(JSCredentialResponse), 'jwtVcJsonLd', protoOf(JSCredentialResponse).z3i);
  defineProp(protoOf(JSCredentialResponse), 'jwtVcJson', protoOf(JSCredentialResponse).a3j);
  defineProp(protoOf(JSCredentialResponse), 'didJwtVcJson', protoOf(JSCredentialResponse).b3j);
  defineProp(protoOf(JSCredentialResponse), 'ldp', protoOf(JSCredentialResponse).c3j);
  defineProp(protoOf(JSCredentialResponse), 'vcSdJwt', protoOf(JSCredentialResponse).d3j);
  defineProp(protoOf(JsDidJwtVcJsonCredential), 'claimDisplayables', protoOf(JsDidJwtVcJsonCredential).i3j);
  defineProp(protoOf(JsDidJwtVcJsonCredential), 'credentialDisplay', protoOf(JsDidJwtVcJsonCredential).j3j);
  defineProp(protoOf(JsDidJwtVcJsonCredential), 'subjectStringProperties', protoOf(JsDidJwtVcJsonCredential).k3j);
  defineProp(protoOf(JsVcSdJwtCredential), 'claimDisplayables', protoOf(JsVcSdJwtCredential).i3j);
  defineProp(protoOf(JsVcSdJwtCredential), 'credentialDisplay', protoOf(JsVcSdJwtCredential).j3j);
  defineProp(protoOf(JsVcSdJwtCredential), 'customStringClaims', protoOf(JsVcSdJwtCredential).r3j);
  defineProp(protoOf(JSW3CVerifiableCredential), 'id', protoOf(JSW3CVerifiableCredential).k2a);
  defineProp(protoOf(JSW3CVerifiableCredential), 'context', protoOf(JSW3CVerifiableCredential).b9);
  defineProp(protoOf(JSW3CVerifiableCredential), 'types', protoOf(JSW3CVerifiableCredential).p3g);
  defineProp(protoOf(JSW3CVerifiableCredential), 'credentialSubject', protoOf(JSW3CVerifiableCredential).v3j);
  defineProp(protoOf(JSW3CVerifiableCredential), 'issuer', protoOf(JSW3CVerifiableCredential).e3c);
  defineProp(protoOf(JSW3CVerifiableCredential), 'issuanceDate', protoOf(JSW3CVerifiableCredential).w3j);
  defineProp(protoOf(JSW3CVerifiableCredential), 'proof', protoOf(JSW3CVerifiableCredential).x3j);
  defineProp(protoOf(JSW3CVerifiableCredential), 'expirationDate', protoOf(JSW3CVerifiableCredential).y3j);
  defineProp(protoOf(JSW3CVerifiableCredential), 'credentialStatus', protoOf(JSW3CVerifiableCredential).z3j);
  defineProp(protoOf(JSW3CVerifiableCredential), 'customClaims', protoOf(JSW3CVerifiableCredential).z3g);
  //endregion
  //region block: init
  Companion_instance_3 = new Companion_1();
  Companion_instance_4 = new Companion_2();
  Companion_instance_5 = new Companion_3();
  Companion_instance_7 = new Companion_5();
  Companion_instance_8 = new Companion_6();
  Companion_instance_10 = new Companion_8();
  Companion_instance_13 = new Companion_11();
  Companion_instance_14 = new Companion_12();
  Companion_instance_15 = new Companion_13();
  Companion_instance_16 = new Companion_14();
  Companion_instance_17 = new Companion_15();
  Companion_instance_19 = new Companion_17();
  Companion_instance_21 = new Companion_19();
  Companion_instance_25 = new Companion_23();
  Companion_instance_26 = new Companion_24();
  Companion_instance_27 = new Companion_25();
  Companion_instance_28 = new Companion_26();
  Companion_instance_30 = new Companion_28();
  Companion_instance_31 = new Companion_29();
  Companion_instance_32 = new Companion_30();
  Companion_instance_33 = new Companion_31();
  Companion_instance_34 = new Companion_32();
  Companion_instance_35 = new Companion_33();
  Companion_instance_36 = new Companion_34();
  Companion_instance_40 = new Companion_38();
  Companion_instance_41 = new Companion_39();
  Companion_instance_42 = new Companion_40();
  Companion_instance_43 = new Companion_41();
  Companion_instance_44 = new Companion_42();
  Companion_instance_45 = new Companion_43();
  Companion_instance_47 = new Companion_45();
  Companion_instance_48 = new Companion_46();
  Companion_instance_49 = new Companion_47();
  Companion_instance_50 = new Companion_48();
  Companion_instance_51 = new Companion_49();
  Companion_instance_52 = new Companion_50();
  Companion_instance_53 = new Companion_51();
  Companion_instance_54 = new Companion_52();
  Companion_instance_55 = new Companion_53();
  Companion_instance_56 = new Companion_54();
  Companion_instance_58 = new Companion_56();
  Companion_instance_62 = new Companion_60();
  Companion_instance_63 = new Companion_61();
  Companion_instance_64 = new Companion_62();
  Companion_instance_65 = new Companion_63();
  Companion_instance_67 = new Companion_65();
  Companion_instance_70 = new Companion_68();
  Companion_instance_71 = new Companion_69();
  Companion_instance_72 = new Companion_70();
  Companion_instance_73 = new Companion_71();
  Companion_instance_74 = new Companion_72();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    _.Either = Either;
    defineProp(_.Either, 'Companion', Companion_getInstance_71);
    var $vc_js = _.vc_js || (_.vc_js = {});
    _.JSObject = JSObject;
    _.JSIssuerObject = JSIssuerObject;
    _.JSProofObject = JSProofObject;
    _.JSCredentialStatusObject = JSCredentialStatusObject;
    _.JsPair = JsPair;
    _.JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition = JsJwtVcJsonVerifiableCredentialRequestCredentialDefinition;
    _.JSJwtVcJsonVerifiableCredentialRequest = JSJwtVcJsonVerifiableCredentialRequest;
    _.JSJwtVcJsonLdVerifiableCredentialRequest = JSJwtVcJsonLdVerifiableCredentialRequest;
    _.JSLdpVerifiableCredentialRequest = JSLdpVerifiableCredentialRequest;
    _.JSDeferredJsonCredentialResponse = JSDeferredJsonCredentialResponse;
    _.JSJwtVcJsonVerifiableCredentialResponse = JSJwtVcJsonVerifiableCredentialResponse;
    _.JSLdpVerifiableCredentialResponse = JSLdpVerifiableCredentialResponse;
    _.JSJwtVcJsonLdVerifiableCredentialResponse = JSJwtVcJsonLdVerifiableCredentialResponse;
    _.JsServerMetadata = JsServerMetadata;
    _.JsDisplayableAdapter = JsDisplayableAdapter;
    _.JsIssuerDisplayAdapter = JsIssuerDisplayAdapter;
    _.JsCredentialDisplayAdapter = JsCredentialDisplayAdapter;
    _.JsLogo = JsLogo;
    _.JsCredentialDisplay = JsCredentialDisplay;
    _.JsCredentialIssuerSupportedCredential = JsCredentialIssuerSupportedCredential;
    _.JsCredentialStatus = JsCredentialStatus;
    _.JsSdObject = JsSdObject;
    _.JsSdArray = JsSdArray;
    _.JsSdPrimitive = JsSdPrimitive;
    _.JsSdProperty = JsSdProperty;
    _.JsSdArrayValue = JsSdArrayValue;
    _.JsCredentialIssuer = JsCredentialIssuer;
    _.JsUserVerifiableCredential = JsUserVerifiableCredential;
    _.JsLdpVcJsonLdCredential = JsLdpVcJsonLdCredential;
    _.JSCredentialResponse = JSCredentialResponse;
    _.JsJwtVcJsonLdCredential = JsJwtVcJsonLdCredential;
    _.JsJwtVcJsonCredential = JsJwtVcJsonCredential;
    _.JsDidJwtVcJsonCredential = JsDidJwtVcJsonCredential;
    _.JsSelectivelyDiscloseableClaim = JsSelectivelyDiscloseableClaim;
    _.JsVcSdJwtCredential = JsVcSdJwtCredential;
    _.JSW3CVerifiableCredential = JSW3CVerifiableCredential;
    defineProp(_.JSW3CVerifiableCredential, 'Companion', Companion_getInstance_72);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = JsCredentialIssuer;
  _.$_$.b = JsPair;
  _.$_$.c = convertJwtVcJsonLdRequest;
  _.$_$.d = convertJwtVcJsonLdResponse;
  _.$_$.e = convertJwtVcJsonRequest;
  _.$_$.f = convertJwtVcJsonResponse;
  _.$_$.g = convertLdpVcJsonRequest;
  _.$_$.h = convertLdpVcJsonResponse;
  _.$_$.i = createJSObject;
  _.$_$.j = createJsCredentialIssuerSupportedCredential;
  _.$_$.k = createJsCredentialIssuer;
  _.$_$.l = createJsUserVerifiableCredential;
  _.$_$.m = getRootCause;
  _.$_$.n = inner;
  _.$_$.o = inner_0;
  _.$_$.p = inner_1;
  _.$_$.q = JwtVcJsonAuthorizationDetail_init_$Create$;
  _.$_$.r = VcSdJwtAuthorizationDetail_init_$Create$;
  _.$_$.s = $serializer_getInstance_8;
  _.$_$.t = $serializer_getInstance_6;
  _.$_$.u = $serializer_getInstance_3;
  _.$_$.v = JsonSupportedCredentialSerializer_getInstance;
  _.$_$.w = Companion_instance_54;
  _.$_$.x = Companion_getInstance_9;
  _.$_$.y = $serializer_getInstance_31;
  _.$_$.z = DefaultValidatedVcSdJwtCredentialResponse;
  _.$_$.a1 = DidValidatedJwtVcJsonCredentialResponse;
  _.$_$.b1 = JsonCredentialIssuerMetadata;
  _.$_$.c1 = JsonCredentialIssuer;
  _.$_$.d1 = IssuerObject_0;
  _.$_$.e1 = IssuerURI_0;
  _.$_$.f1 = JsonOAuthMetadata;
  _.$_$.g1 = JsonOffer;
  _.$_$.h1 = JsonProofOfPossession;
  _.$_$.i1 = JwtVcJsonAuthorizationDetail;
  _.$_$.j1 = JwtVcJsonCredentialConfigurationsSupported;
  _.$_$.k1 = Deferred;
  _.$_$.l1 = JwtVcJsonCredentialResponse;
  _.$_$.m1 = JwtVcJsonLdCredentialResponse;
  _.$_$.n1 = JwtVcJsonLdVerifiableCredentialRequest;
  _.$_$.o1 = CredentialDefinition;
  _.$_$.p1 = JwtVcJsonVerifiableCredentialRequest;
  _.$_$.q1 = JwtVcJsonVerifiableCredentialResponse;
  _.$_$.r1 = LdpVcCredentialResponse;
  _.$_$.s1 = LdpVerifiableCredentialRequest;
  _.$_$.t1 = UserVerifiableCredential;
  _.$_$.u1 = VcSdJwtAuthorizationDetail;
  _.$_$.v1 = VcSdJwtCredentialConfigurationsSupported;
  _.$_$.w1 = Deferred_2;
  _.$_$.x1 = VcSdJwtCredentialResponse;
  _.$_$.y1 = VcSdJwtVerifiableCredentialRequest;
  _.$_$.z1 = VcSdJwtVerifiableCredentialResponse;
  _.$_$.a2 = JsonArrayContainsFilter;
  _.$_$.b2 = JsonDescriptorMapObject;
  _.$_$.c2 = JsonPathNested;
  _.$_$.d2 = JsonPresentationDefinition;
  _.$_$.e2 = JsonPresentationSubmission;
  _.$_$.f2 = JsonStringFilter;
  _.$_$.g2 = JsonStringVerifiablePresentation;
  _.$_$.h2 = JsonVerifiablePresentation;
  _.$_$.i2 = JsonVerifierDirectPostAuthorizationResponse;
  _.$_$.j2 = SerializableW3CVerifiablePresentation;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-verifiable-credentials-vc-ks-data.js.map
